// src/generated/quetzal-translations.ts
import { typedEntries } from "@stackframe/stack-shared/dist/utils/objects";
var quetzalKeys = new Map(typedEntries({
  "Account settings": "__stack-auto-translation-0",
  "Account Settings": "__stack-auto-translation-1",
  "Add": "__stack-auto-translation-2",
  "Add an email": "__stack-auto-translation-3",
  "Add new passkey": "__stack-auto-translation-4",
  "Already have an account?": "__stack-auto-translation-5",
  "An unknown error occurred": "__stack-auto-translation-6",
  "Are you sure you want to delete your account? This action is IRREVERSIBLE and will delete ALL associated data.": "__stack-auto-translation-7",
  "Are you sure you want to disable OTP sign-in? You will not be able to sign in with only emails anymore.": "__stack-auto-translation-8",
  "Are you sure you want to disable Passkey sign-in? You will not be able to sign in with your passkey anymore.": "__stack-auto-translation-9",
  "Are you sure you want to leave the team?": "__stack-auto-translation-10",
  "Cancel": "__stack-auto-translation-11",
  "Change the display name of your team": "__stack-auto-translation-12",
  "click here": "__stack-auto-translation-13",
  "Create": "__stack-auto-translation-14",
  "Create a new account": "__stack-auto-translation-15",
  "Create a team": "__stack-auto-translation-16",
  "Create a Team": "__stack-auto-translation-17",
  "Current team": "__stack-auto-translation-18",
  "Danger zone": "__stack-auto-translation-19",
  "Delete account": "__stack-auto-translation-20",
  "Delete Account": "__stack-auto-translation-21",
  "Delete Passkey": "__stack-auto-translation-22",
  "Disable": "__stack-auto-translation-23",
  "Disable MFA": "__stack-auto-translation-24",
  "Disable OTP": "__stack-auto-translation-25",
  "Display name": "__stack-auto-translation-26",
  "Do you want to sign in?": "__stack-auto-translation-27",
  "Do you want to verify your email?": "__stack-auto-translation-28",
  "Don't have an account?": "__stack-auto-translation-29",
  "Don't need to reset?": "__stack-auto-translation-30",
  "Email": "__stack-auto-translation-31",
  "Email & Password": "__stack-auto-translation-32",
  "Email already exists": "__stack-auto-translation-33",
  "Email is required": "__stack-auto-translation-34",
  "Email sent!": "__stack-auto-translation-35",
  "Emails": "__stack-auto-translation-36",
  "Emails & Auth": "__stack-auto-translation-37",
  "Enable MFA": "__stack-auto-translation-38",
  "Enable OTP": "__stack-auto-translation-39",
  "Enable sign-in via magic link or OTP sent to your sign-in emails.": "__stack-auto-translation-40",
  "End your current session": "__stack-auto-translation-41",
  "Enter a display name for your new team": "__stack-auto-translation-42",
  "Enter email": "__stack-auto-translation-43",
  "Enter the code from your email": "__stack-auto-translation-44",
  "Expired Magic Link": "__stack-auto-translation-45",
  "Expired Password Reset Link": "__stack-auto-translation-46",
  "Expired Team Invitation Link": "__stack-auto-translation-47",
  "Expired Verification Link": "__stack-auto-translation-48",
  "Expires": "__stack-auto-translation-49",
  "Failed to connect account": "__stack-auto-translation-50",
  "Failed to reset password": "__stack-auto-translation-51",
  "Failed to reset password. Please request a new password reset link": "__stack-auto-translation-52",
  "Forgot password?": "__stack-auto-translation-53",
  "Go home": "__stack-auto-translation-54",
  "Go Home": "__stack-auto-translation-55",
  "If the user with this e-mail address exists, an e-mail was sent to your inbox. Make sure to check your spam folder.": "__stack-auto-translation-56",
  "If you are not redirected automatically, ": "__stack-auto-translation-57",
  "Ignore": "__stack-auto-translation-58",
  "Incorrect code. Please try again.": "__stack-auto-translation-59",
  "Incorrect password": "__stack-auto-translation-60",
  "Invalid code": "__stack-auto-translation-61",
  "Invalid image": "__stack-auto-translation-62",
  "Invalid Magic Link": "__stack-auto-translation-63",
  "Invalid Password Reset Link": "__stack-auto-translation-64",
  "Invalid Team Invitation Link": "__stack-auto-translation-65",
  "Invalid TOTP code": "__stack-auto-translation-66",
  "Invalid Verification Link": "__stack-auto-translation-67",
  "Invite a user to your team through email": "__stack-auto-translation-68",
  "Invite member": "__stack-auto-translation-69",
  "Invite User": "__stack-auto-translation-70",
  "Join": "__stack-auto-translation-71",
  "Leave": "__stack-auto-translation-72",
  "Leave team": "__stack-auto-translation-73",
  "Leave Team": "__stack-auto-translation-74",
  "leave this team and remove your team profile": "__stack-auto-translation-75",
  "Magic Link Already Used": "__stack-auto-translation-76",
  "Members": "__stack-auto-translation-77",
  "Multi-factor authentication": "__stack-auto-translation-78",
  "Multi-factor authentication is currently disabled.": "__stack-auto-translation-79",
  "Multi-factor authentication is currently enabled.": "__stack-auto-translation-80",
  "My Profile": "__stack-auto-translation-81",
  "Name": "__stack-auto-translation-82",
  "New account registration is not allowed": "__stack-auto-translation-83",
  "New password": "__stack-auto-translation-84",
  "New Password": "__stack-auto-translation-85",
  "No authentication method enabled.": "__stack-auto-translation-86",
  "No teams yet": "__stack-auto-translation-87",
  "Not signed in": "__stack-auto-translation-88",
  "OAuth provider access denied": "__stack-auto-translation-89",
  "Old password": "__stack-auto-translation-90",
  "Or continue with": "__stack-auto-translation-91",
  "Other teams": "__stack-auto-translation-92",
  "OTP sign-in": "__stack-auto-translation-93",
  "OTP sign-in is enabled and cannot be disabled as it is currently the only sign-in method": "__stack-auto-translation-94",
  "OTP/magic link sign-in is currently enabled.": "__stack-auto-translation-95",
  "Outstanding invitations": "__stack-auto-translation-96",
  "Overwrite your user display name in this team": "__stack-auto-translation-97",
  "Passkey": "__stack-auto-translation-98",
  "Passkey registered": "__stack-auto-translation-99",
  "Passkey sign-in is enabled and cannot be disabled as it is currently the only sign-in method": "__stack-auto-translation-100",
  "Password": "__stack-auto-translation-101",
  "Password reset successfully!": "__stack-auto-translation-102",
  "Passwords do not match": "__stack-auto-translation-103",
  "Permanently remove your account and all associated data": "__stack-auto-translation-104",
  "Please check if you have the correct link. If you continue to have issues, please contact support.": "__stack-auto-translation-105",
  "Please double check if you have the correct password reset link.": "__stack-auto-translation-106",
  "Please double check if you have the correct team invitation link.": "__stack-auto-translation-107",
  "Please enter a team name": "__stack-auto-translation-108",
  "Please enter a valid email": "__stack-auto-translation-109",
  "Please enter a valid email address": "__stack-auto-translation-110",
  "Please enter an email address": "__stack-auto-translation-111",
  "Please enter your email": "__stack-auto-translation-112",
  "Please enter your old password": "__stack-auto-translation-113",
  "Please enter your password": "__stack-auto-translation-114",
  "Please repeat your password": "__stack-auto-translation-115",
  "Please try again and if the problem persists, contact support.": "__stack-auto-translation-116",
  "Please verify your email first": "__stack-auto-translation-117",
  "Primary": "__stack-auto-translation-118",
  "Profile image": "__stack-auto-translation-119",
  "Register a passkey": "__stack-auto-translation-120",
  "Remove": "__stack-auto-translation-121",
  "Repeat new password": "__stack-auto-translation-122",
  "Repeat New Password": "__stack-auto-translation-123",
  "Repeat Password": "__stack-auto-translation-124",
  "Reset Password": "__stack-auto-translation-125",
  "Reset Your Password": "__stack-auto-translation-126",
  "Save": "__stack-auto-translation-127",
  "Scan this QR code with your authenticator app:": "__stack-auto-translation-128",
  "Send email": "__stack-auto-translation-129",
  "Send Email": "__stack-auto-translation-130",
  "Send verification email": "__stack-auto-translation-131",
  "Set a password for your account": "__stack-auto-translation-132",
  "Set as primary": "__stack-auto-translation-133",
  "Set password": "__stack-auto-translation-134",
  "Set Password": "__stack-auto-translation-135",
  "Settings": "__stack-auto-translation-136",
  "Sign in": "__stack-auto-translation-137",
  "Sign In": "__stack-auto-translation-138",
  "Sign in again": "__stack-auto-translation-139",
  "Sign in or create an account to join the team.": "__stack-auto-translation-140",
  "Sign in to your account": "__stack-auto-translation-141",
  "Sign in with Passkey": "__stack-auto-translation-142",
  "Sign in with {provider}": "__stack-auto-translation-143",
  "Sign out": "__stack-auto-translation-144",
  "Sign up": "__stack-auto-translation-145",
  "Sign Up": "__stack-auto-translation-146",
  "Sign up for new users is not enabled at the moment.": "__stack-auto-translation-147",
  "Sign up with Passkey": "__stack-auto-translation-148",
  "Sign up with {provider}": "__stack-auto-translation-149",
  "Signed in successfully!": "__stack-auto-translation-150",
  "Something went wrong while processing the OAuth callback:": "__stack-auto-translation-151",
  "Stop using for sign-in": "__stack-auto-translation-152",
  "Team creation is not enabled": "__stack-auto-translation-153",
  "Team display name": "__stack-auto-translation-154",
  "Team invitation": "__stack-auto-translation-155",
  "Team profile image": "__stack-auto-translation-156",
  "Team user name": "__stack-auto-translation-157",
  "Teams": "__stack-auto-translation-158",
  "The magic link has already been used. The link can only be used once. Please request a new magic link if you need to sign-in again.": "__stack-auto-translation-159",
  "The sign-in operation has been cancelled. Please try again. [access_denied]": "__stack-auto-translation-160",
  "The user is already connected to another OAuth account. Did you maybe selected the wrong account on the OAuth provider page?": "__stack-auto-translation-161",
  "Then, enter your six-digit MFA code:": "__stack-auto-translation-162",
  "This account is already connected to another user. Please connect a different account.": "__stack-auto-translation-163",
  "This email is already used for sign-in by another user.": "__stack-auto-translation-164",
  "This is a display name and is not used for authentication": "__stack-auto-translation-165",
  "This is most likely an error in Stack. Please report it.": "__stack-auto-translation-166",
  "This password reset link has already been used. If you need to reset your password again, please request a new password reset link from the login page.": "__stack-auto-translation-167",
  "This team invitation link has already been used.": "__stack-auto-translation-168",
  "To enable OTP sign-in, please add a verified sign-in email.": "__stack-auto-translation-169",
  "To enable Passkey sign-in, please add a verified sign-in email.": "__stack-auto-translation-170",
  "To set a password, please add a sign-in email.": "__stack-auto-translation-171",
  "Toggle theme": "__stack-auto-translation-172",
  "TOTP multi-factor authentication QR code": "__stack-auto-translation-173",
  "Unverified": "__stack-auto-translation-174",
  "Update password": "__stack-auto-translation-175",
  "Update Password": "__stack-auto-translation-176",
  "Update your password": "__stack-auto-translation-177",
  "Upload an image for your team": "__stack-auto-translation-178",
  "Upload your own image as your avatar": "__stack-auto-translation-179",
  "Use for sign-in": "__stack-auto-translation-180",
  "Used for sign-in": "__stack-auto-translation-181",
  "Used Password Reset Link": "__stack-auto-translation-182",
  "Used Team Invitation Link": "__stack-auto-translation-183",
  "User": "__stack-auto-translation-184",
  "User name": "__stack-auto-translation-185",
  "Verify": "__stack-auto-translation-186",
  "You are already signed in": "__stack-auto-translation-187",
  "You are not currently signed in.": "__stack-auto-translation-188",
  "You can not remove your last sign-in email": "__stack-auto-translation-189",
  "You email has been verified!": "__stack-auto-translation-190",
  "Your Email": "__stack-auto-translation-191",
  "Your email verification link has expired. Please request a new verification link from your account settings.": "__stack-auto-translation-192",
  "Your magic link has expired. Please request a new magic link if you need to sign-in.": "__stack-auto-translation-193",
  "Your password has been reset. You can now sign in with your new password.": "__stack-auto-translation-194",
  "Your password reset link has expired. Please request a new password reset link from the login page.": "__stack-auto-translation-195",
  "Your team invitation link has expired. Please request a new team invitation link ": "__stack-auto-translation-196"
}));
var quetzalLocales = new Map(typedEntries({
  "de-DE": new Map(typedEntries({
    "__stack-auto-translation-0": "Kontoeinstellungen",
    "__stack-auto-translation-1": "Kontoeinstellungen",
    "__stack-auto-translation-10": "Sind Sie sicher, dass Sie das Team verlassen m\xF6chten?",
    "__stack-auto-translation-100": "Passkey-Anmeldung ist aktiviert und kann nicht deaktiviert werden, da es derzeit die einzige Anmeldemethode ist",
    "__stack-auto-translation-101": "Passwort",
    "__stack-auto-translation-102": "Passwort erfolgreich zur\xFCckgesetzt!",
    "__stack-auto-translation-103": "Passw\xF6rter stimmen nicht \xFCberein",
    "__stack-auto-translation-104": "L\xF6schen Sie Ihr Konto und alle zugeh\xF6rigen Daten dauerhaft",
    "__stack-auto-translation-105": "Bitte \xFCberpr\xFCfen Sie, ob Sie den richtigen Link haben. Wenn weiterhin Probleme auftreten, kontaktieren Sie bitte den Support.",
    "__stack-auto-translation-106": "Bitte \xFCberpr\xFCfen Sie, ob Sie den richtigen Link zum Zur\xFCcksetzen des Passworts haben.",
    "__stack-auto-translation-107": "Bitte \xFCberpr\xFCfen Sie, ob Sie den korrekten Team-Einladungslink haben.",
    "__stack-auto-translation-108": "Bitte geben Sie einen Teamnamen ein",
    "__stack-auto-translation-109": "Bitte geben Sie eine g\xFCltige E-Mail-Adresse ein",
    "__stack-auto-translation-11": "Abbrechen",
    "__stack-auto-translation-110": "Bitte geben Sie eine g\xFCltige E-Mail-Adresse ein",
    "__stack-auto-translation-111": "Bitte geben Sie eine E-Mail-Adresse ein",
    "__stack-auto-translation-112": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "__stack-auto-translation-113": "Bitte geben Sie Ihr altes Passwort ein",
    "__stack-auto-translation-114": "Bitte geben Sie Ihr Passwort ein",
    "__stack-auto-translation-115": "Bitte wiederholen Sie Ihr Passwort",
    "__stack-auto-translation-116": "Bitte versuchen Sie es erneut und kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
    "__stack-auto-translation-117": "Bitte verifizieren Sie zuerst Ihre E-Mail-Adresse",
    "__stack-auto-translation-118": "Prim\xE4r",
    "__stack-auto-translation-119": "Profilbild",
    "__stack-auto-translation-12": "\xC4ndern Sie den Anzeigenamen Ihres Teams",
    "__stack-auto-translation-120": "Passkey registrieren",
    "__stack-auto-translation-121": "Entfernen",
    "__stack-auto-translation-122": "Neues Passwort wiederholen",
    "__stack-auto-translation-123": "Neues Passwort wiederholen",
    "__stack-auto-translation-124": "Passwort wiederholen",
    "__stack-auto-translation-125": "Passwort zur\xFCcksetzen",
    "__stack-auto-translation-126": "Passwort zur\xFCcksetzen",
    "__stack-auto-translation-127": "Speichern",
    "__stack-auto-translation-128": "Scannen Sie diesen QR-Code mit Ihrer Authentifizierungs-App:",
    "__stack-auto-translation-129": "E-Mail senden",
    "__stack-auto-translation-13": "hier klicken",
    "__stack-auto-translation-130": "E-Mail senden",
    "__stack-auto-translation-131": "E-Mail-Verifizierung senden",
    "__stack-auto-translation-132": "Legen Sie ein Passwort f\xFCr Ihr Konto fest",
    "__stack-auto-translation-133": "Als Prim\xE4r festlegen",
    "__stack-auto-translation-134": "Passwort festlegen",
    "__stack-auto-translation-135": "Passwort festlegen",
    "__stack-auto-translation-136": "Einstellungen",
    "__stack-auto-translation-137": "Anmelden",
    "__stack-auto-translation-138": "Anmelden",
    "__stack-auto-translation-139": "Erneut anmelden",
    "__stack-auto-translation-14": "Erstellen",
    "__stack-auto-translation-140": "Melden Sie sich an oder erstellen Sie ein Konto, um dem Team beizutreten.",
    "__stack-auto-translation-141": "Melden Sie sich in Ihrem Konto an",
    "__stack-auto-translation-142": "Mit Passkey anmelden",
    "__stack-auto-translation-143": "Mit {provider} anmelden",
    "__stack-auto-translation-144": "Abmelden",
    "__stack-auto-translation-145": "Registrieren",
    "__stack-auto-translation-146": "Registrieren",
    "__stack-auto-translation-147": "Die Registrierung f\xFCr neue Benutzer ist derzeit nicht aktiviert.",
    "__stack-auto-translation-148": "Mit Passkey registrieren",
    "__stack-auto-translation-149": "Mit {provider} registrieren",
    "__stack-auto-translation-15": "Ein neues Konto erstellen",
    "__stack-auto-translation-150": "Erfolgreich angemeldet!",
    "__stack-auto-translation-151": "Bei der Verarbeitung des OAuth-Callbacks ist etwas schiefgelaufen:",
    "__stack-auto-translation-152": "Nicht mehr zur Anmeldung verwenden",
    "__stack-auto-translation-153": "Teamerstellung ist nicht aktiviert",
    "__stack-auto-translation-154": "Team-Anzeigename",
    "__stack-auto-translation-155": "Teameinladung",
    "__stack-auto-translation-156": "Teamprofilbild",
    "__stack-auto-translation-157": "Teamnutzername",
    "__stack-auto-translation-158": "Teams",
    "__stack-auto-translation-159": "Der Magic-Link wurde bereits verwendet. Der Link kann nur einmal benutzt werden. Bitte fordern Sie einen neuen Magic-Link an, wenn Sie sich erneut anmelden m\xFCssen.",
    "__stack-auto-translation-16": "Erstellen Sie ein Team",
    "__stack-auto-translation-160": "Der Anmeldevorgang wurde abgebrochen. Bitte versuchen Sie es erneut. [access_denied]",
    "__stack-auto-translation-161": "Der Benutzer ist bereits mit einem anderen OAuth-Konto verbunden. Haben Sie m\xF6glicherweise das falsche Konto auf der Seite des OAuth-Anbieters ausgew\xE4hlt?",
    "__stack-auto-translation-162": "Geben Sie dann Ihren sechsstelligen MFA-Code ein:",
    "__stack-auto-translation-163": "Dieses Konto ist bereits mit einem anderen Benutzer verbunden. Bitte verbinden Sie ein anderes Konto.",
    "__stack-auto-translation-164": "Diese E-Mail wird bereits von einem anderen Benutzer f\xFCr die Anmeldung verwendet.",
    "__stack-auto-translation-165": "Dies ist ein Anzeigename und wird nicht f\xFCr die Authentifizierung verwendet",
    "__stack-auto-translation-166": "Dies ist h\xF6chstwahrscheinlich ein Fehler in Stack. Bitte melden Sie ihn.",
    "__stack-auto-translation-167": "Dieser Link zum Zur\xFCcksetzen des Passworts wurde bereits verwendet. Falls Sie Ihr Passwort erneut zur\xFCcksetzen m\xFCssen, fordern Sie bitte einen neuen Link zum Zur\xFCcksetzen des Passworts auf der Anmeldeseite an.",
    "__stack-auto-translation-168": "Dieser Teameinladungslink wurde bereits verwendet.",
    "__stack-auto-translation-169": "Um die OTP-Anmeldung zu aktivieren, f\xFCgen Sie bitte eine verifizierte Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-17": "Ein Team erstellen",
    "__stack-auto-translation-170": "Um die Passkey-Anmeldung zu aktivieren, f\xFCgen Sie bitte eine verifizierte Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-171": "Um ein Passwort festzulegen, f\xFCgen Sie bitte eine Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-172": "Theme umschalten",
    "__stack-auto-translation-173": "TOTP-Mehrfaktor-Authentifizierungs-QR-Code",
    "__stack-auto-translation-174": "Nicht verifiziert",
    "__stack-auto-translation-175": "Passwort aktualisieren",
    "__stack-auto-translation-176": "Passwort aktualisieren",
    "__stack-auto-translation-177": "Aktualisieren Sie Ihr Passwort",
    "__stack-auto-translation-178": "Laden Sie ein Bild f\xFCr Ihr Team hoch",
    "__stack-auto-translation-179": "Laden Sie Ihr eigenes Bild als Avatar hoch",
    "__stack-auto-translation-18": "Aktuelles Team",
    "__stack-auto-translation-180": "F\xFCr die Anmeldung verwenden",
    "__stack-auto-translation-181": "F\xFCr die Anmeldung verwendet",
    "__stack-auto-translation-182": "Verwendeter Link zum Zur\xFCcksetzen des Passworts",
    "__stack-auto-translation-183": "Verwendeter Team-Einladungslink",
    "__stack-auto-translation-184": "Benutzer",
    "__stack-auto-translation-185": "Benutzername",
    "__stack-auto-translation-186": "Best\xE4tigen",
    "__stack-auto-translation-187": "Sie sind bereits angemeldet",
    "__stack-auto-translation-188": "Sie sind derzeit nicht angemeldet.",
    "__stack-auto-translation-189": "Sie k\xF6nnen Ihre letzte Anmelde-E-Mail nicht entfernen",
    "__stack-auto-translation-19": "Gefahrenzone",
    "__stack-auto-translation-190": "Ihre E-Mail wurde verifiziert!",
    "__stack-auto-translation-191": "Ihre E-Mail-Adresse",
    "__stack-auto-translation-192": "Ihr E-Mail-Best\xE4tigungslink ist abgelaufen. Bitte fordern Sie in Ihren Kontoeinstellungen einen neuen Best\xE4tigungslink an.",
    "__stack-auto-translation-193": "Ihr Magic Link ist abgelaufen. Bitte fordern Sie einen neuen Magic Link an, wenn Sie sich anmelden m\xFCssen.",
    "__stack-auto-translation-194": "Ihr Passwort wurde zur\xFCckgesetzt. Sie k\xF6nnen sich jetzt mit Ihrem neuen Passwort anmelden.",
    "__stack-auto-translation-195": "Ihr Link zum Zur\xFCcksetzen des Passworts ist abgelaufen. Bitte fordern Sie einen neuen Link zum Zur\xFCcksetzen des Passworts von der Anmeldeseite an.",
    "__stack-auto-translation-196": "Ihr Team-Einladungslink ist abgelaufen. Bitte fordern Sie einen neuen Team-Einladungslink an ",
    "__stack-auto-translation-2": "Hinzuf\xFCgen",
    "__stack-auto-translation-20": "Konto l\xF6schen",
    "__stack-auto-translation-21": "Konto l\xF6schen",
    "__stack-auto-translation-22": "Passkey l\xF6schen",
    "__stack-auto-translation-23": "Deaktivieren",
    "__stack-auto-translation-24": "MFA deaktivieren",
    "__stack-auto-translation-25": "OTP deaktivieren",
    "__stack-auto-translation-26": "Anzeigename",
    "__stack-auto-translation-27": "M\xF6chten Sie sich anmelden?",
    "__stack-auto-translation-28": "M\xF6chten Sie Ihre E-Mail-Adresse best\xE4tigen?",
    "__stack-auto-translation-29": "Noch kein Konto?",
    "__stack-auto-translation-3": "Eine E-Mail-Adresse hinzuf\xFCgen",
    "__stack-auto-translation-30": "Kein Zur\xFCcksetzen n\xF6tig?",
    "__stack-auto-translation-31": "E-Mail",
    "__stack-auto-translation-32": "E-Mail & Passwort",
    "__stack-auto-translation-33": "E-Mail existiert bereits",
    "__stack-auto-translation-34": "E-Mail ist erforderlich",
    "__stack-auto-translation-35": "E-Mail gesendet!",
    "__stack-auto-translation-36": "E-Mails",
    "__stack-auto-translation-37": "E-Mails & Authentifizierung",
    "__stack-auto-translation-38": "MFA aktivieren",
    "__stack-auto-translation-39": "OTP aktivieren",
    "__stack-auto-translation-4": "Neue Passkey hinzuf\xFCgen",
    "__stack-auto-translation-40": "Aktivieren Sie die Anmeldung \xFCber einen magischen Link oder OTP, die an Ihre Anmelde-E-Mails gesendet werden.",
    "__stack-auto-translation-41": "Beenden Sie Ihre aktuelle Sitzung",
    "__stack-auto-translation-42": "Geben Sie einen Anzeigenamen f\xFCr Ihr neues Team ein",
    "__stack-auto-translation-43": "E-Mail-Adresse eingeben",
    "__stack-auto-translation-44": "Geben Sie den Code aus Ihrer E-Mail ein",
    "__stack-auto-translation-45": "Abgelaufener Magic Link",
    "__stack-auto-translation-46": "Abgelaufener Link zum Zur\xFCcksetzen des Passworts",
    "__stack-auto-translation-47": "Abgelaufener Team-Einladungslink",
    "__stack-auto-translation-48": "Abgelaufener Verifizierungslink",
    "__stack-auto-translation-49": "L\xE4uft ab",
    "__stack-auto-translation-5": "Haben Sie bereits ein Konto?",
    "__stack-auto-translation-50": "Verbindung des Kontos fehlgeschlagen",
    "__stack-auto-translation-51": "Passwort konnte nicht zur\xFCckgesetzt werden",
    "__stack-auto-translation-52": "Passwort konnte nicht zur\xFCckgesetzt werden. Bitte fordern Sie einen neuen Link zum Zur\xFCcksetzen des Passworts an",
    "__stack-auto-translation-53": "Passwort vergessen?",
    "__stack-auto-translation-54": "Zur Startseite",
    "__stack-auto-translation-55": "Zur Startseite",
    "__stack-auto-translation-56": "Wenn der Benutzer mit dieser E-Mail-Adresse existiert, wurde eine E-Mail an Ihren Posteingang gesendet. \xDCberpr\xFCfen Sie auch Ihren Spam-Ordner.",
    "__stack-auto-translation-57": "Wenn Sie nicht automatisch weitergeleitet werden, ",
    "__stack-auto-translation-58": "Ignorieren",
    "__stack-auto-translation-59": "Falscher Code. Bitte versuchen Sie es erneut.",
    "__stack-auto-translation-6": "Ein unbekannter Fehler ist aufgetreten",
    "__stack-auto-translation-60": "Falsches Passwort",
    "__stack-auto-translation-61": "Ung\xFCltiger Code",
    "__stack-auto-translation-62": "Ung\xFCltiges Bild",
    "__stack-auto-translation-63": "Ung\xFCltiger Magic Link",
    "__stack-auto-translation-64": "Ung\xFCltiger Link zum Zur\xFCcksetzen des Passworts",
    "__stack-auto-translation-65": "Ung\xFCltiger Team-Einladungslink",
    "__stack-auto-translation-66": "Ung\xFCltiger TOTP-Code",
    "__stack-auto-translation-67": "Ung\xFCltiger Verifizierungslink",
    "__stack-auto-translation-68": "Laden Sie einen Benutzer per E-Mail in Ihr Team ein",
    "__stack-auto-translation-69": "Mitglied einladen",
    "__stack-auto-translation-7": "Sind Sie sicher, dass Sie Ihr Konto l\xF6schen m\xF6chten? Diese Aktion ist UNWIDERRUFLICH und l\xF6scht ALLE zugeh\xF6rigen Daten.",
    "__stack-auto-translation-70": "Benutzer einladen",
    "__stack-auto-translation-71": "Beitreten",
    "__stack-auto-translation-72": "Verlassen",
    "__stack-auto-translation-73": "Team verlassen",
    "__stack-auto-translation-74": "Team verlassen",
    "__stack-auto-translation-75": "dieses Team verlassen und Ihr Teamprofil entfernen",
    "__stack-auto-translation-76": "Bereits verwendeter Magic-Link",
    "__stack-auto-translation-77": "Mitglieder",
    "__stack-auto-translation-78": "Mehr-Faktor-Authentifizierung",
    "__stack-auto-translation-79": "Zwei-Faktor-Authentifizierung ist derzeit deaktiviert.",
    "__stack-auto-translation-8": "Sind Sie sicher, dass Sie die OTP-Anmeldung deaktivieren m\xF6chten? Sie k\xF6nnen sich dann nicht mehr nur mit E-Mails anmelden.",
    "__stack-auto-translation-80": "Mehrfaktor-Authentifizierung ist derzeit aktiviert.",
    "__stack-auto-translation-81": "Mein Profil",
    "__stack-auto-translation-82": "Name",
    "__stack-auto-translation-83": "Neue Kontoregistrierung ist nicht erlaubt",
    "__stack-auto-translation-84": "Neues Passwort",
    "__stack-auto-translation-85": "Neues Passwort",
    "__stack-auto-translation-86": "Keine Authentifizierungsmethode aktiviert.",
    "__stack-auto-translation-87": "Noch keine Teams",
    "__stack-auto-translation-88": "Nicht angemeldet",
    "__stack-auto-translation-89": "OAuth-Anbieter-Zugriff verweigert",
    "__stack-auto-translation-9": "M\xF6chten Sie die Passkey-Anmeldung wirklich deaktivieren? Sie k\xF6nnen sich dann nicht mehr mit Ihrem Passkey anmelden.",
    "__stack-auto-translation-90": "Altes Passwort",
    "__stack-auto-translation-91": "Oder fortfahren mit",
    "__stack-auto-translation-92": "Andere Teams",
    "__stack-auto-translation-93": "OTP-Anmeldung",
    "__stack-auto-translation-94": "OTP-Anmeldung ist aktiviert und kann nicht deaktiviert werden, da es derzeit die einzige Anmeldemethode ist",
    "__stack-auto-translation-95": "Die Anmeldung per OTP/magischem Link ist derzeit aktiviert.",
    "__stack-auto-translation-96": "Ausstehende Einladungen",
    "__stack-auto-translation-97": "\xDCberschreiben Sie Ihren Benutzeranzeigenamen in diesem Team",
    "__stack-auto-translation-98": "Passkey",
    "__stack-auto-translation-99": "Passkey registriert"
  })),
  "en-US": new Map(typedEntries({
    "__stack-auto-translation-0": "Account settings",
    "__stack-auto-translation-1": "Account Settings",
    "__stack-auto-translation-10": "Are you sure you want to leave the team?",
    "__stack-auto-translation-100": "Passkey sign-in is enabled and cannot be disabled as it is currently the only sign-in method",
    "__stack-auto-translation-101": "Password",
    "__stack-auto-translation-102": "Password reset successfully!",
    "__stack-auto-translation-103": "Passwords do not match",
    "__stack-auto-translation-104": "Permanently remove your account and all associated data",
    "__stack-auto-translation-105": "Please check if you have the correct link. If you continue to have issues, please contact support.",
    "__stack-auto-translation-106": "Please double check if you have the correct password reset link.",
    "__stack-auto-translation-107": "Please double check if you have the correct team invitation link.",
    "__stack-auto-translation-108": "Please enter a team name",
    "__stack-auto-translation-109": "Please enter a valid email",
    "__stack-auto-translation-11": "Cancel",
    "__stack-auto-translation-110": "Please enter a valid email address",
    "__stack-auto-translation-111": "Please enter an email address",
    "__stack-auto-translation-112": "Please enter your email",
    "__stack-auto-translation-113": "Please enter your old password",
    "__stack-auto-translation-114": "Please enter your password",
    "__stack-auto-translation-115": "Please repeat your password",
    "__stack-auto-translation-116": "Please try again and if the problem persists, contact support.",
    "__stack-auto-translation-117": "Please verify your email first",
    "__stack-auto-translation-118": "Primary",
    "__stack-auto-translation-119": "Profile image",
    "__stack-auto-translation-12": "Change the display name of your team",
    "__stack-auto-translation-120": "Register a passkey",
    "__stack-auto-translation-121": "Remove",
    "__stack-auto-translation-122": "Repeat new password",
    "__stack-auto-translation-123": "Repeat New Password",
    "__stack-auto-translation-124": "Repeat Password",
    "__stack-auto-translation-125": "Reset Password",
    "__stack-auto-translation-126": "Reset Your Password",
    "__stack-auto-translation-127": "Save",
    "__stack-auto-translation-128": "Scan this QR code with your authenticator app:",
    "__stack-auto-translation-129": "Send email",
    "__stack-auto-translation-13": "click here",
    "__stack-auto-translation-130": "Send Email",
    "__stack-auto-translation-131": "Send verification email",
    "__stack-auto-translation-132": "Set a password for your account",
    "__stack-auto-translation-133": "Set as primary",
    "__stack-auto-translation-134": "Set password",
    "__stack-auto-translation-135": "Set Password",
    "__stack-auto-translation-136": "Settings",
    "__stack-auto-translation-137": "Sign in",
    "__stack-auto-translation-138": "Sign In",
    "__stack-auto-translation-139": "Sign in again",
    "__stack-auto-translation-14": "Create",
    "__stack-auto-translation-140": "Sign in or create an account to join the team.",
    "__stack-auto-translation-141": "Sign in to your account",
    "__stack-auto-translation-142": "Sign in with Passkey",
    "__stack-auto-translation-143": "Sign in with {provider}",
    "__stack-auto-translation-144": "Sign out",
    "__stack-auto-translation-145": "Sign up",
    "__stack-auto-translation-146": "Sign Up",
    "__stack-auto-translation-147": "Sign up for new users is not enabled at the moment.",
    "__stack-auto-translation-148": "Sign up with Passkey",
    "__stack-auto-translation-149": "Sign up with {provider}",
    "__stack-auto-translation-15": "Create a new account",
    "__stack-auto-translation-150": "Signed in successfully!",
    "__stack-auto-translation-151": "Something went wrong while processing the OAuth callback:",
    "__stack-auto-translation-152": "Stop using for sign-in",
    "__stack-auto-translation-153": "Team creation is not enabled",
    "__stack-auto-translation-154": "Team display name",
    "__stack-auto-translation-155": "Team invitation",
    "__stack-auto-translation-156": "Team profile image",
    "__stack-auto-translation-157": "Team user name",
    "__stack-auto-translation-158": "Teams",
    "__stack-auto-translation-159": "The magic link has already been used. The link can only be used once. Please request a new magic link if you need to sign-in again.",
    "__stack-auto-translation-16": "Create a team",
    "__stack-auto-translation-160": "The sign-in operation has been cancelled. Please try again. [access_denied]",
    "__stack-auto-translation-161": "The user is already connected to another OAuth account. Did you maybe selected the wrong account on the OAuth provider page?",
    "__stack-auto-translation-162": "Then, enter your six-digit MFA code:",
    "__stack-auto-translation-163": "This account is already connected to another user. Please connect a different account.",
    "__stack-auto-translation-164": "This email is already used for sign-in by another user.",
    "__stack-auto-translation-165": "This is a display name and is not used for authentication",
    "__stack-auto-translation-166": "This is most likely an error in Stack. Please report it.",
    "__stack-auto-translation-167": "This password reset link has already been used. If you need to reset your password again, please request a new password reset link from the login page.",
    "__stack-auto-translation-168": "This team invitation link has already been used.",
    "__stack-auto-translation-169": "To enable OTP sign-in, please add a verified sign-in email.",
    "__stack-auto-translation-17": "Create a Team",
    "__stack-auto-translation-170": "To enable Passkey sign-in, please add a verified sign-in email.",
    "__stack-auto-translation-171": "To set a password, please add a sign-in email.",
    "__stack-auto-translation-172": "Toggle theme",
    "__stack-auto-translation-173": "TOTP multi-factor authentication QR code",
    "__stack-auto-translation-174": "Unverified",
    "__stack-auto-translation-175": "Update password",
    "__stack-auto-translation-176": "Update Password",
    "__stack-auto-translation-177": "Update your password",
    "__stack-auto-translation-178": "Upload an image for your team",
    "__stack-auto-translation-179": "Upload your own image as your avatar",
    "__stack-auto-translation-18": "Current team",
    "__stack-auto-translation-180": "Use for sign-in",
    "__stack-auto-translation-181": "Used for sign-in",
    "__stack-auto-translation-182": "Used Password Reset Link",
    "__stack-auto-translation-183": "Used Team Invitation Link",
    "__stack-auto-translation-184": "User",
    "__stack-auto-translation-185": "User name",
    "__stack-auto-translation-186": "Verify",
    "__stack-auto-translation-187": "You are already signed in",
    "__stack-auto-translation-188": "You are not currently signed in.",
    "__stack-auto-translation-189": "You can not remove your last sign-in email",
    "__stack-auto-translation-19": "Danger zone",
    "__stack-auto-translation-190": "You email has been verified!",
    "__stack-auto-translation-191": "Your Email",
    "__stack-auto-translation-192": "Your email verification link has expired. Please request a new verification link from your account settings.",
    "__stack-auto-translation-193": "Your magic link has expired. Please request a new magic link if you need to sign-in.",
    "__stack-auto-translation-194": "Your password has been reset. You can now sign in with your new password.",
    "__stack-auto-translation-195": "Your password reset link has expired. Please request a new password reset link from the login page.",
    "__stack-auto-translation-196": "Your team invitation link has expired. Please request a new team invitation link ",
    "__stack-auto-translation-2": "Add",
    "__stack-auto-translation-20": "Delete account",
    "__stack-auto-translation-21": "Delete Account",
    "__stack-auto-translation-22": "Delete Passkey",
    "__stack-auto-translation-23": "Disable",
    "__stack-auto-translation-24": "Disable MFA",
    "__stack-auto-translation-25": "Disable OTP",
    "__stack-auto-translation-26": "Display name",
    "__stack-auto-translation-27": "Do you want to sign in?",
    "__stack-auto-translation-28": "Do you want to verify your email?",
    "__stack-auto-translation-29": "Don't have an account?",
    "__stack-auto-translation-3": "Add an email",
    "__stack-auto-translation-30": "Don't need to reset?",
    "__stack-auto-translation-31": "Email",
    "__stack-auto-translation-32": "Email & Password",
    "__stack-auto-translation-33": "Email already exists",
    "__stack-auto-translation-34": "Email is required",
    "__stack-auto-translation-35": "Email sent!",
    "__stack-auto-translation-36": "Emails",
    "__stack-auto-translation-37": "Emails & Auth",
    "__stack-auto-translation-38": "Enable MFA",
    "__stack-auto-translation-39": "Enable OTP",
    "__stack-auto-translation-4": "Add new passkey",
    "__stack-auto-translation-40": "Enable sign-in via magic link or OTP sent to your sign-in emails.",
    "__stack-auto-translation-41": "End your current session",
    "__stack-auto-translation-42": "Enter a display name for your new team",
    "__stack-auto-translation-43": "Enter email",
    "__stack-auto-translation-44": "Enter the code from your email",
    "__stack-auto-translation-45": "Expired Magic Link",
    "__stack-auto-translation-46": "Expired Password Reset Link",
    "__stack-auto-translation-47": "Expired Team Invitation Link",
    "__stack-auto-translation-48": "Expired Verification Link",
    "__stack-auto-translation-49": "Expires",
    "__stack-auto-translation-5": "Already have an account?",
    "__stack-auto-translation-50": "Failed to connect account",
    "__stack-auto-translation-51": "Failed to reset password",
    "__stack-auto-translation-52": "Failed to reset password. Please request a new password reset link",
    "__stack-auto-translation-53": "Forgot password?",
    "__stack-auto-translation-54": "Go home",
    "__stack-auto-translation-55": "Go Home",
    "__stack-auto-translation-56": "If the user with this e-mail address exists, an e-mail was sent to your inbox. Make sure to check your spam folder.",
    "__stack-auto-translation-57": "If you are not redirected automatically, ",
    "__stack-auto-translation-58": "Ignore",
    "__stack-auto-translation-59": "Incorrect code. Please try again.",
    "__stack-auto-translation-6": "An unknown error occurred",
    "__stack-auto-translation-60": "Incorrect password",
    "__stack-auto-translation-61": "Invalid code",
    "__stack-auto-translation-62": "Invalid image",
    "__stack-auto-translation-63": "Invalid Magic Link",
    "__stack-auto-translation-64": "Invalid Password Reset Link",
    "__stack-auto-translation-65": "Invalid Team Invitation Link",
    "__stack-auto-translation-66": "Invalid TOTP code",
    "__stack-auto-translation-67": "Invalid Verification Link",
    "__stack-auto-translation-68": "Invite a user to your team through email",
    "__stack-auto-translation-69": "Invite member",
    "__stack-auto-translation-7": "Are you sure you want to delete your account? This action is IRREVERSIBLE and will delete ALL associated data.",
    "__stack-auto-translation-70": "Invite User",
    "__stack-auto-translation-71": "Join",
    "__stack-auto-translation-72": "Leave",
    "__stack-auto-translation-73": "Leave team",
    "__stack-auto-translation-74": "Leave Team",
    "__stack-auto-translation-75": "leave this team and remove your team profile",
    "__stack-auto-translation-76": "Magic Link Already Used",
    "__stack-auto-translation-77": "Members",
    "__stack-auto-translation-78": "Multi-factor authentication",
    "__stack-auto-translation-79": "Multi-factor authentication is currently disabled.",
    "__stack-auto-translation-8": "Are you sure you want to disable OTP sign-in? You will not be able to sign in with only emails anymore.",
    "__stack-auto-translation-80": "Multi-factor authentication is currently enabled.",
    "__stack-auto-translation-81": "My Profile",
    "__stack-auto-translation-82": "Name",
    "__stack-auto-translation-83": "New account registration is not allowed",
    "__stack-auto-translation-84": "New password",
    "__stack-auto-translation-85": "New Password",
    "__stack-auto-translation-86": "No authentication method enabled.",
    "__stack-auto-translation-87": "No teams yet",
    "__stack-auto-translation-88": "Not signed in",
    "__stack-auto-translation-89": "OAuth provider access denied",
    "__stack-auto-translation-9": "Are you sure you want to disable Passkey sign-in? You will not be able to sign in with your passkey anymore.",
    "__stack-auto-translation-90": "Old password",
    "__stack-auto-translation-91": "Or continue with",
    "__stack-auto-translation-92": "Other teams",
    "__stack-auto-translation-93": "OTP sign-in",
    "__stack-auto-translation-94": "OTP sign-in is enabled and cannot be disabled as it is currently the only sign-in method",
    "__stack-auto-translation-95": "OTP/magic link sign-in is currently enabled.",
    "__stack-auto-translation-96": "Outstanding invitations",
    "__stack-auto-translation-97": "Overwrite your user display name in this team",
    "__stack-auto-translation-98": "Passkey",
    "__stack-auto-translation-99": "Passkey registered"
  })),
  "es-419": new Map(typedEntries({
    "__stack-auto-translation-0": "Configuraci\xF3n de cuenta",
    "__stack-auto-translation-1": "Configuraci\xF3n de la cuenta",
    "__stack-auto-translation-10": "\xBFEst\xE1s seguro de que quieres abandonar el equipo?",
    "__stack-auto-translation-100": "El inicio de sesi\xF3n con clave de acceso est\xE1 activado y no se puede desactivar ya que es el \xFAnico m\xE9todo de inicio de sesi\xF3n actual",
    "__stack-auto-translation-101": "Contrase\xF1a",
    "__stack-auto-translation-102": "\xA1Contrase\xF1a restablecida con \xE9xito!",
    "__stack-auto-translation-103": "Las contrase\xF1as no coinciden",
    "__stack-auto-translation-104": "Elimina permanentemente tu cuenta y todos los datos asociados",
    "__stack-auto-translation-105": "Por favor, verifique si tiene el enlace correcto. Si contin\xFAa teniendo problemas, comun\xEDquese con soporte.",
    "__stack-auto-translation-106": "Por favor, verifica que tengas el enlace correcto para restablecer la contrase\xF1a.",
    "__stack-auto-translation-107": "Por favor, verifique si tiene el enlace de invitaci\xF3n al equipo correcto.",
    "__stack-auto-translation-108": "Por favor, ingrese un nombre de equipo",
    "__stack-auto-translation-109": "Por favor, ingrese un correo electr\xF3nico v\xE1lido",
    "__stack-auto-translation-11": "Cancelar",
    "__stack-auto-translation-110": "Por favor, ingrese una direcci\xF3n de correo electr\xF3nico v\xE1lida",
    "__stack-auto-translation-111": "Por favor, ingrese una direcci\xF3n de correo electr\xF3nico",
    "__stack-auto-translation-112": "Por favor ingrese su correo electr\xF3nico",
    "__stack-auto-translation-113": "Por favor, ingrese su contrase\xF1a antigua",
    "__stack-auto-translation-114": "Por favor ingrese su contrase\xF1a",
    "__stack-auto-translation-115": "Por favor repita su contrase\xF1a",
    "__stack-auto-translation-116": "Int\xE9ntelo de nuevo y si el problema persiste, comun\xEDquese con soporte.",
    "__stack-auto-translation-117": "Por favor, verifique su correo electr\xF3nico primero",
    "__stack-auto-translation-118": "Principal",
    "__stack-auto-translation-119": "Imagen de perfil",
    "__stack-auto-translation-12": "Cambiar el nombre visible de tu equipo",
    "__stack-auto-translation-120": "Registrar una clave de acceso",
    "__stack-auto-translation-121": "Eliminar",
    "__stack-auto-translation-122": "Repetir nueva contrase\xF1a",
    "__stack-auto-translation-123": "Repetir Nueva Contrase\xF1a",
    "__stack-auto-translation-124": "Repetir contrase\xF1a",
    "__stack-auto-translation-125": "Restablecer Contrase\xF1a",
    "__stack-auto-translation-126": "Restablecer su contrase\xF1a",
    "__stack-auto-translation-127": "Guardar",
    "__stack-auto-translation-128": "Escanea este c\xF3digo QR con tu aplicaci\xF3n de autenticaci\xF3n:",
    "__stack-auto-translation-129": "Enviar correo electr\xF3nico",
    "__stack-auto-translation-13": "haga clic aqu\xED",
    "__stack-auto-translation-130": "Enviar Correo",
    "__stack-auto-translation-131": "Enviar correo electr\xF3nico de verificaci\xF3n",
    "__stack-auto-translation-132": "Establezca una contrase\xF1a para su cuenta",
    "__stack-auto-translation-133": "Establecer como principal",
    "__stack-auto-translation-134": "Establecer contrase\xF1a",
    "__stack-auto-translation-135": "Establecer Contrase\xF1a",
    "__stack-auto-translation-136": "Configuraci\xF3n",
    "__stack-auto-translation-137": "Iniciar sesi\xF3n",
    "__stack-auto-translation-138": "Iniciar sesi\xF3n",
    "__stack-auto-translation-139": "Iniciar sesi\xF3n de nuevo",
    "__stack-auto-translation-14": "Crear",
    "__stack-auto-translation-140": "Inicie sesi\xF3n o cree una cuenta para unirse al equipo.",
    "__stack-auto-translation-141": "Inicia sesi\xF3n en tu cuenta",
    "__stack-auto-translation-142": "Iniciar sesi\xF3n con Passkey",
    "__stack-auto-translation-143": "Iniciar sesi\xF3n con {provider}",
    "__stack-auto-translation-144": "Cerrar sesi\xF3n",
    "__stack-auto-translation-145": "Registrarse",
    "__stack-auto-translation-146": "Registrarse",
    "__stack-auto-translation-147": "En este momento no est\xE1 habilitado el registro para nuevos usuarios.",
    "__stack-auto-translation-148": "Registrarse con clave de acceso",
    "__stack-auto-translation-149": "Registrarse con {provider}",
    "__stack-auto-translation-15": "Crear una cuenta nueva",
    "__stack-auto-translation-150": "\xA1Sesi\xF3n iniciada con \xE9xito!",
    "__stack-auto-translation-151": "Algo sali\xF3 mal al procesar la devoluci\xF3n de llamada de OAuth:",
    "__stack-auto-translation-152": "Dejar de usar para iniciar sesi\xF3n",
    "__stack-auto-translation-153": "La creaci\xF3n de equipos no est\xE1 habilitada",
    "__stack-auto-translation-154": "Nombre de visualizaci\xF3n del equipo",
    "__stack-auto-translation-155": "Invitaci\xF3n al equipo",
    "__stack-auto-translation-156": "Imagen de perfil del equipo",
    "__stack-auto-translation-157": "Nombre de usuario del equipo",
    "__stack-auto-translation-158": "Equipos",
    "__stack-auto-translation-159": "El enlace m\xE1gico ya ha sido utilizado. El enlace solo puede usarse una vez. Por favor, solicita un nuevo enlace m\xE1gico si necesitas iniciar sesi\xF3n nuevamente.",
    "__stack-auto-translation-16": "Crear un equipo",
    "__stack-auto-translation-160": "La operaci\xF3n de inicio de sesi\xF3n ha sido cancelada. Por favor, int\xE9ntelo de nuevo. [access_denied]",
    "__stack-auto-translation-161": "El usuario ya est\xE1 conectado a otra cuenta de OAuth. \xBFQuiz\xE1s seleccionaste la cuenta incorrecta en la p\xE1gina del proveedor de OAuth?",
    "__stack-auto-translation-162": "Luego, ingrese su c\xF3digo MFA de seis d\xEDgitos:",
    "__stack-auto-translation-163": "Esta cuenta ya est\xE1 conectada a otro usuario. Por favor, conecta una cuenta diferente.",
    "__stack-auto-translation-164": "Este correo electr\xF3nico ya est\xE1 siendo usado para iniciar sesi\xF3n por otro usuario.",
    "__stack-auto-translation-165": "Este es un nombre para mostrar y no se usa para autenticaci\xF3n",
    "__stack-auto-translation-166": "Es muy probable que esto sea un error en Stack. Por favor, rep\xF3rtelo.",
    "__stack-auto-translation-167": "Este enlace para restablecer la contrase\xF1a ya ha sido utilizado. Si necesita restablecer su contrase\xF1a nuevamente, solicite un nuevo enlace para restablecer la contrase\xF1a desde la p\xE1gina de inicio de sesi\xF3n.",
    "__stack-auto-translation-168": "Este enlace de invitaci\xF3n al equipo ya ha sido utilizado.",
    "__stack-auto-translation-169": "Para activar el inicio de sesi\xF3n con OTP, agregue un correo electr\xF3nico de inicio de sesi\xF3n verificado.",
    "__stack-auto-translation-17": "Crear un equipo",
    "__stack-auto-translation-170": "Para activar el inicio de sesi\xF3n con clave de acceso, agregue un correo electr\xF3nico de inicio de sesi\xF3n verificado.",
    "__stack-auto-translation-171": "Para establecer una contrase\xF1a, agregue un correo electr\xF3nico de inicio de sesi\xF3n.",
    "__stack-auto-translation-172": "Cambiar tema",
    "__stack-auto-translation-173": "C\xF3digo QR de autenticaci\xF3n multifactor TOTP",
    "__stack-auto-translation-174": "No verificado",
    "__stack-auto-translation-175": "Actualizar contrase\xF1a",
    "__stack-auto-translation-176": "Actualizar Contrase\xF1a",
    "__stack-auto-translation-177": "Actualiza tu contrase\xF1a",
    "__stack-auto-translation-178": "Sube una imagen para tu equipo",
    "__stack-auto-translation-179": "Sube tu propia imagen como tu avatar",
    "__stack-auto-translation-18": "Equipo actual",
    "__stack-auto-translation-180": "Usar para iniciar sesi\xF3n",
    "__stack-auto-translation-181": "Usado para iniciar sesi\xF3n",
    "__stack-auto-translation-182": "Enlace de Restablecimiento de Contrase\xF1a Usado",
    "__stack-auto-translation-183": "Enlace de Invitaci\xF3n de Equipo Utilizado",
    "__stack-auto-translation-184": "Usuario",
    "__stack-auto-translation-185": "Nombre de usuario",
    "__stack-auto-translation-186": "Verificar",
    "__stack-auto-translation-187": "Ya has iniciado sesi\xF3n",
    "__stack-auto-translation-188": "No est\xE1s conectado actualmente.",
    "__stack-auto-translation-189": "No puedes eliminar tu \xFAltimo correo electr\xF3nico de inicio de sesi\xF3n",
    "__stack-auto-translation-19": "Zona de peligro",
    "__stack-auto-translation-190": "\xA1Tu correo electr\xF3nico ha sido verificado!",
    "__stack-auto-translation-191": "Tu correo electr\xF3nico",
    "__stack-auto-translation-192": "Su enlace de verificaci\xF3n de correo electr\xF3nico ha expirado. Por favor, solicite un nuevo enlace de verificaci\xF3n desde la configuraci\xF3n de su cuenta.",
    "__stack-auto-translation-193": "Su enlace m\xE1gico ha expirado. Por favor, solicite un nuevo enlace m\xE1gico si necesita iniciar sesi\xF3n.",
    "__stack-auto-translation-194": "Tu contrase\xF1a ha sido restablecida. Ahora puedes iniciar sesi\xF3n con tu nueva contrase\xF1a.",
    "__stack-auto-translation-195": "Su enlace para restablecer la contrase\xF1a ha expirado. Por favor, solicite un nuevo enlace para restablecer la contrase\xF1a desde la p\xE1gina de inicio de sesi\xF3n.",
    "__stack-auto-translation-196": "Su enlace de invitaci\xF3n al equipo ha expirado. Por favor, solicite un nuevo enlace de invitaci\xF3n al equipo ",
    "__stack-auto-translation-2": "Agregar",
    "__stack-auto-translation-20": "Eliminar cuenta",
    "__stack-auto-translation-21": "Eliminar cuenta",
    "__stack-auto-translation-22": "Eliminar clave de acceso",
    "__stack-auto-translation-23": "Deshabilitar",
    "__stack-auto-translation-24": "Deshabilitar MFA",
    "__stack-auto-translation-25": "Deshabilitar OTP",
    "__stack-auto-translation-26": "Nombre para mostrar",
    "__stack-auto-translation-27": "\xBFDesea iniciar sesi\xF3n?",
    "__stack-auto-translation-28": "\xBFQuieres verificar tu correo electr\xF3nico?",
    "__stack-auto-translation-29": "\xBFNo tienes una cuenta?",
    "__stack-auto-translation-3": "Agregar un correo electr\xF3nico",
    "__stack-auto-translation-30": "\xBFNo necesitas restablecer?",
    "__stack-auto-translation-31": "Correo electr\xF3nico",
    "__stack-auto-translation-32": "Correo y contrase\xF1a",
    "__stack-auto-translation-33": "El correo electr\xF3nico ya existe",
    "__stack-auto-translation-34": "El correo electr\xF3nico es obligatorio",
    "__stack-auto-translation-35": "\xA1Correo enviado!",
    "__stack-auto-translation-36": "Correos electr\xF3nicos",
    "__stack-auto-translation-37": "Correos electr\xF3nicos y autenticaci\xF3n",
    "__stack-auto-translation-38": "Activar MFA",
    "__stack-auto-translation-39": "Activar OTP",
    "__stack-auto-translation-4": "Agregar nueva clave de acceso",
    "__stack-auto-translation-40": "Activar inicio de sesi\xF3n mediante enlace m\xE1gico o OTP enviado a sus correos electr\xF3nicos de inicio de sesi\xF3n.",
    "__stack-auto-translation-41": "Finalizar su sesi\xF3n actual",
    "__stack-auto-translation-42": "Ingrese un nombre para mostrar para su nuevo equipo",
    "__stack-auto-translation-43": "Ingrese correo electr\xF3nico",
    "__stack-auto-translation-44": "Ingrese el c\xF3digo de su correo electr\xF3nico",
    "__stack-auto-translation-45": "Enlace m\xE1gico caducado",
    "__stack-auto-translation-46": "Enlace de Restablecimiento de Contrase\xF1a Expirado",
    "__stack-auto-translation-47": "Enlace de invitaci\xF3n del equipo caducado",
    "__stack-auto-translation-48": "Enlace de verificaci\xF3n caducado",
    "__stack-auto-translation-49": "Vence",
    "__stack-auto-translation-5": "\xBFYa tienes una cuenta?",
    "__stack-auto-translation-50": "Error al conectar la cuenta",
    "__stack-auto-translation-51": "Fallo al restablecer la contrase\xF1a",
    "__stack-auto-translation-52": "No se pudo restablecer la contrase\xF1a. Por favor, solicite un nuevo enlace para restablecer la contrase\xF1a",
    "__stack-auto-translation-53": "\xBFOlvidaste tu contrase\xF1a?",
    "__stack-auto-translation-54": "Ir a inicio",
    "__stack-auto-translation-55": "Ir a inicio",
    "__stack-auto-translation-56": "Si el usuario con esta direcci\xF3n de correo electr\xF3nico existe, se envi\xF3 un correo electr\xF3nico a su bandeja de entrada. Aseg\xFArese de revisar su carpeta de spam.",
    "__stack-auto-translation-57": "Si no se le redirige autom\xE1ticamente, ",
    "__stack-auto-translation-58": "Ignorar",
    "__stack-auto-translation-59": "C\xF3digo incorrecto. Int\xE9ntelo de nuevo.",
    "__stack-auto-translation-6": "Se produjo un error desconocido",
    "__stack-auto-translation-60": "Contrase\xF1a incorrecta",
    "__stack-auto-translation-61": "C\xF3digo no v\xE1lido",
    "__stack-auto-translation-62": "Imagen no v\xE1lida",
    "__stack-auto-translation-63": "Enlace m\xE1gico no v\xE1lido",
    "__stack-auto-translation-64": "Enlace de restablecimiento de contrase\xF1a no v\xE1lido",
    "__stack-auto-translation-65": "Enlace de invitaci\xF3n de equipo inv\xE1lido",
    "__stack-auto-translation-66": "C\xF3digo TOTP inv\xE1lido",
    "__stack-auto-translation-67": "Enlace de verificaci\xF3n inv\xE1lido",
    "__stack-auto-translation-68": "Invita a un usuario a tu equipo por correo electr\xF3nico",
    "__stack-auto-translation-69": "Invitar miembro",
    "__stack-auto-translation-7": "\xBFEst\xE1 seguro de que desea eliminar su cuenta? Esta acci\xF3n es IRREVERSIBLE y eliminar\xE1 TODOS los datos asociados.",
    "__stack-auto-translation-70": "Invitar Usuario",
    "__stack-auto-translation-71": "Unirse",
    "__stack-auto-translation-72": "Salir",
    "__stack-auto-translation-73": "Abandonar equipo",
    "__stack-auto-translation-74": "Salir del equipo",
    "__stack-auto-translation-75": "abandona este equipo y elimina tu perfil de equipo",
    "__stack-auto-translation-76": "Enlace M\xE1gico Ya Utilizado",
    "__stack-auto-translation-77": "Miembros",
    "__stack-auto-translation-78": "Autenticaci\xF3n de m\xFAltiples factores",
    "__stack-auto-translation-79": "La autenticaci\xF3n de m\xFAltiples factores est\xE1 actualmente desactivada.",
    "__stack-auto-translation-8": "\xBFEst\xE1 seguro de que desea deshabilitar el inicio de sesi\xF3n con OTP? Ya no podr\xE1 iniciar sesi\xF3n solo con correos electr\xF3nicos.",
    "__stack-auto-translation-80": "La autenticaci\xF3n de m\xFAltiples factores est\xE1 actualmente habilitada.",
    "__stack-auto-translation-81": "Mi perfil",
    "__stack-auto-translation-82": "Nombre",
    "__stack-auto-translation-83": "No se permite el registro de nuevas cuentas",
    "__stack-auto-translation-84": "Nueva contrase\xF1a",
    "__stack-auto-translation-85": "Nueva Contrase\xF1a",
    "__stack-auto-translation-86": "Ning\xFAn m\xE9todo de autenticaci\xF3n habilitado.",
    "__stack-auto-translation-87": "Sin equipos a\xFAn",
    "__stack-auto-translation-88": "No ha iniciado sesi\xF3n",
    "__stack-auto-translation-89": "Acceso denegado por el proveedor de OAuth",
    "__stack-auto-translation-9": "\xBFEst\xE1s seguro de que quieres deshabilitar el inicio de sesi\xF3n con clave de acceso? Ya no podr\xE1s iniciar sesi\xF3n con tu clave de acceso.",
    "__stack-auto-translation-90": "Contrase\xF1a anterior",
    "__stack-auto-translation-91": "O continuar con",
    "__stack-auto-translation-92": "Otros equipos",
    "__stack-auto-translation-93": "Inicio de sesi\xF3n con OTP",
    "__stack-auto-translation-94": "El inicio de sesi\xF3n con OTP est\xE1 activado y no se puede deshabilitar ya que actualmente es el \xFAnico m\xE9todo de inicio de sesi\xF3n",
    "__stack-auto-translation-95": "El inicio de sesi\xF3n por OTP/enlace m\xE1gico est\xE1 actualmente activado.",
    "__stack-auto-translation-96": "Invitaciones pendientes",
    "__stack-auto-translation-97": "Sobrescribe tu nombre de usuario en este equipo",
    "__stack-auto-translation-98": "Clave de acceso",
    "__stack-auto-translation-99": "Clave de acceso registrada"
  })),
  "es-ES": new Map(typedEntries({
    "__stack-auto-translation-0": "Configuraci\xF3n de la cuenta",
    "__stack-auto-translation-1": "Configuraci\xF3n de la cuenta",
    "__stack-auto-translation-10": "\xBFEst\xE1 seguro de que desea abandonar el equipo?",
    "__stack-auto-translation-100": "El inicio de sesi\xF3n con clave de acceso est\xE1 habilitado y no se puede deshabilitar ya que es el \xFAnico m\xE9todo de inicio de sesi\xF3n actual",
    "__stack-auto-translation-101": "Contrase\xF1a",
    "__stack-auto-translation-102": "Contrase\xF1a restablecida correctamente",
    "__stack-auto-translation-103": "Las contrase\xF1as no coinciden",
    "__stack-auto-translation-104": "Eliminar permanentemente tu cuenta y todos los datos asociados",
    "__stack-auto-translation-105": "Por favor, verifique si tiene el enlace correcto. Si contin\xFAa teniendo problemas, comun\xEDquese con el soporte t\xE9cnico.",
    "__stack-auto-translation-106": "Por favor, verifique si tiene el enlace correcto para restablecer la contrase\xF1a.",
    "__stack-auto-translation-107": "Por favor, verifica si tienes el enlace de invitaci\xF3n de equipo correcto.",
    "__stack-auto-translation-108": "Por favor, introduce un nombre de equipo",
    "__stack-auto-translation-109": "Por favor, introduce un correo electr\xF3nico v\xE1lido",
    "__stack-auto-translation-11": "Cancelar",
    "__stack-auto-translation-110": "Por favor, introduzca una direcci\xF3n de correo electr\xF3nico v\xE1lida",
    "__stack-auto-translation-111": "Por favor, introduzca una direcci\xF3n de correo electr\xF3nico",
    "__stack-auto-translation-112": "Por favor, introduzca su correo electr\xF3nico",
    "__stack-auto-translation-113": "Por favor, introduce tu contrase\xF1a antigua",
    "__stack-auto-translation-114": "Por favor, ingrese su contrase\xF1a",
    "__stack-auto-translation-115": "Por favor, repita su contrase\xF1a",
    "__stack-auto-translation-116": "Int\xE9ntelo de nuevo y, si el problema persiste, p\xF3ngase en contacto con el soporte.",
    "__stack-auto-translation-117": "Por favor, verifica tu email primero",
    "__stack-auto-translation-118": "Principal",
    "__stack-auto-translation-119": "Imagen de perfil",
    "__stack-auto-translation-12": "Cambiar el nombre visible de tu equipo",
    "__stack-auto-translation-120": "Registrar una clave de acceso",
    "__stack-auto-translation-121": "Eliminar",
    "__stack-auto-translation-122": "Repita la nueva contrase\xF1a",
    "__stack-auto-translation-123": "Repita la nueva contrase\xF1a",
    "__stack-auto-translation-124": "Repetir Contrase\xF1a",
    "__stack-auto-translation-125": "Restablecer Contrase\xF1a",
    "__stack-auto-translation-126": "Restablecer tu contrase\xF1a",
    "__stack-auto-translation-127": "Guardar",
    "__stack-auto-translation-128": "Escanea este c\xF3digo QR con tu aplicaci\xF3n de autenticaci\xF3n:",
    "__stack-auto-translation-129": "Enviar correo electr\xF3nico",
    "__stack-auto-translation-13": "haga clic aqu\xED",
    "__stack-auto-translation-130": "Enviar correo electr\xF3nico",
    "__stack-auto-translation-131": "Enviar correo de verificaci\xF3n",
    "__stack-auto-translation-132": "Establece una contrase\xF1a para tu cuenta",
    "__stack-auto-translation-133": "Establecer como principal",
    "__stack-auto-translation-134": "Establecer contrase\xF1a",
    "__stack-auto-translation-135": "Establecer contrase\xF1a",
    "__stack-auto-translation-136": "Configuraci\xF3n",
    "__stack-auto-translation-137": "Iniciar sesi\xF3n",
    "__stack-auto-translation-138": "Iniciar sesi\xF3n",
    "__stack-auto-translation-139": "Iniciar sesi\xF3n de nuevo",
    "__stack-auto-translation-14": "Crear",
    "__stack-auto-translation-140": "Inicia sesi\xF3n o crea una cuenta para unirte al equipo.",
    "__stack-auto-translation-141": "Iniciar sesi\xF3n en tu cuenta",
    "__stack-auto-translation-142": "Iniciar sesi\xF3n con Passkey",
    "__stack-auto-translation-143": "Iniciar sesi\xF3n con {provider}",
    "__stack-auto-translation-144": "Cerrar sesi\xF3n",
    "__stack-auto-translation-145": "Registrarse",
    "__stack-auto-translation-146": "Registrarse",
    "__stack-auto-translation-147": "El registro de nuevos usuarios no est\xE1 habilitado en este momento.",
    "__stack-auto-translation-148": "Registrarse con Passkey",
    "__stack-auto-translation-149": "Registrarse con {provider}",
    "__stack-auto-translation-15": "Crear una nueva cuenta",
    "__stack-auto-translation-150": "\xA1Sesi\xF3n iniciada con \xE9xito!",
    "__stack-auto-translation-151": "Algo sali\xF3 mal al procesar la devoluci\xF3n de llamada de OAuth:",
    "__stack-auto-translation-152": "Dejar de usar para iniciar sesi\xF3n",
    "__stack-auto-translation-153": "La creaci\xF3n de equipos no est\xE1 habilitada",
    "__stack-auto-translation-154": "Nombre visible del equipo",
    "__stack-auto-translation-155": "Invitaci\xF3n al equipo",
    "__stack-auto-translation-156": "Imagen de perfil del equipo",
    "__stack-auto-translation-157": "Nombre de usuario del equipo",
    "__stack-auto-translation-158": "Equipos",
    "__stack-auto-translation-159": "El enlace m\xE1gico ya ha sido utilizado. El enlace solo se puede usar una vez. Por favor, solicita un nuevo enlace m\xE1gico si necesitas iniciar sesi\xF3n de nuevo.",
    "__stack-auto-translation-16": "Crear un equipo",
    "__stack-auto-translation-160": "La operaci\xF3n de inicio de sesi\xF3n ha sido cancelada. Por favor, int\xE9ntelo de nuevo. [access_denied]",
    "__stack-auto-translation-161": "El usuario ya est\xE1 conectado a otra cuenta OAuth. \xBFQuiz\xE1s seleccion\xF3 la cuenta equivocada en la p\xE1gina del proveedor OAuth?",
    "__stack-auto-translation-162": "Luego, ingrese su c\xF3digo MFA de seis d\xEDgitos:",
    "__stack-auto-translation-163": "Esta cuenta ya est\xE1 conectada a otro usuario. Por favor, conecta una cuenta diferente.",
    "__stack-auto-translation-164": "Este email ya est\xE1 siendo usado para iniciar sesi\xF3n por otro usuario.",
    "__stack-auto-translation-165": "Este es un nombre visible y no se utiliza para la autenticaci\xF3n",
    "__stack-auto-translation-166": "Es muy probable que se trate de un error en Stack. Por favor, informe de ello.",
    "__stack-auto-translation-167": "Este enlace para restablecer la contrase\xF1a ya ha sido utilizado. Si necesita restablecer su contrase\xF1a nuevamente, solicite un nuevo enlace para restablecer la contrase\xF1a desde la p\xE1gina de inicio de sesi\xF3n.",
    "__stack-auto-translation-168": "Este enlace de invitaci\xF3n al equipo ya ha sido utilizado.",
    "__stack-auto-translation-169": "Para habilitar el inicio de sesi\xF3n por OTP, a\xF1ada un correo electr\xF3nico de inicio de sesi\xF3n verificado.",
    "__stack-auto-translation-17": "Crear un equipo",
    "__stack-auto-translation-170": "Para habilitar el inicio de sesi\xF3n con clave de acceso, a\xF1ada un email de inicio de sesi\xF3n verificado.",
    "__stack-auto-translation-171": "Para establecer una contrase\xF1a, a\xF1ade un email de inicio de sesi\xF3n.",
    "__stack-auto-translation-172": "Cambiar tema",
    "__stack-auto-translation-173": "C\xF3digo QR de autenticaci\xF3n multifactor TOTP",
    "__stack-auto-translation-174": "Sin verificar",
    "__stack-auto-translation-175": "Actualizar contrase\xF1a",
    "__stack-auto-translation-176": "Actualizar Contrase\xF1a",
    "__stack-auto-translation-177": "Actualiza tu contrase\xF1a",
    "__stack-auto-translation-178": "Sube una imagen para tu equipo",
    "__stack-auto-translation-179": "Sube tu propia imagen como avatar",
    "__stack-auto-translation-18": "Equipo actual",
    "__stack-auto-translation-180": "Usar para iniciar sesi\xF3n",
    "__stack-auto-translation-181": "Usado para iniciar sesi\xF3n",
    "__stack-auto-translation-182": "Enlace de restablecimiento de contrase\xF1a utilizado",
    "__stack-auto-translation-183": "Enlace de invitaci\xF3n al equipo utilizado",
    "__stack-auto-translation-184": "Usuario",
    "__stack-auto-translation-185": "Nombre de usuario",
    "__stack-auto-translation-186": "Verificar",
    "__stack-auto-translation-187": "Ya has iniciado sesi\xF3n",
    "__stack-auto-translation-188": "No est\xE1 registrado actualmente.",
    "__stack-auto-translation-189": "No puedes eliminar tu \xFAltimo correo electr\xF3nico de inicio de sesi\xF3n",
    "__stack-auto-translation-19": "Zona de peligro",
    "__stack-auto-translation-190": "\xA1Tu email ha sido verificado!",
    "__stack-auto-translation-191": "Tu email",
    "__stack-auto-translation-192": "Su enlace de verificaci\xF3n de correo electr\xF3nico ha caducado. Por favor, solicite un nuevo enlace de verificaci\xF3n desde la configuraci\xF3n de su cuenta.",
    "__stack-auto-translation-193": "Su enlace m\xE1gico ha caducado. Por favor, solicite un nuevo enlace m\xE1gico si necesita iniciar sesi\xF3n.",
    "__stack-auto-translation-194": "Tu contrase\xF1a ha sido restablecida. Ahora puedes iniciar sesi\xF3n con tu nueva contrase\xF1a.",
    "__stack-auto-translation-195": "Tu enlace para restablecer la contrase\xF1a ha caducado. Solicita un nuevo enlace para restablecer la contrase\xF1a desde la p\xE1gina de inicio de sesi\xF3n.",
    "__stack-auto-translation-196": "Tu enlace de invitaci\xF3n al equipo ha caducado. Por favor, solicita un nuevo enlace de invitaci\xF3n al equipo ",
    "__stack-auto-translation-2": "A\xF1adir",
    "__stack-auto-translation-20": "Eliminar cuenta",
    "__stack-auto-translation-21": "Eliminar cuenta",
    "__stack-auto-translation-22": "Eliminar clave de acceso",
    "__stack-auto-translation-23": "Deshabilitar",
    "__stack-auto-translation-24": "Deshabilitar MFA",
    "__stack-auto-translation-25": "Deshabilitar OTP",
    "__stack-auto-translation-26": "Nombre visible",
    "__stack-auto-translation-27": "\xBFQuieres iniciar sesi\xF3n?",
    "__stack-auto-translation-28": "\xBFQuieres verificar tu email?",
    "__stack-auto-translation-29": "\xBFNo tienes una cuenta?",
    "__stack-auto-translation-3": "A\xF1adir un correo electr\xF3nico",
    "__stack-auto-translation-30": "\xBFNo necesitas restablecer?",
    "__stack-auto-translation-31": "Correo electr\xF3nico",
    "__stack-auto-translation-32": "Correo y contrase\xF1a",
    "__stack-auto-translation-33": "El correo electr\xF3nico ya existe",
    "__stack-auto-translation-34": "El correo electr\xF3nico es obligatorio",
    "__stack-auto-translation-35": "\xA1Correo enviado!",
    "__stack-auto-translation-36": "Correos electr\xF3nicos",
    "__stack-auto-translation-37": "Correos electr\xF3nicos y autenticaci\xF3n",
    "__stack-auto-translation-38": "Habilitar MFA",
    "__stack-auto-translation-39": "Habilitar OTP",
    "__stack-auto-translation-4": "A\xF1adir nueva clave de acceso",
    "__stack-auto-translation-40": "Habilitar el inicio de sesi\xF3n mediante enlace m\xE1gico o OTP enviado a tus correos electr\xF3nicos de inicio de sesi\xF3n.",
    "__stack-auto-translation-41": "Finalizar su sesi\xF3n actual",
    "__stack-auto-translation-42": "Ingrese un nombre para mostrar para su nuevo equipo",
    "__stack-auto-translation-43": "Introducir correo electr\xF3nico",
    "__stack-auto-translation-44": "Ingrese el c\xF3digo de su correo electr\xF3nico",
    "__stack-auto-translation-45": "Enlace m\xE1gico caducado",
    "__stack-auto-translation-46": "Enlace de restablecimiento de contrase\xF1a caducado",
    "__stack-auto-translation-47": "Enlace de invitaci\xF3n al equipo caducado",
    "__stack-auto-translation-48": "Enlace de verificaci\xF3n caducado",
    "__stack-auto-translation-49": "Caduca",
    "__stack-auto-translation-5": "\xBFYa tienes una cuenta?",
    "__stack-auto-translation-50": "Error al conectar la cuenta",
    "__stack-auto-translation-51": "Error al restablecer la contrase\xF1a",
    "__stack-auto-translation-52": "No se pudo restablecer la contrase\xF1a. Por favor, solicite un nuevo enlace para restablecer la contrase\xF1a",
    "__stack-auto-translation-53": "\xBFOlvidaste tu contrase\xF1a?",
    "__stack-auto-translation-54": "Ir a inicio",
    "__stack-auto-translation-55": "Ir a inicio",
    "__stack-auto-translation-56": "Si el usuario con esta direcci\xF3n de correo electr\xF3nico existe, se ha enviado un correo electr\xF3nico a su bandeja de entrada. Aseg\xFArese de revisar su carpeta de spam.",
    "__stack-auto-translation-57": "Si no es redirigido autom\xE1ticamente, ",
    "__stack-auto-translation-58": "Ignorar",
    "__stack-auto-translation-59": "C\xF3digo incorrecto. Por favor, int\xE9ntelo de nuevo.",
    "__stack-auto-translation-6": "Se produjo un error desconocido",
    "__stack-auto-translation-60": "Contrase\xF1a incorrecta",
    "__stack-auto-translation-61": "C\xF3digo no v\xE1lido",
    "__stack-auto-translation-62": "Imagen no v\xE1lida",
    "__stack-auto-translation-63": "Enlace M\xE1gico No V\xE1lido",
    "__stack-auto-translation-64": "Enlace de restablecimiento de contrase\xF1a no v\xE1lido",
    "__stack-auto-translation-65": "Enlace de invitaci\xF3n al equipo no v\xE1lido",
    "__stack-auto-translation-66": "C\xF3digo TOTP no v\xE1lido",
    "__stack-auto-translation-67": "Enlace de verificaci\xF3n no v\xE1lido",
    "__stack-auto-translation-68": "Invita a un usuario a tu equipo por correo electr\xF3nico",
    "__stack-auto-translation-69": "Invitar miembro",
    "__stack-auto-translation-7": "\xBFEst\xE1 seguro de que desea eliminar su cuenta? Esta acci\xF3n es IRREVERSIBLE y eliminar\xE1 TODOS los datos asociados.",
    "__stack-auto-translation-70": "Invitar usuario",
    "__stack-auto-translation-71": "Unirse",
    "__stack-auto-translation-72": "Salir",
    "__stack-auto-translation-73": "Abandonar equipo",
    "__stack-auto-translation-74": "Abandonar equipo",
    "__stack-auto-translation-75": "abandonar este equipo y eliminar tu perfil de equipo",
    "__stack-auto-translation-76": "Enlace m\xE1gico ya utilizado",
    "__stack-auto-translation-77": "Miembros",
    "__stack-auto-translation-78": "Autenticaci\xF3n de m\xFAltiples factores",
    "__stack-auto-translation-79": "La autenticaci\xF3n de m\xFAltiples factores est\xE1 actualmente desactivada.",
    "__stack-auto-translation-8": "\xBFEst\xE1 seguro de que desea deshabilitar el inicio de sesi\xF3n por OTP? Ya no podr\xE1 iniciar sesi\xF3n solo con correos electr\xF3nicos.",
    "__stack-auto-translation-80": "La autenticaci\xF3n de m\xFAltiples factores est\xE1 actualmente habilitada.",
    "__stack-auto-translation-81": "Mi perfil",
    "__stack-auto-translation-82": "Nombre",
    "__stack-auto-translation-83": "No se permite el registro de nuevas cuentas",
    "__stack-auto-translation-84": "Nueva contrase\xF1a",
    "__stack-auto-translation-85": "Nueva contrase\xF1a",
    "__stack-auto-translation-86": "Ning\xFAn m\xE9todo de autenticaci\xF3n habilitado.",
    "__stack-auto-translation-87": "Sin equipos a\xFAn",
    "__stack-auto-translation-88": "No registrado",
    "__stack-auto-translation-89": "Acceso denegado al proveedor de OAuth",
    "__stack-auto-translation-9": "\xBFEst\xE1 seguro de que desea deshabilitar el inicio de sesi\xF3n con clave de acceso? Ya no podr\xE1 iniciar sesi\xF3n con su clave de acceso.",
    "__stack-auto-translation-90": "Contrase\xF1a anterior",
    "__stack-auto-translation-91": "O continuar con",
    "__stack-auto-translation-92": "Otros equipos",
    "__stack-auto-translation-93": "Inicio de sesi\xF3n por OTP",
    "__stack-auto-translation-94": "El inicio de sesi\xF3n por OTP est\xE1 habilitado y no se puede deshabilitar ya que actualmente es el \xFAnico m\xE9todo de inicio de sesi\xF3n",
    "__stack-auto-translation-95": "El inicio de sesi\xF3n por OTP/enlace m\xE1gico est\xE1 actualmente habilitado.",
    "__stack-auto-translation-96": "Invitaciones pendientes",
    "__stack-auto-translation-97": "Sobrescribe tu nombre de usuario en este equipo",
    "__stack-auto-translation-98": "Clave de acceso",
    "__stack-auto-translation-99": "Clave de acceso registrada"
  })),
  "fr-CA": new Map(typedEntries({
    "__stack-auto-translation-0": "Param\xE8tres du compte",
    "__stack-auto-translation-1": "Param\xE8tres du compte",
    "__stack-auto-translation-10": "\xCAtes-vous s\xFBr de vouloir quitter l'\xE9quipe?",
    "__stack-auto-translation-100": "La connexion par cl\xE9 d'acc\xE8s est activ\xE9e et ne peut \xEAtre d\xE9sactiv\xE9e car c'est actuellement la seule m\xE9thode de connexion",
    "__stack-auto-translation-101": "Mot de passe",
    "__stack-auto-translation-102": "R\xE9initialisation du mot de passe r\xE9ussie !",
    "__stack-auto-translation-103": "Les mots de passe ne correspondent pas",
    "__stack-auto-translation-104": "Supprimer d\xE9finitivement votre compte et toutes les donn\xE9es associ\xE9es",
    "__stack-auto-translation-105": "Veuillez v\xE9rifier si vous avez le bon lien. Si vous continuez \xE0 avoir des probl\xE8mes, veuillez contacter le support.",
    "__stack-auto-translation-106": "Veuillez v\xE9rifier si vous avez le bon lien de r\xE9initialisation du mot de passe.",
    "__stack-auto-translation-107": "Veuillez v\xE9rifier si vous avez le bon lien d'invitation d'\xE9quipe.",
    "__stack-auto-translation-108": "Veuillez saisir un nom d'\xE9quipe",
    "__stack-auto-translation-109": "Veuillez saisir une adresse courriel valide",
    "__stack-auto-translation-11": "Annuler",
    "__stack-auto-translation-110": "Veuillez saisir une adresse courriel valide",
    "__stack-auto-translation-111": "Veuillez saisir une adresse courriel",
    "__stack-auto-translation-112": "Veuillez saisir votre adresse courriel",
    "__stack-auto-translation-113": "Veuillez entrer votre ancien mot de passe",
    "__stack-auto-translation-114": "Veuillez entrer votre mot de passe",
    "__stack-auto-translation-115": "Veuillez r\xE9p\xE9ter votre mot de passe",
    "__stack-auto-translation-116": "Veuillez r\xE9essayer et si le probl\xE8me persiste, contactez le support.",
    "__stack-auto-translation-117": "Veuillez d'abord v\xE9rifier votre courriel",
    "__stack-auto-translation-118": "Principal",
    "__stack-auto-translation-119": "Image de profil",
    "__stack-auto-translation-12": "Modifier le nom d'affichage de votre \xE9quipe",
    "__stack-auto-translation-120": "Enregistrer une cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-121": "Supprimer",
    "__stack-auto-translation-122": "R\xE9p\xE9tez le nouveau mot de passe",
    "__stack-auto-translation-123": "R\xE9p\xE9tez le nouveau mot de passe",
    "__stack-auto-translation-124": "R\xE9p\xE9ter le mot de passe",
    "__stack-auto-translation-125": "R\xE9initialiser le mot de passe",
    "__stack-auto-translation-126": "R\xE9initialisez votre mot de passe",
    "__stack-auto-translation-127": "Enregistrer",
    "__stack-auto-translation-128": "Scannez ce code QR avec votre application d'authentification :",
    "__stack-auto-translation-129": "Envoyer le courriel",
    "__stack-auto-translation-13": "cliquez ici",
    "__stack-auto-translation-130": "Envoyer le courriel",
    "__stack-auto-translation-131": "Envoyer un courriel de v\xE9rification",
    "__stack-auto-translation-132": "D\xE9finir un mot de passe pour votre compte",
    "__stack-auto-translation-133": "D\xE9finir comme principal",
    "__stack-auto-translation-134": "D\xE9finir le mot de passe",
    "__stack-auto-translation-135": "D\xE9finir le mot de passe",
    "__stack-auto-translation-136": "Param\xE8tres",
    "__stack-auto-translation-137": "Connexion",
    "__stack-auto-translation-138": "Se connecter",
    "__stack-auto-translation-139": "Se connecter \xE0 nouveau",
    "__stack-auto-translation-14": "Cr\xE9er",
    "__stack-auto-translation-140": "Connectez-vous ou cr\xE9ez un compte pour rejoindre l'\xE9quipe.",
    "__stack-auto-translation-141": "Connectez-vous \xE0 votre compte",
    "__stack-auto-translation-142": "Se connecter avec cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-143": "Connexion avec {provider}",
    "__stack-auto-translation-144": "Se d\xE9connecter",
    "__stack-auto-translation-145": "S'inscrire",
    "__stack-auto-translation-146": "S'inscrire",
    "__stack-auto-translation-147": "L'inscription de nouveaux utilisateurs n'est pas activ\xE9e pour le moment.",
    "__stack-auto-translation-148": "S'inscrire avec Passkey",
    "__stack-auto-translation-149": "S'inscrire avec {provider}",
    "__stack-auto-translation-15": "Cr\xE9er un nouveau compte",
    "__stack-auto-translation-150": "Connexion r\xE9ussie !",
    "__stack-auto-translation-151": "Une erreur s'est produite lors du traitement du rappel OAuth :",
    "__stack-auto-translation-152": "Cesser d'utiliser pour la connexion",
    "__stack-auto-translation-153": "La cr\xE9ation d'\xE9quipe n'est pas activ\xE9e",
    "__stack-auto-translation-154": "Nom d'affichage de l'\xE9quipe",
    "__stack-auto-translation-155": "Invitation d'\xE9quipe",
    "__stack-auto-translation-156": "Image de profil d'\xE9quipe",
    "__stack-auto-translation-157": "Nom d'utilisateur d'\xE9quipe",
    "__stack-auto-translation-158": "\xC9quipes",
    "__stack-auto-translation-159": "Le lien magique a d\xE9j\xE0 \xE9t\xE9 utilis\xE9. Le lien ne peut \xEAtre utilis\xE9 qu'une seule fois. Veuillez demander un nouveau lien magique si vous devez vous reconnecter.",
    "__stack-auto-translation-16": "Cr\xE9er une \xE9quipe",
    "__stack-auto-translation-160": "L'op\xE9ration de connexion a \xE9t\xE9 annul\xE9e. Veuillez r\xE9essayer. [access_denied]",
    "__stack-auto-translation-161": "L'utilisateur est d\xE9j\xE0 connect\xE9 \xE0 un autre compte OAuth. Avez-vous peut-\xEAtre s\xE9lectionn\xE9 le mauvais compte sur la page du fournisseur OAuth ?",
    "__stack-auto-translation-162": "Ensuite, saisissez votre code MFA \xE0 six chiffres :",
    "__stack-auto-translation-163": "Ce compte est d\xE9j\xE0 associ\xE9 \xE0 un autre utilisateur. Veuillez connecter un compte diff\xE9rent.",
    "__stack-auto-translation-164": "Ce courriel est d\xE9j\xE0 utilis\xE9 pour la connexion par un autre utilisateur.",
    "__stack-auto-translation-165": "Il s'agit d'un nom d'affichage et il n'est pas utilis\xE9 pour l'authentification",
    "__stack-auto-translation-166": "Il s'agit probablement d'une erreur dans Stack. Veuillez la signaler.",
    "__stack-auto-translation-167": "Ce lien de r\xE9initialisation de mot de passe a d\xE9j\xE0 \xE9t\xE9 utilis\xE9. Si vous devez \xE0 nouveau r\xE9initialiser votre mot de passe, veuillez demander un nouveau lien de r\xE9initialisation depuis la page de connexion.",
    "__stack-auto-translation-168": "Ce lien d'invitation d'\xE9quipe a d\xE9j\xE0 \xE9t\xE9 utilis\xE9.",
    "__stack-auto-translation-169": "Pour activer la connexion par OTP, veuillez ajouter un courriel de connexion v\xE9rifi\xE9.",
    "__stack-auto-translation-17": "Cr\xE9er une \xE9quipe",
    "__stack-auto-translation-170": "Pour activer la connexion par cl\xE9 d'acc\xE8s, veuillez ajouter un courriel de connexion v\xE9rifi\xE9.",
    "__stack-auto-translation-171": "Pour d\xE9finir un mot de passe, veuillez ajouter un courriel de connexion.",
    "__stack-auto-translation-172": "Changer de th\xE8me",
    "__stack-auto-translation-173": "Code QR d'authentification \xE0 plusieurs facteurs TOTP",
    "__stack-auto-translation-174": "Non v\xE9rifi\xE9",
    "__stack-auto-translation-175": "Mettre \xE0 jour le mot de passe",
    "__stack-auto-translation-176": "Mettre \xE0 jour le mot de passe",
    "__stack-auto-translation-177": "Mettre \xE0 jour votre mot de passe",
    "__stack-auto-translation-178": "T\xE9l\xE9versez une image pour votre \xE9quipe",
    "__stack-auto-translation-179": "T\xE9l\xE9versez votre propre image comme avatar",
    "__stack-auto-translation-18": "\xC9quipe actuelle",
    "__stack-auto-translation-180": "Utiliser pour la connexion",
    "__stack-auto-translation-181": "Utilis\xE9 pour la connexion",
    "__stack-auto-translation-182": "Lien de r\xE9initialisation de mot de passe utilis\xE9",
    "__stack-auto-translation-183": "Lien d'invitation d'\xE9quipe utilis\xE9",
    "__stack-auto-translation-184": "Utilisateur",
    "__stack-auto-translation-185": "Nom d'utilisateur",
    "__stack-auto-translation-186": "V\xE9rifier",
    "__stack-auto-translation-187": "Vous \xEAtes d\xE9j\xE0 connect\xE9",
    "__stack-auto-translation-188": "Vous n'\xEAtes pas connect\xE9 actuellement.",
    "__stack-auto-translation-189": "Vous ne pouvez pas supprimer votre dernier courriel de connexion",
    "__stack-auto-translation-19": "Zone dangereuse",
    "__stack-auto-translation-190": "Votre courriel a \xE9t\xE9 v\xE9rifi\xE9 !",
    "__stack-auto-translation-191": "Votre courriel",
    "__stack-auto-translation-192": "Votre lien de v\xE9rification de courriel a expir\xE9. Veuillez demander un nouveau lien de v\xE9rification dans les param\xE8tres de votre compte.",
    "__stack-auto-translation-193": "Votre lien magique a expir\xE9. Veuillez demander un nouveau lien magique si vous avez besoin de vous connecter.",
    "__stack-auto-translation-194": "Votre mot de passe a \xE9t\xE9 r\xE9initialis\xE9. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "__stack-auto-translation-195": "Votre lien de r\xE9initialisation du mot de passe a expir\xE9. Veuillez demander un nouveau lien de r\xE9initialisation du mot de passe \xE0 partir de la page de connexion.",
    "__stack-auto-translation-196": "Votre lien d'invitation \xE0 l'\xE9quipe a expir\xE9. Veuillez demander un nouveau lien d'invitation \xE0 l'\xE9quipe ",
    "__stack-auto-translation-2": "Ajouter",
    "__stack-auto-translation-20": "Supprimer le compte",
    "__stack-auto-translation-21": "Supprimer le compte",
    "__stack-auto-translation-22": "Supprimer la cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-23": "D\xE9sactiver",
    "__stack-auto-translation-24": "D\xE9sactiver l'AMF",
    "__stack-auto-translation-25": "D\xE9sactiver OTP",
    "__stack-auto-translation-26": "Nom d'affichage",
    "__stack-auto-translation-27": "Voulez-vous vous connecter ?",
    "__stack-auto-translation-28": "Voulez-vous v\xE9rifier votre courriel ?",
    "__stack-auto-translation-29": "Vous n'avez pas de compte ?",
    "__stack-auto-translation-3": "Ajouter un courriel",
    "__stack-auto-translation-30": "Pas besoin de r\xE9initialiser ?",
    "__stack-auto-translation-31": "Courriel",
    "__stack-auto-translation-32": "Courriel et mot de passe",
    "__stack-auto-translation-33": "Le courriel existe d\xE9j\xE0",
    "__stack-auto-translation-34": "Le courriel est requis",
    "__stack-auto-translation-35": "Courriel envoy\xE9 !",
    "__stack-auto-translation-36": "Courriels",
    "__stack-auto-translation-37": "Courriels et authentification",
    "__stack-auto-translation-38": "Activer l'AMF",
    "__stack-auto-translation-39": "Activer l'OTP",
    "__stack-auto-translation-4": "Ajouter une nouvelle cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-40": "Activer la connexion par lien magique ou OTP envoy\xE9 \xE0 vos courriels de connexion.",
    "__stack-auto-translation-41": "Terminez votre session actuelle",
    "__stack-auto-translation-42": "Entrez un nom d'affichage pour votre nouvelle \xE9quipe",
    "__stack-auto-translation-43": "Saisir le courriel",
    "__stack-auto-translation-44": "Entrez le code re\xE7u par courriel",
    "__stack-auto-translation-45": "Lien magique expir\xE9",
    "__stack-auto-translation-46": "Lien de r\xE9initialisation de mot de passe expir\xE9",
    "__stack-auto-translation-47": "Lien d'invitation d'\xE9quipe expir\xE9",
    "__stack-auto-translation-48": "Lien de v\xE9rification expir\xE9",
    "__stack-auto-translation-49": "Expire",
    "__stack-auto-translation-5": "Vous avez d\xE9j\xE0 un compte?",
    "__stack-auto-translation-50": "\xC9chec de connexion du compte",
    "__stack-auto-translation-51": "\xC9chec de la r\xE9initialisation du mot de passe",
    "__stack-auto-translation-52": "\xC9chec de la r\xE9initialisation du mot de passe. Veuillez demander un nouveau lien de r\xE9initialisation du mot de passe",
    "__stack-auto-translation-53": "Mot de passe oubli\xE9 ?",
    "__stack-auto-translation-54": "Accueil",
    "__stack-auto-translation-55": "Accueil",
    "__stack-auto-translation-56": "Si l'utilisateur avec cette adresse courriel existe, un courriel a \xE9t\xE9 envoy\xE9 \xE0 votre bo\xEEte de r\xE9ception. Assurez-vous de v\xE9rifier votre dossier de courrier ind\xE9sirable.",
    "__stack-auto-translation-57": "Si vous n'\xEAtes pas redirig\xE9 automatiquement, ",
    "__stack-auto-translation-58": "Ignorer",
    "__stack-auto-translation-59": "Code incorrect. Veuillez r\xE9essayer.",
    "__stack-auto-translation-6": "Une erreur inconnue s'est produite",
    "__stack-auto-translation-60": "Mot de passe incorrect",
    "__stack-auto-translation-61": "Code invalide",
    "__stack-auto-translation-62": "Image non valide",
    "__stack-auto-translation-63": "Lien magique invalide",
    "__stack-auto-translation-64": "Lien de r\xE9initialisation du mot de passe invalide",
    "__stack-auto-translation-65": "Lien d'invitation d'\xE9quipe invalide",
    "__stack-auto-translation-66": "Code TOTP non valide",
    "__stack-auto-translation-67": "Lien de v\xE9rification invalide",
    "__stack-auto-translation-68": "Invitez un utilisateur \xE0 votre \xE9quipe par courriel",
    "__stack-auto-translation-69": "Inviter un membre",
    "__stack-auto-translation-7": "\xCAtes-vous s\xFBr de vouloir supprimer votre compte ? Cette action est IRR\xC9VERSIBLE et supprimera TOUTES les donn\xE9es associ\xE9es.",
    "__stack-auto-translation-70": "Inviter l'utilisateur",
    "__stack-auto-translation-71": "Joindre",
    "__stack-auto-translation-72": "Quitter",
    "__stack-auto-translation-73": "Quitter l'\xE9quipe",
    "__stack-auto-translation-74": "Quitter l'\xE9quipe",
    "__stack-auto-translation-75": "quitter cette \xE9quipe et supprimer votre profil d'\xE9quipe",
    "__stack-auto-translation-76": "Lien magique d\xE9j\xE0 utilis\xE9",
    "__stack-auto-translation-77": "Membres",
    "__stack-auto-translation-78": "Authentification \xE0 plusieurs facteurs",
    "__stack-auto-translation-79": "L'authentification \xE0 deux facteurs est actuellement d\xE9sactiv\xE9e.",
    "__stack-auto-translation-8": "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver la connexion par OTP ? Vous ne pourrez plus vous connecter uniquement avec des courriels.",
    "__stack-auto-translation-80": "L'authentification multifactorielle est actuellement activ\xE9e.",
    "__stack-auto-translation-81": "Mon profil",
    "__stack-auto-translation-82": "Nom",
    "__stack-auto-translation-83": "L'inscription de nouveaux comptes n'est pas autoris\xE9e",
    "__stack-auto-translation-84": "Nouveau mot de passe",
    "__stack-auto-translation-85": "Nouveau mot de passe",
    "__stack-auto-translation-86": "Aucune m\xE9thode d'authentification activ\xE9e.",
    "__stack-auto-translation-87": "Aucune \xE9quipe pour l'instant",
    "__stack-auto-translation-88": "Non connect\xE9",
    "__stack-auto-translation-89": "Acc\xE8s au fournisseur OAuth refus\xE9",
    "__stack-auto-translation-9": "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver la connexion par cl\xE9 d'acc\xE8s ? Vous ne pourrez plus vous connecter avec votre cl\xE9 d'acc\xE8s.",
    "__stack-auto-translation-90": "Ancien mot de passe",
    "__stack-auto-translation-91": "Ou continuer avec",
    "__stack-auto-translation-92": "Autres \xE9quipes",
    "__stack-auto-translation-93": "Connexion par OTP",
    "__stack-auto-translation-94": "La connexion par OTP est activ\xE9e et ne peut pas \xEAtre d\xE9sactiv\xE9e car c'est actuellement la seule m\xE9thode de connexion",
    "__stack-auto-translation-95": "La connexion par OTP/lien magique est actuellement activ\xE9e.",
    "__stack-auto-translation-96": "Invitations en attente",
    "__stack-auto-translation-97": "Remplacez votre nom d'affichage d'utilisateur dans cette \xE9quipe",
    "__stack-auto-translation-98": "Cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-99": "Cl\xE9 d'acc\xE8s enregistr\xE9e"
  })),
  "fr-FR": new Map(typedEntries({
    "__stack-auto-translation-0": "Param\xE8tres du compte",
    "__stack-auto-translation-1": "Param\xE8tres du compte",
    "__stack-auto-translation-10": "\xCAtes-vous s\xFBr de vouloir quitter l'\xE9quipe ?",
    "__stack-auto-translation-100": "La connexion par cl\xE9 d'acc\xE8s est activ\xE9e et ne peut pas \xEAtre d\xE9sactiv\xE9e car c'est actuellement la seule m\xE9thode de connexion",
    "__stack-auto-translation-101": "Mot de passe",
    "__stack-auto-translation-102": "R\xE9initialisation du mot de passe r\xE9ussie !",
    "__stack-auto-translation-103": "Les mots de passe ne correspondent pas",
    "__stack-auto-translation-104": "Supprimez d\xE9finitivement votre compte et toutes les donn\xE9es associ\xE9es",
    "__stack-auto-translation-105": "Veuillez v\xE9rifier si vous avez le bon lien. Si vous continuez \xE0 rencontrer des probl\xE8mes, veuillez contacter le support.",
    "__stack-auto-translation-106": "Veuillez v\xE9rifier si vous avez le bon lien de r\xE9initialisation de mot de passe.",
    "__stack-auto-translation-107": "Veuillez v\xE9rifier que vous disposez du bon lien d'invitation d'\xE9quipe.",
    "__stack-auto-translation-108": "Veuillez saisir un nom d'\xE9quipe",
    "__stack-auto-translation-109": "Veuillez saisir une adresse e-mail valide",
    "__stack-auto-translation-11": "Annuler",
    "__stack-auto-translation-110": "Veuillez saisir une adresse e-mail valide",
    "__stack-auto-translation-111": "Veuillez saisir une adresse e-mail",
    "__stack-auto-translation-112": "Veuillez saisir votre adresse e-mail",
    "__stack-auto-translation-113": "Veuillez saisir votre ancien mot de passe",
    "__stack-auto-translation-114": "Veuillez saisir votre mot de passe",
    "__stack-auto-translation-115": "Veuillez r\xE9p\xE9ter votre mot de passe",
    "__stack-auto-translation-116": "Veuillez r\xE9essayer et si le probl\xE8me persiste, contactez le support.",
    "__stack-auto-translation-117": "Veuillez d'abord v\xE9rifier votre adresse e-mail",
    "__stack-auto-translation-118": "Principal",
    "__stack-auto-translation-119": "Image de profil",
    "__stack-auto-translation-12": "Modifiez le nom d'affichage de votre \xE9quipe",
    "__stack-auto-translation-120": "Enregistrer une cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-121": "Supprimer",
    "__stack-auto-translation-122": "R\xE9p\xE9ter le nouveau mot de passe",
    "__stack-auto-translation-123": "R\xE9p\xE9ter le nouveau mot de passe",
    "__stack-auto-translation-124": "R\xE9p\xE9ter le mot de passe",
    "__stack-auto-translation-125": "R\xE9initialiser le mot de passe",
    "__stack-auto-translation-126": "R\xE9initialisez votre mot de passe",
    "__stack-auto-translation-127": "Enregistrer",
    "__stack-auto-translation-128": "Scannez ce code QR avec votre application d'authentification :",
    "__stack-auto-translation-129": "Envoyer l'e-mail",
    "__stack-auto-translation-13": "cliquez ici",
    "__stack-auto-translation-130": "Envoyer l'e-mail",
    "__stack-auto-translation-131": "Envoyer un e-mail de v\xE9rification",
    "__stack-auto-translation-132": "D\xE9finissez un mot de passe pour votre compte",
    "__stack-auto-translation-133": "D\xE9finir comme principal",
    "__stack-auto-translation-134": "D\xE9finir le mot de passe",
    "__stack-auto-translation-135": "D\xE9finir le mot de passe",
    "__stack-auto-translation-136": "Param\xE8tres",
    "__stack-auto-translation-137": "Se connecter",
    "__stack-auto-translation-138": "Se connecter",
    "__stack-auto-translation-139": "Se connecter \xE0 nouveau",
    "__stack-auto-translation-14": "Cr\xE9er",
    "__stack-auto-translation-140": "Connectez-vous ou cr\xE9ez un compte pour rejoindre l'\xE9quipe.",
    "__stack-auto-translation-141": "Connectez-vous \xE0 votre compte",
    "__stack-auto-translation-142": "Se connecter avec Passkey",
    "__stack-auto-translation-143": "Se connecter avec {provider}",
    "__stack-auto-translation-144": "Se d\xE9connecter",
    "__stack-auto-translation-145": "S'inscrire",
    "__stack-auto-translation-146": "S'inscrire",
    "__stack-auto-translation-147": "L'inscription pour les nouveaux utilisateurs n'est pas activ\xE9e pour le moment.",
    "__stack-auto-translation-148": "S'inscrire avec Passkey",
    "__stack-auto-translation-149": "S'inscrire avec {provider}",
    "__stack-auto-translation-15": "Cr\xE9er un nouveau compte",
    "__stack-auto-translation-150": "Connexion r\xE9ussie !",
    "__stack-auto-translation-151": "Une erreur est survenue lors du traitement de la r\xE9ponse OAuth :",
    "__stack-auto-translation-152": "Ne plus utiliser pour la connexion",
    "__stack-auto-translation-153": "La cr\xE9ation d'\xE9quipe n'est pas activ\xE9e",
    "__stack-auto-translation-154": "Nom d'affichage de l'\xE9quipe",
    "__stack-auto-translation-155": "Invitation d'\xE9quipe",
    "__stack-auto-translation-156": "Image de profil d'\xE9quipe",
    "__stack-auto-translation-157": "Nom d'utilisateur de l'\xE9quipe",
    "__stack-auto-translation-158": "\xC9quipes",
    "__stack-auto-translation-159": "Le lien magique a d\xE9j\xE0 \xE9t\xE9 utilis\xE9. Le lien ne peut \xEAtre utilis\xE9 qu'une seule fois. Veuillez demander un nouveau lien magique si vous devez vous reconnecter.",
    "__stack-auto-translation-16": "Cr\xE9er une \xE9quipe",
    "__stack-auto-translation-160": "L'op\xE9ration de connexion a \xE9t\xE9 annul\xE9e. Veuillez r\xE9essayer. [access_denied]",
    "__stack-auto-translation-161": "L'utilisateur est d\xE9j\xE0 connect\xE9 \xE0 un autre compte OAuth. Avez-vous peut-\xEAtre s\xE9lectionn\xE9 le mauvais compte sur la page du fournisseur OAuth ?",
    "__stack-auto-translation-162": "Ensuite, saisissez votre code MFA \xE0 six chiffres :",
    "__stack-auto-translation-163": "Ce compte est d\xE9j\xE0 connect\xE9 \xE0 un autre utilisateur. Veuillez connecter un compte diff\xE9rent.",
    "__stack-auto-translation-164": "Cet e-mail est d\xE9j\xE0 utilis\xE9 pour la connexion par un autre utilisateur.",
    "__stack-auto-translation-165": "Il s'agit d'un nom d'affichage et n'est pas utilis\xE9 pour l'authentification",
    "__stack-auto-translation-166": "Il s'agit probablement d'une erreur dans Stack. Veuillez la signaler.",
    "__stack-auto-translation-167": "Ce lien de r\xE9initialisation de mot de passe a d\xE9j\xE0 \xE9t\xE9 utilis\xE9. Si vous devez \xE0 nouveau r\xE9initialiser votre mot de passe, veuillez demander un nouveau lien de r\xE9initialisation depuis la page de connexion.",
    "__stack-auto-translation-168": "Ce lien d'invitation d'\xE9quipe a d\xE9j\xE0 \xE9t\xE9 utilis\xE9.",
    "__stack-auto-translation-169": "Pour activer la connexion OTP, veuillez ajouter une adresse e-mail de connexion v\xE9rifi\xE9e.",
    "__stack-auto-translation-17": "Cr\xE9er une \xE9quipe",
    "__stack-auto-translation-170": "Pour activer la connexion par cl\xE9 d'acc\xE8s, veuillez ajouter une adresse e-mail de connexion v\xE9rifi\xE9e.",
    "__stack-auto-translation-171": "Pour d\xE9finir un mot de passe, veuillez ajouter une adresse e-mail de connexion.",
    "__stack-auto-translation-172": "Changer de th\xE8me",
    "__stack-auto-translation-173": "TOTP Code QR d'authentification \xE0 plusieurs facteurs",
    "__stack-auto-translation-174": "Non v\xE9rifi\xE9",
    "__stack-auto-translation-175": "Mettre \xE0 jour le mot de passe",
    "__stack-auto-translation-176": "Mettre \xE0 jour le mot de passe",
    "__stack-auto-translation-177": "Mettez \xE0 jour votre mot de passe",
    "__stack-auto-translation-178": "T\xE9l\xE9chargez une image pour votre \xE9quipe",
    "__stack-auto-translation-179": "T\xE9l\xE9chargez votre propre image comme avatar",
    "__stack-auto-translation-18": "\xC9quipe actuelle",
    "__stack-auto-translation-180": "Utiliser pour la connexion",
    "__stack-auto-translation-181": "Utilis\xE9 pour la connexion",
    "__stack-auto-translation-182": "Lien de r\xE9initialisation de mot de passe utilis\xE9",
    "__stack-auto-translation-183": "Lien d'invitation d'\xE9quipe d\xE9j\xE0 utilis\xE9",
    "__stack-auto-translation-184": "Utilisateur",
    "__stack-auto-translation-185": "Nom d'utilisateur",
    "__stack-auto-translation-186": "V\xE9rifier",
    "__stack-auto-translation-187": "Vous \xEAtes d\xE9j\xE0 connect\xE9",
    "__stack-auto-translation-188": "Vous n'\xEAtes pas connect\xE9 actuellement.",
    "__stack-auto-translation-189": "Vous ne pouvez pas supprimer votre derni\xE8re adresse e-mail de connexion",
    "__stack-auto-translation-19": "Zone dangereuse",
    "__stack-auto-translation-190": "Votre email a \xE9t\xE9 v\xE9rifi\xE9 !",
    "__stack-auto-translation-191": "Votre e-mail",
    "__stack-auto-translation-192": "Votre lien de v\xE9rification d'e-mail a expir\xE9. Veuillez demander un nouveau lien de v\xE9rification dans les param\xE8tres de votre compte.",
    "__stack-auto-translation-193": "Votre lien magique a expir\xE9. Veuillez demander un nouveau lien magique si vous avez besoin de vous connecter.",
    "__stack-auto-translation-194": "Votre mot de passe a \xE9t\xE9 r\xE9initialis\xE9. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "__stack-auto-translation-195": "Votre lien de r\xE9initialisation du mot de passe a expir\xE9. Veuillez demander un nouveau lien de r\xE9initialisation du mot de passe \xE0 partir de la page de connexion.",
    "__stack-auto-translation-196": "Votre lien d'invitation d'\xE9quipe a expir\xE9. Veuillez demander un nouveau lien d'invitation d'\xE9quipe ",
    "__stack-auto-translation-2": "Ajouter",
    "__stack-auto-translation-20": "Supprimer le compte",
    "__stack-auto-translation-21": "Supprimer le compte",
    "__stack-auto-translation-22": "Supprimer la cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-23": "D\xE9sactiver",
    "__stack-auto-translation-24": "D\xE9sactiver MFA",
    "__stack-auto-translation-25": "D\xE9sactiver l'OTP",
    "__stack-auto-translation-26": "Nom d'affichage",
    "__stack-auto-translation-27": "Voulez-vous vous connecter ?",
    "__stack-auto-translation-28": "Voulez-vous v\xE9rifier votre e-mail ?",
    "__stack-auto-translation-29": "Vous n'avez pas de compte ?",
    "__stack-auto-translation-3": "Ajouter un e-mail",
    "__stack-auto-translation-30": "Pas besoin de r\xE9initialiser ?",
    "__stack-auto-translation-31": "Adresse e-mail",
    "__stack-auto-translation-32": "Email et mot de passe",
    "__stack-auto-translation-33": "Cet email existe d\xE9j\xE0",
    "__stack-auto-translation-34": "L'adresse e-mail est requise",
    "__stack-auto-translation-35": "Email envoy\xE9 !",
    "__stack-auto-translation-36": "E-mails",
    "__stack-auto-translation-37": "E-mails et authentification",
    "__stack-auto-translation-38": "Activer l'AMF",
    "__stack-auto-translation-39": "Activer l'OTP",
    "__stack-auto-translation-4": "Ajouter une nouvelle cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-40": "Activer la connexion via un lien magique ou un OTP envoy\xE9 \xE0 vos e-mails de connexion.",
    "__stack-auto-translation-41": "Mettre fin \xE0 votre session actuelle",
    "__stack-auto-translation-42": "Entrez un nom d'affichage pour votre nouvelle \xE9quipe",
    "__stack-auto-translation-43": "Saisir l'adresse e-mail",
    "__stack-auto-translation-44": "Saisissez le code re\xE7u par e-mail",
    "__stack-auto-translation-45": "Lien magique expir\xE9",
    "__stack-auto-translation-46": "Lien de r\xE9initialisation de mot de passe expir\xE9",
    "__stack-auto-translation-47": "Lien d'invitation d'\xE9quipe expir\xE9",
    "__stack-auto-translation-48": "Lien de v\xE9rification expir\xE9",
    "__stack-auto-translation-49": "Expire",
    "__stack-auto-translation-5": "Vous avez d\xE9j\xE0 un compte ?",
    "__stack-auto-translation-50": "\xC9chec de la connexion du compte",
    "__stack-auto-translation-51": "\xC9chec de la r\xE9initialisation du mot de passe",
    "__stack-auto-translation-52": "\xC9chec de la r\xE9initialisation du mot de passe. Veuillez demander un nouveau lien de r\xE9initialisation du mot de passe",
    "__stack-auto-translation-53": "Mot de passe oubli\xE9 ?",
    "__stack-auto-translation-54": "Accueil",
    "__stack-auto-translation-55": "Accueil",
    "__stack-auto-translation-56": "Si l'utilisateur avec cette adresse e-mail existe, un e-mail a \xE9t\xE9 envoy\xE9 dans votre bo\xEEte de r\xE9ception. Assurez-vous de v\xE9rifier votre dossier de courrier ind\xE9sirable.",
    "__stack-auto-translation-57": "Si vous n'\xEAtes pas redirig\xE9 automatiquement, ",
    "__stack-auto-translation-58": "Ignorer",
    "__stack-auto-translation-59": "Code incorrect. Veuillez r\xE9essayer.",
    "__stack-auto-translation-6": "Une erreur inconnue s'est produite",
    "__stack-auto-translation-60": "Mot de passe incorrect",
    "__stack-auto-translation-61": "Code invalide",
    "__stack-auto-translation-62": "Image invalide",
    "__stack-auto-translation-63": "Lien magique invalide",
    "__stack-auto-translation-64": "Lien de r\xE9initialisation de mot de passe non valide",
    "__stack-auto-translation-65": "Lien d'invitation d'\xE9quipe non valide",
    "__stack-auto-translation-66": "Code TOTP invalide",
    "__stack-auto-translation-67": "Lien de v\xE9rification invalide",
    "__stack-auto-translation-68": "Invitez un utilisateur \xE0 rejoindre votre \xE9quipe par e-mail",
    "__stack-auto-translation-69": "Inviter un membre",
    "__stack-auto-translation-7": "\xCAtes-vous s\xFBr de vouloir supprimer votre compte ? Cette action est IRR\xC9VERSIBLE et supprimera TOUTES les donn\xE9es associ\xE9es.",
    "__stack-auto-translation-70": "Inviter l'utilisateur",
    "__stack-auto-translation-71": "Rejoindre",
    "__stack-auto-translation-72": "Quitter",
    "__stack-auto-translation-73": "Quitter l'\xE9quipe",
    "__stack-auto-translation-74": "Quitter l'\xE9quipe",
    "__stack-auto-translation-75": "quitter cette \xE9quipe et supprimer votre profil d'\xE9quipe",
    "__stack-auto-translation-76": "Lien magique d\xE9j\xE0 utilis\xE9",
    "__stack-auto-translation-77": "Membres",
    "__stack-auto-translation-78": "Authentification \xE0 plusieurs facteurs",
    "__stack-auto-translation-79": "L'authentification \xE0 deux facteurs est actuellement d\xE9sactiv\xE9e.",
    "__stack-auto-translation-8": "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver la connexion OTP ? Vous ne pourrez plus vous connecter uniquement avec des e-mails.",
    "__stack-auto-translation-80": "L'authentification \xE0 plusieurs facteurs est actuellement activ\xE9e.",
    "__stack-auto-translation-81": "Mon profil",
    "__stack-auto-translation-82": "Nom",
    "__stack-auto-translation-83": "L'inscription de nouveaux comptes n'est pas autoris\xE9e",
    "__stack-auto-translation-84": "Nouveau mot de passe",
    "__stack-auto-translation-85": "Nouveau mot de passe",
    "__stack-auto-translation-86": "Aucune m\xE9thode d'authentification activ\xE9e.",
    "__stack-auto-translation-87": "Aucune \xE9quipe pour l'instant",
    "__stack-auto-translation-88": "Non connect\xE9",
    "__stack-auto-translation-89": "Acc\xE8s refus\xE9 par le fournisseur OAuth",
    "__stack-auto-translation-9": "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver la connexion par cl\xE9 d'acc\xE8s ? Vous ne pourrez plus vous connecter avec votre cl\xE9 d'acc\xE8s.",
    "__stack-auto-translation-90": "Ancien mot de passe",
    "__stack-auto-translation-91": "Ou continuer avec",
    "__stack-auto-translation-92": "Autres \xE9quipes",
    "__stack-auto-translation-93": "Connexion OTP",
    "__stack-auto-translation-94": "La connexion OTP est activ\xE9e et ne peut pas \xEAtre d\xE9sactiv\xE9e car c'est actuellement la seule m\xE9thode de connexion",
    "__stack-auto-translation-95": "La connexion par OTP/lien magique est actuellement activ\xE9e.",
    "__stack-auto-translation-96": "Invitations en attente",
    "__stack-auto-translation-97": "Remplacez votre nom d'affichage d'utilisateur dans cette \xE9quipe",
    "__stack-auto-translation-98": "Cl\xE9 d'acc\xE8s",
    "__stack-auto-translation-99": "Cl\xE9 d'acc\xE8s enregistr\xE9e"
  })),
  "it-IT": new Map(typedEntries({
    "__stack-auto-translation-0": "Impostazioni account",
    "__stack-auto-translation-1": "Impostazioni Account",
    "__stack-auto-translation-10": "Sei sicuro di voler lasciare il team?",
    "__stack-auto-translation-100": "L'accesso con Passkey \xE8 attivo e non pu\xF2 essere disattivato poich\xE9 \xE8 attualmente l'unico metodo di accesso",
    "__stack-auto-translation-101": "Password",
    "__stack-auto-translation-102": "Password reimpostata con successo!",
    "__stack-auto-translation-103": "Le password non corrispondono",
    "__stack-auto-translation-104": "Rimuovi permanentemente il tuo account e tutti i dati associati",
    "__stack-auto-translation-105": "Verificare di avere il link corretto. Se continui ad avere problemi, contatta l'assistenza.",
    "__stack-auto-translation-106": "Si prega di verificare di avere il link corretto per il ripristino della password.",
    "__stack-auto-translation-107": "Verifica di avere il link di invito al team corretto.",
    "__stack-auto-translation-108": "Inserisci un nome per il team",
    "__stack-auto-translation-109": "Inserisci un indirizzo email valido",
    "__stack-auto-translation-11": "Annulla",
    "__stack-auto-translation-110": "Inserisci un indirizzo email valido",
    "__stack-auto-translation-111": "Si prega di inserire un indirizzo email",
    "__stack-auto-translation-112": "Inserisci il tuo indirizzo email",
    "__stack-auto-translation-113": "Inserisci la tua vecchia password",
    "__stack-auto-translation-114": "Inserisci la tua password",
    "__stack-auto-translation-115": "Per favore ripeti la tua password",
    "__stack-auto-translation-116": "Si prega di riprovare e se il problema persiste, contattare l'assistenza.",
    "__stack-auto-translation-117": "Per favore verifica prima la tua email",
    "__stack-auto-translation-118": "Principale",
    "__stack-auto-translation-119": "Immagine del profilo",
    "__stack-auto-translation-12": "Modifica il nome visualizzato del tuo team",
    "__stack-auto-translation-120": "Registra una passkey",
    "__stack-auto-translation-121": "Rimuovi",
    "__stack-auto-translation-122": "Ripeti nuova password",
    "__stack-auto-translation-123": "Ripeti Nuova Password",
    "__stack-auto-translation-124": "Ripeti Password",
    "__stack-auto-translation-125": "Reimposta Password",
    "__stack-auto-translation-126": "Reimposta la tua password",
    "__stack-auto-translation-127": "Salva",
    "__stack-auto-translation-128": "Scansiona questo codice QR con la tua app di autenticazione:",
    "__stack-auto-translation-129": "Invia email",
    "__stack-auto-translation-13": "clicca qui",
    "__stack-auto-translation-130": "Invia Email",
    "__stack-auto-translation-131": "Invia email di verifica",
    "__stack-auto-translation-132": "Imposta una password per il tuo account",
    "__stack-auto-translation-133": "Imposta come principale",
    "__stack-auto-translation-134": "Imposta password",
    "__stack-auto-translation-135": "Imposta Password",
    "__stack-auto-translation-136": "Impostazioni",
    "__stack-auto-translation-137": "Accedi",
    "__stack-auto-translation-138": "Accedi",
    "__stack-auto-translation-139": "Accedi di nuovo",
    "__stack-auto-translation-14": "Crea",
    "__stack-auto-translation-140": "Accedi o crea un account per unirti al team.",
    "__stack-auto-translation-141": "Accedi al tuo account",
    "__stack-auto-translation-142": "Accedi con Passkey",
    "__stack-auto-translation-143": "Accedi con {provider}",
    "__stack-auto-translation-144": "Esci",
    "__stack-auto-translation-145": "Registrati",
    "__stack-auto-translation-146": "Registrati",
    "__stack-auto-translation-147": "L'iscrizione per i nuovi utenti non \xE8 attualmente abilitata.",
    "__stack-auto-translation-148": "Registrati con Passkey",
    "__stack-auto-translation-149": "Registrati con {provider}",
    "__stack-auto-translation-15": "Crea un nuovo account",
    "__stack-auto-translation-150": "Accesso effettuato con successo!",
    "__stack-auto-translation-151": "Qualcosa \xE8 andato storto durante l'elaborazione del callback OAuth:",
    "__stack-auto-translation-152": "Interrompi l'utilizzo per l'accesso",
    "__stack-auto-translation-153": "La creazione del team non \xE8 abilitata",
    "__stack-auto-translation-154": "Nome visualizzato del team",
    "__stack-auto-translation-155": "Invito di squadra",
    "__stack-auto-translation-156": "Immagine del profilo del team",
    "__stack-auto-translation-157": "Nome utente del team",
    "__stack-auto-translation-158": "Team",
    "__stack-auto-translation-159": "Il link magico \xE8 gi\xE0 stato utilizzato. Il link pu\xF2 essere usato una sola volta. Si prega di richiedere un nuovo link magico se \xE8 necessario accedere nuovamente.",
    "__stack-auto-translation-16": "Crea un team",
    "__stack-auto-translation-160": "L'operazione di accesso \xE8 stata annullata. Si prega di riprovare. [access_denied]",
    "__stack-auto-translation-161": "L'utente \xE8 gi\xE0 collegato a un altro account OAuth. Hai forse selezionato l'account sbagliato nella pagina del provider OAuth?",
    "__stack-auto-translation-162": "Quindi, inserisci il tuo codice MFA a sei cifre:",
    "__stack-auto-translation-163": "Questo account \xE8 gi\xE0 collegato a un altro utente. Si prega di collegare un account diverso.",
    "__stack-auto-translation-164": "Questa email \xE8 gi\xE0 utilizzata per l'accesso da un altro utente.",
    "__stack-auto-translation-165": "Questo \xE8 un nome visualizzato e non viene utilizzato per l'autenticazione",
    "__stack-auto-translation-166": "Questo \xE8 molto probabilmente un errore in Stack. Si prega di segnalarlo.",
    "__stack-auto-translation-167": "Questo link per il ripristino della password \xE8 gi\xE0 stato utilizzato. Se hai bisogno di reimpostare nuovamente la tua password, richiedi un nuovo link per il ripristino dalla pagina di accesso.",
    "__stack-auto-translation-168": "Questo link di invito al team \xE8 gi\xE0 stato utilizzato.",
    "__stack-auto-translation-169": "Per abilitare l'accesso con OTP, aggiungi un'email di accesso verificata.",
    "__stack-auto-translation-17": "Crea un Team",
    "__stack-auto-translation-170": "Per abilitare l'accesso con Passkey, aggiungi un'email di accesso verificata.",
    "__stack-auto-translation-171": "Per impostare una password, aggiungi un'email di accesso.",
    "__stack-auto-translation-172": "Cambia tema",
    "__stack-auto-translation-173": "Codice QR per l'autenticazione a pi\xF9 fattori TOTP",
    "__stack-auto-translation-174": "Non verificato",
    "__stack-auto-translation-175": "Aggiorna password",
    "__stack-auto-translation-176": "Aggiorna Password",
    "__stack-auto-translation-177": "Aggiorna la tua password",
    "__stack-auto-translation-178": "Carica un'immagine per il tuo team",
    "__stack-auto-translation-179": "Carica la tua immagine come avatar",
    "__stack-auto-translation-18": "Team attuale",
    "__stack-auto-translation-180": "Usa per l'accesso",
    "__stack-auto-translation-181": "Usato per l'accesso",
    "__stack-auto-translation-182": "Link per il ripristino della password gi\xE0 utilizzato",
    "__stack-auto-translation-183": "Link di invito al team gi\xE0 utilizzato",
    "__stack-auto-translation-184": "Utente",
    "__stack-auto-translation-185": "Nome utente",
    "__stack-auto-translation-186": "Verifica",
    "__stack-auto-translation-187": "Hai gi\xE0 effettuato l'accesso",
    "__stack-auto-translation-188": "Non sei attualmente autenticato.",
    "__stack-auto-translation-189": "Non puoi rimuovere la tua ultima email di accesso",
    "__stack-auto-translation-19": "Zona pericolosa",
    "__stack-auto-translation-190": "La tua email \xE8 stata verificata!",
    "__stack-auto-translation-191": "La tua email",
    "__stack-auto-translation-192": "Il tuo link di verifica dell'email \xE8 scaduto. Richiedi un nuovo link di verifica dalle impostazioni del tuo account.",
    "__stack-auto-translation-193": "Il tuo link magico \xE8 scaduto. Richiedi un nuovo link magico se hai bisogno di accedere.",
    "__stack-auto-translation-194": "La tua password \xE8 stata reimpostata. Ora puoi accedere con la tua nuova password.",
    "__stack-auto-translation-195": "Il tuo link per il reset della password \xE8 scaduto. Ti preghiamo di richiedere un nuovo link per il reset della password dalla pagina di accesso.",
    "__stack-auto-translation-196": "Il tuo link di invito al team \xE8 scaduto. Per favore richiedi un nuovo link di invito al team ",
    "__stack-auto-translation-2": "Aggiungi",
    "__stack-auto-translation-20": "Elimina account",
    "__stack-auto-translation-21": "Elimina Account",
    "__stack-auto-translation-22": "Elimina Passkey",
    "__stack-auto-translation-23": "Disattiva",
    "__stack-auto-translation-24": "Disattiva MFA",
    "__stack-auto-translation-25": "Disattiva OTP",
    "__stack-auto-translation-26": "Nome visualizzato",
    "__stack-auto-translation-27": "Vuoi accedere?",
    "__stack-auto-translation-28": "Vuoi verificare la tua email?",
    "__stack-auto-translation-29": "Non hai un account?",
    "__stack-auto-translation-3": "Aggiungi un'email",
    "__stack-auto-translation-30": "Non hai bisogno di reimpostare?",
    "__stack-auto-translation-31": "Email",
    "__stack-auto-translation-32": "Email e password",
    "__stack-auto-translation-33": "L'indirizzo email esiste gi\xE0",
    "__stack-auto-translation-34": "L'indirizzo email \xE8 obbligatorio",
    "__stack-auto-translation-35": "Email inviato!",
    "__stack-auto-translation-36": "Email",
    "__stack-auto-translation-37": "Email e Autenticazione",
    "__stack-auto-translation-38": "Abilita MFA",
    "__stack-auto-translation-39": "Abilita OTP",
    "__stack-auto-translation-4": "Aggiungi nuova passkey",
    "__stack-auto-translation-40": "Abilita l'accesso tramite link magico o OTP inviato alle tue email di accesso.",
    "__stack-auto-translation-41": "Termina la sessione corrente",
    "__stack-auto-translation-42": "Inserisci un nome visualizzato per il tuo nuovo team",
    "__stack-auto-translation-43": "Inserisci email",
    "__stack-auto-translation-44": "Inserti il codice ricevuto via email",
    "__stack-auto-translation-45": "Link magico scaduto",
    "__stack-auto-translation-46": "Link per il Reset della Password Scaduto",
    "__stack-auto-translation-47": "Link di invito al team scaduto",
    "__stack-auto-translation-48": "Link di verifica scaduto",
    "__stack-auto-translation-49": "Scade",
    "__stack-auto-translation-5": "Hai gi\xE0 un account?",
    "__stack-auto-translation-50": "Impossibile connettere l'account",
    "__stack-auto-translation-51": "Impossibile reimpostare la password",
    "__stack-auto-translation-52": "Impossibile reimpostare la password. Si prega di richiedere un nuovo link per il reset della password",
    "__stack-auto-translation-53": "Password dimenticata?",
    "__stack-auto-translation-54": "Vai alla home",
    "__stack-auto-translation-55": "Vai alla home",
    "__stack-auto-translation-56": "Se l'utente con questo indirizzo e-mail esiste, un'e-mail \xE8 stata inviata alla tua casella di posta. Assicurati di controllare la cartella dello spam.",
    "__stack-auto-translation-57": "Se non vieni reindirizzato automaticamente, ",
    "__stack-auto-translation-58": "Ignora",
    "__stack-auto-translation-59": "Codice errato. Per favore riprova.",
    "__stack-auto-translation-6": "Si \xE8 verificato un errore sconosciuto",
    "__stack-auto-translation-60": "Password non corretta",
    "__stack-auto-translation-61": "Codice non valido",
    "__stack-auto-translation-62": "Immagine non valida",
    "__stack-auto-translation-63": "Link Magico Non Valido",
    "__stack-auto-translation-64": "Link di Reimpostazione Password Non Valido",
    "__stack-auto-translation-65": "Link di invito al team non valido",
    "__stack-auto-translation-66": "Codice TOTP non valido",
    "__stack-auto-translation-67": "Link di verifica non valido",
    "__stack-auto-translation-68": "Invita un utente al tuo team tramite email",
    "__stack-auto-translation-69": "Invita membro",
    "__stack-auto-translation-7": "Sei sicuro di voler eliminare il tuo account? Questa azione \xE8 IRREVERSIBILE e canceller\xE0 TUTTI i dati associati.",
    "__stack-auto-translation-70": "Invita Utente",
    "__stack-auto-translation-71": "Unisciti",
    "__stack-auto-translation-72": "Abbandona",
    "__stack-auto-translation-73": "Lascia il team",
    "__stack-auto-translation-74": "Lascia il Team",
    "__stack-auto-translation-75": "lasciare questa squadra e rimuovere il tuo profilo di team",
    "__stack-auto-translation-76": "Il link magico \xE8 gi\xE0 stato utilizzato",
    "__stack-auto-translation-77": "Membri",
    "__stack-auto-translation-78": "Autenticazione a pi\xF9 fattori",
    "__stack-auto-translation-79": "L'autenticazione a pi\xF9 fattori \xE8 attualmente disabilitata.",
    "__stack-auto-translation-8": "Sei sicuro di voler disattivare l'accesso con OTP? Non potrai pi\xF9 accedere solo con le email.",
    "__stack-auto-translation-80": "L'autenticazione a pi\xF9 fattori \xE8 attualmente attiva.",
    "__stack-auto-translation-81": "Il mio profilo",
    "__stack-auto-translation-82": "Nome",
    "__stack-auto-translation-83": "La registrazione di nuovi account non \xE8 consentita",
    "__stack-auto-translation-84": "Nuova password",
    "__stack-auto-translation-85": "Nuova Password",
    "__stack-auto-translation-86": "Nessun metodo di autenticazione abilitato.",
    "__stack-auto-translation-87": "Nessun team ancora",
    "__stack-auto-translation-88": "Non hai effettuato l'accesso",
    "__stack-auto-translation-89": "Accesso al provider OAuth negato",
    "__stack-auto-translation-9": "Sei sicuro di voler disattivare l'accesso con Passkey? Non potrai pi\xF9 accedere utilizzando la tua passkey.",
    "__stack-auto-translation-90": "Vecchia password",
    "__stack-auto-translation-91": "Oppure continua con",
    "__stack-auto-translation-92": "Altri team",
    "__stack-auto-translation-93": "Accesso con OTP",
    "__stack-auto-translation-94": "L'accesso con OTP \xE8 abilitato e non pu\xF2 essere disattivato poich\xE9 \xE8 attualmente l'unico metodo di accesso disponibile",
    "__stack-auto-translation-95": "L'accesso tramite OTP/link magico \xE8 attualmente abilitato.",
    "__stack-auto-translation-96": "Inviti in sospeso",
    "__stack-auto-translation-97": "Sovrascrivi il tuo nome utente visualizzato in questo team",
    "__stack-auto-translation-98": "Passkey",
    "__stack-auto-translation-99": "Passkey registrata"
  })),
  "pt-BR": new Map(typedEntries({
    "__stack-auto-translation-0": "Configura\xE7\xF5es da conta",
    "__stack-auto-translation-1": "Configura\xE7\xF5es da Conta",
    "__stack-auto-translation-10": "Tem certeza de que deseja sair da equipe?",
    "__stack-auto-translation-100": "O acesso por chave de acesso est\xE1 habilitado e n\xE3o pode ser desativado, pois \xE9 atualmente o \xFAnico m\xE9todo de acesso",
    "__stack-auto-translation-101": "Senha",
    "__stack-auto-translation-102": "Senha redefinida com sucesso!",
    "__stack-auto-translation-103": "As senhas n\xE3o coincidem",
    "__stack-auto-translation-104": "Remover permanentemente sua conta e todos os dados associados",
    "__stack-auto-translation-105": "Verifique se voc\xEA tem o link correto. Se continuar tendo problemas, entre em contato com o suporte.",
    "__stack-auto-translation-106": "Verifique novamente se voc\xEA tem o link correto para redefini\xE7\xE3o de senha.",
    "__stack-auto-translation-107": "Por favor, verifique se voc\xEA tem o link de convite para a equipe correto.",
    "__stack-auto-translation-108": "Por favor, insira um nome para a equipe",
    "__stack-auto-translation-109": "Por favor, insira um e-mail v\xE1lido",
    "__stack-auto-translation-11": "Cancelar",
    "__stack-auto-translation-110": "Insira um endere\xE7o de e-mail v\xE1lido",
    "__stack-auto-translation-111": "Por favor, insira um endere\xE7o de e-mail",
    "__stack-auto-translation-112": "Por favor, insira seu e-mail",
    "__stack-auto-translation-113": "Por favor, digite sua senha antiga",
    "__stack-auto-translation-114": "Insira sua senha",
    "__stack-auto-translation-115": "Por favor, repita sua senha",
    "__stack-auto-translation-116": "Por favor, tente novamente e, se o problema persistir, entre em contato com o suporte.",
    "__stack-auto-translation-117": "Por favor, verifique seu email primeiro",
    "__stack-auto-translation-118": "Prim\xE1rio",
    "__stack-auto-translation-119": "Imagem de perfil",
    "__stack-auto-translation-12": "Alterar o nome de exibi\xE7\xE3o da sua equipe",
    "__stack-auto-translation-120": "Registrar uma chave de acesso",
    "__stack-auto-translation-121": "Remover",
    "__stack-auto-translation-122": "Repita a nova senha",
    "__stack-auto-translation-123": "Repita a Nova Senha",
    "__stack-auto-translation-124": "Repetir Senha",
    "__stack-auto-translation-125": "Redefinir Senha",
    "__stack-auto-translation-126": "Redefina Sua Senha",
    "__stack-auto-translation-127": "Salvar",
    "__stack-auto-translation-128": "Escaneie este c\xF3digo QR com seu aplicativo autenticador:",
    "__stack-auto-translation-129": "Enviar e-mail",
    "__stack-auto-translation-13": "clique aqui",
    "__stack-auto-translation-130": "Enviar Email",
    "__stack-auto-translation-131": "Enviar email de verifica\xE7\xE3o",
    "__stack-auto-translation-132": "Defina uma senha para sua conta",
    "__stack-auto-translation-133": "Definir como prim\xE1rio",
    "__stack-auto-translation-134": "Definir senha",
    "__stack-auto-translation-135": "Definir Senha",
    "__stack-auto-translation-136": "Configura\xE7\xF5es",
    "__stack-auto-translation-137": "Entrar",
    "__stack-auto-translation-138": "Entrar",
    "__stack-auto-translation-139": "Entrar novamente",
    "__stack-auto-translation-14": "Criar",
    "__stack-auto-translation-140": "Fa\xE7a login ou crie uma conta para se juntar \xE0 equipe.",
    "__stack-auto-translation-141": "Entrar na sua conta",
    "__stack-auto-translation-142": "Entrar com Passkey",
    "__stack-auto-translation-143": "Entrar com {provider}",
    "__stack-auto-translation-144": "Sair",
    "__stack-auto-translation-145": "Cadastrar-se",
    "__stack-auto-translation-146": "Cadastrar-se",
    "__stack-auto-translation-147": "O cadastro para novos usu\xE1rios n\xE3o est\xE1 dispon\xEDvel no momento.",
    "__stack-auto-translation-148": "Cadastre-se com Passkey",
    "__stack-auto-translation-149": "Cadastre-se com o {provider}",
    "__stack-auto-translation-15": "Criar uma nova conta",
    "__stack-auto-translation-150": "Login realizado com sucesso!",
    "__stack-auto-translation-151": "Algo deu errado ao processar o retorno de chamada OAuth:",
    "__stack-auto-translation-152": "Parar de usar para login",
    "__stack-auto-translation-153": "Cria\xE7\xE3o de equipe n\xE3o est\xE1 habilitada",
    "__stack-auto-translation-154": "Nome de exibi\xE7\xE3o da equipe",
    "__stack-auto-translation-155": "Convite para equipe",
    "__stack-auto-translation-156": "Imagem de perfil da equipe",
    "__stack-auto-translation-157": "Nome de usu\xE1rio na equipe",
    "__stack-auto-translation-158": "Equipes",
    "__stack-auto-translation-159": "O link m\xE1gico j\xE1 foi utilizado. O link s\xF3 pode ser usado uma vez. Por favor, solicite um novo link m\xE1gico se precisar fazer login novamente.",
    "__stack-auto-translation-16": "Criar uma equipe",
    "__stack-auto-translation-160": "A opera\xE7\xE3o de login foi cancelada. Por favor, tente novamente. [access_denied]",
    "__stack-auto-translation-161": "O usu\xE1rio j\xE1 est\xE1 conectado a outra conta OAuth. Voc\xEA pode ter selecionado a conta errada na p\xE1gina do provedor OAuth?",
    "__stack-auto-translation-162": "Em seguida, insira seu c\xF3digo MFA de seis d\xEDgitos:",
    "__stack-auto-translation-163": "Esta conta j\xE1 est\xE1 conectada a outro usu\xE1rio. Por favor, conecte uma conta diferente.",
    "__stack-auto-translation-164": "Este email j\xE1 est\xE1 sendo usado para login por outro usu\xE1rio.",
    "__stack-auto-translation-165": "Este \xE9 um nome de exibi\xE7\xE3o e n\xE3o \xE9 usado para autentica\xE7\xE3o",
    "__stack-auto-translation-166": "Isto \xE9 provavelmente um erro no Stack. Por favor, reporte-o.",
    "__stack-auto-translation-167": "Este link de redefini\xE7\xE3o de senha j\xE1 foi utilizado. Se voc\xEA precisar redefinir sua senha novamente, solicite um novo link de redefini\xE7\xE3o de senha na p\xE1gina de login.",
    "__stack-auto-translation-168": "Este link de convite para a equipe j\xE1 foi utilizado.",
    "__stack-auto-translation-169": "Para habilitar a autentica\xE7\xE3o por OTP, adicione um email de login verificado.",
    "__stack-auto-translation-17": "Criar uma Equipe",
    "__stack-auto-translation-170": "Para habilitar o login por chave de acesso, adicione um email de login verificado.",
    "__stack-auto-translation-171": "Para definir uma senha, adicione um email de login.",
    "__stack-auto-translation-172": "Alternar tema",
    "__stack-auto-translation-173": "C\xF3digo QR de autentica\xE7\xE3o de dois fatores TOTP",
    "__stack-auto-translation-174": "N\xE3o verificado",
    "__stack-auto-translation-175": "Atualizar senha",
    "__stack-auto-translation-176": "Atualizar Senha",
    "__stack-auto-translation-177": "Atualize sua senha",
    "__stack-auto-translation-178": "Envie uma imagem para sua equipe",
    "__stack-auto-translation-179": "Envie sua pr\xF3pria imagem como seu avatar",
    "__stack-auto-translation-18": "Equipe atual",
    "__stack-auto-translation-180": "Usar para login",
    "__stack-auto-translation-181": "Usado para login",
    "__stack-auto-translation-182": "Link de Redefini\xE7\xE3o de Senha Utilizado",
    "__stack-auto-translation-183": "Link de Convite de Equipe Usado",
    "__stack-auto-translation-184": "Usu\xE1rio",
    "__stack-auto-translation-185": "Nome de usu\xE1rio",
    "__stack-auto-translation-186": "Verificar",
    "__stack-auto-translation-187": "Voc\xEA j\xE1 est\xE1 conectado",
    "__stack-auto-translation-188": "Voc\xEA n\xE3o est\xE1 atualmente conectado.",
    "__stack-auto-translation-189": "Voc\xEA n\xE3o pode remover seu \xFAltimo email de login",
    "__stack-auto-translation-19": "Zona de perigo",
    "__stack-auto-translation-190": "Seu email foi verificado!",
    "__stack-auto-translation-191": "Seu E-mail",
    "__stack-auto-translation-192": "Seu link de verifica\xE7\xE3o de e-mail expirou. Por favor, solicite um novo link de verifica\xE7\xE3o nas configura\xE7\xF5es da sua conta.",
    "__stack-auto-translation-193": "Seu link m\xE1gico expirou. Por favor, solicite um novo link m\xE1gico se precisar fazer login.",
    "__stack-auto-translation-194": "Sua senha foi redefinida. Agora voc\xEA pode fazer login com sua nova senha.",
    "__stack-auto-translation-195": "Seu link de redefini\xE7\xE3o de senha expirou. Por favor, solicite um novo link de redefini\xE7\xE3o de senha na p\xE1gina de login.",
    "__stack-auto-translation-196": "Seu link de convite para a equipe expirou. Solicite um novo link de convite para a equipe ",
    "__stack-auto-translation-2": "Adicionar",
    "__stack-auto-translation-20": "Excluir conta",
    "__stack-auto-translation-21": "Excluir Conta",
    "__stack-auto-translation-22": "Excluir Chave de acesso",
    "__stack-auto-translation-23": "Desativar",
    "__stack-auto-translation-24": "Desativar MFA",
    "__stack-auto-translation-25": "Desativar OTP",
    "__stack-auto-translation-26": "Nome de exibi\xE7\xE3o",
    "__stack-auto-translation-27": "Deseja entrar?",
    "__stack-auto-translation-28": "Deseja verificar seu email?",
    "__stack-auto-translation-29": "N\xE3o tem uma conta?",
    "__stack-auto-translation-3": "Adicionar um e-mail",
    "__stack-auto-translation-30": "N\xE3o precisa redefinir?",
    "__stack-auto-translation-31": "Email",
    "__stack-auto-translation-32": "Email e Senha",
    "__stack-auto-translation-33": "E-mail j\xE1 existe",
    "__stack-auto-translation-34": "E-mail \xE9 obrigat\xF3rio",
    "__stack-auto-translation-35": "E-mail enviado!",
    "__stack-auto-translation-36": "E-mails",
    "__stack-auto-translation-37": "E-mails & Autentica\xE7\xE3o",
    "__stack-auto-translation-38": "Habilitar MFA",
    "__stack-auto-translation-39": "Habilitar OTP",
    "__stack-auto-translation-4": "Adicionar nova chave de acesso",
    "__stack-auto-translation-40": "Habilitar login via link m\xE1gico ou OTP enviado para seus e-mails de acesso.",
    "__stack-auto-translation-41": "Encerre sua sess\xE3o atual",
    "__stack-auto-translation-42": "Insira um nome de exibi\xE7\xE3o para sua nova equipe",
    "__stack-auto-translation-43": "Inserir email",
    "__stack-auto-translation-44": "Digite o c\xF3digo do seu e-mail",
    "__stack-auto-translation-45": "Link M\xE1gico Expirado",
    "__stack-auto-translation-46": "Link de Redefini\xE7\xE3o de Senha Expirado",
    "__stack-auto-translation-47": "Link de Convite de Equipe Expirado",
    "__stack-auto-translation-48": "Link de Verifica\xE7\xE3o Expirado",
    "__stack-auto-translation-49": "Expira",
    "__stack-auto-translation-5": "J\xE1 tem uma conta?",
    "__stack-auto-translation-50": "Falha ao conectar conta",
    "__stack-auto-translation-51": "Falha ao redefinir senha",
    "__stack-auto-translation-52": "Falha ao redefinir a senha. Por favor, solicite um novo link de redefini\xE7\xE3o de senha",
    "__stack-auto-translation-53": "Esqueceu a senha?",
    "__stack-auto-translation-54": "Ir para in\xEDcio",
    "__stack-auto-translation-55": "Ir para in\xEDcio",
    "__stack-auto-translation-56": "Se o usu\xE1rio com este endere\xE7o de e-mail existir, um e-mail foi enviado para sua caixa de entrada. Certifique-se de verificar sua pasta de spam.",
    "__stack-auto-translation-57": "Se voc\xEA n\xE3o for redirecionado automaticamente, ",
    "__stack-auto-translation-58": "Ignorar",
    "__stack-auto-translation-59": "C\xF3digo incorreto. Por favor, tente novamente.",
    "__stack-auto-translation-6": "Um erro desconhecido ocorreu",
    "__stack-auto-translation-60": "Senha incorreta",
    "__stack-auto-translation-61": "C\xF3digo inv\xE1lido",
    "__stack-auto-translation-62": "Imagem inv\xE1lida",
    "__stack-auto-translation-63": "Link M\xE1gico Inv\xE1lido",
    "__stack-auto-translation-64": "Link de Redefini\xE7\xE3o de Senha Inv\xE1lido",
    "__stack-auto-translation-65": "Link de Convite de Equipe Inv\xE1lido",
    "__stack-auto-translation-66": "C\xF3digo TOTP inv\xE1lido",
    "__stack-auto-translation-67": "Link de Verifica\xE7\xE3o Inv\xE1lido",
    "__stack-auto-translation-68": "Convide um usu\xE1rio para sua equipe por e-mail",
    "__stack-auto-translation-69": "Convidar membro",
    "__stack-auto-translation-7": "Tem certeza de que deseja excluir sua conta? Esta a\xE7\xE3o \xE9 IRREVERS\xCDVEL e excluir\xE1 TODOS os dados associados.",
    "__stack-auto-translation-70": "Convidar Usu\xE1rio",
    "__stack-auto-translation-71": "Entrar",
    "__stack-auto-translation-72": "Sair",
    "__stack-auto-translation-73": "Sair da equipe",
    "__stack-auto-translation-74": "Sair da Equipe",
    "__stack-auto-translation-75": "sair desta equipe e remover seu perfil de equipe",
    "__stack-auto-translation-76": "Link M\xE1gico J\xE1 Utilizado",
    "__stack-auto-translation-77": "Membros",
    "__stack-auto-translation-78": "Autentica\xE7\xE3o de m\xFAltiplos fatores",
    "__stack-auto-translation-79": "A autentica\xE7\xE3o de dois fatores est\xE1 atualmente desativada.",
    "__stack-auto-translation-8": "Tem certeza de que deseja desativar a autentica\xE7\xE3o por OTP? Voc\xEA n\xE3o poder\xE1 mais entrar apenas com e-mails.",
    "__stack-auto-translation-80": "Autentica\xE7\xE3o multifator est\xE1 atualmente ativada.",
    "__stack-auto-translation-81": "Meu Perfil",
    "__stack-auto-translation-82": "Nome",
    "__stack-auto-translation-83": "N\xE3o \xE9 permitido o registro de novas contas",
    "__stack-auto-translation-84": "Nova senha",
    "__stack-auto-translation-85": "Nova Senha",
    "__stack-auto-translation-86": "Nenhum m\xE9todo de autentica\xE7\xE3o habilitado.",
    "__stack-auto-translation-87": "Ainda sem equipes",
    "__stack-auto-translation-88": "N\xE3o conectado",
    "__stack-auto-translation-89": "Acesso ao provedor OAuth negado",
    "__stack-auto-translation-9": "Tem certeza que deseja desativar o login com chave de acesso? Voc\xEA n\xE3o poder\xE1 mais entrar com sua chave de acesso.",
    "__stack-auto-translation-90": "Senha antiga",
    "__stack-auto-translation-91": "Ou continuar com",
    "__stack-auto-translation-92": "Outras equipes",
    "__stack-auto-translation-93": "Autentica\xE7\xE3o por OTP",
    "__stack-auto-translation-94": "A autentica\xE7\xE3o por OTP est\xE1 habilitada e n\xE3o pode ser desativada, pois atualmente \xE9 o \xFAnico m\xE9todo de autentica\xE7\xE3o",
    "__stack-auto-translation-95": "O login por OTP/link m\xE1gico est\xE1 atualmente habilitado.",
    "__stack-auto-translation-96": "Convites pendentes",
    "__stack-auto-translation-97": "Substitua seu nome de exibi\xE7\xE3o de usu\xE1rio nesta equipe",
    "__stack-auto-translation-98": "Chave de acesso",
    "__stack-auto-translation-99": "Chave de acesso registrada"
  })),
  "pt-PT": new Map(typedEntries({
    "__stack-auto-translation-0": "Defini\xE7\xF5es da conta",
    "__stack-auto-translation-1": "Defini\xE7\xF5es da Conta",
    "__stack-auto-translation-10": "Tem a certeza de que deseja sair da equipa?",
    "__stack-auto-translation-100": "O in\xEDcio de sess\xE3o por chave de acesso est\xE1 ativo e n\xE3o pode ser desativado pois \xE9 atualmente o \xFAnico m\xE9todo de autentica\xE7\xE3o",
    "__stack-auto-translation-101": "Palavra-passe",
    "__stack-auto-translation-102": "Palavra-passe redefinida com sucesso!",
    "__stack-auto-translation-103": "As senhas n\xE3o coincidem",
    "__stack-auto-translation-104": "Remover permanentemente a sua conta e todos os dados associados",
    "__stack-auto-translation-105": "Por favor, verifique se tem o link correto. Se continuar a ter problemas, entre em contacto com o suporte.",
    "__stack-auto-translation-106": "Por favor, verifique novamente se tem o link correto para redefini\xE7\xE3o da palavra-passe.",
    "__stack-auto-translation-107": "Verifique novamente se possui o link de convite para a equipa correto.",
    "__stack-auto-translation-108": "Por favor, insira um nome para a equipa",
    "__stack-auto-translation-109": "Por favor, introduza um endere\xE7o de email v\xE1lido",
    "__stack-auto-translation-11": "Cancelar",
    "__stack-auto-translation-110": "Introduza um endere\xE7o de e-mail v\xE1lido",
    "__stack-auto-translation-111": "Por favor, introduza um endere\xE7o de e-mail",
    "__stack-auto-translation-112": "Introduza o seu email",
    "__stack-auto-translation-113": "Por favor, insira a sua palavra-passe antiga",
    "__stack-auto-translation-114": "Por favor, introduza a sua palavra-passe",
    "__stack-auto-translation-115": "Por favor, repita a sua palavra-passe",
    "__stack-auto-translation-116": "Tente novamente e, se o problema persistir, entre em contacto com o suporte.",
    "__stack-auto-translation-117": "Por favor, verifique o seu email primeiro",
    "__stack-auto-translation-118": "Principal",
    "__stack-auto-translation-119": "Imagem de perfil",
    "__stack-auto-translation-12": "Alterar o nome de apresenta\xE7\xE3o da sua equipa",
    "__stack-auto-translation-120": "Registar uma chave de acesso",
    "__stack-auto-translation-121": "Remover",
    "__stack-auto-translation-122": "Repetir nova palavra-passe",
    "__stack-auto-translation-123": "Repetir Nova Palavra-passe",
    "__stack-auto-translation-124": "Repita a palavra-passe",
    "__stack-auto-translation-125": "Redefinir Palavra-passe",
    "__stack-auto-translation-126": "Repor a Sua Palavra-passe",
    "__stack-auto-translation-127": "Guardar",
    "__stack-auto-translation-128": "Fa\xE7a scan deste c\xF3digo QR com a sua aplica\xE7\xE3o de autentica\xE7\xE3o:",
    "__stack-auto-translation-129": "Enviar e-mail",
    "__stack-auto-translation-13": "clique aqui",
    "__stack-auto-translation-130": "Enviar Email",
    "__stack-auto-translation-131": "Enviar email de verifica\xE7\xE3o",
    "__stack-auto-translation-132": "Defina uma palavra-passe para a sua conta",
    "__stack-auto-translation-133": "Definir como principal",
    "__stack-auto-translation-134": "Definir palavra-passe",
    "__stack-auto-translation-135": "Definir Palavra-passe",
    "__stack-auto-translation-136": "Defini\xE7\xF5es",
    "__stack-auto-translation-137": "Iniciar sess\xE3o",
    "__stack-auto-translation-138": "Iniciar Sess\xE3o",
    "__stack-auto-translation-139": "Iniciar sess\xE3o novamente",
    "__stack-auto-translation-14": "Criar",
    "__stack-auto-translation-140": "Inicie sess\xE3o ou crie uma conta para se juntar \xE0 equipa.",
    "__stack-auto-translation-141": "Iniciar sess\xE3o na sua conta",
    "__stack-auto-translation-142": "Iniciar sess\xE3o com Passkey",
    "__stack-auto-translation-143": "Iniciar sess\xE3o com {provider}",
    "__stack-auto-translation-144": "Terminar sess\xE3o",
    "__stack-auto-translation-145": "Inscrever-se",
    "__stack-auto-translation-146": "Inscrever-se",
    "__stack-auto-translation-147": "As inscri\xE7\xF5es para novos utilizadores n\xE3o est\xE3o ativadas de momento.",
    "__stack-auto-translation-148": "Registar com chave de acesso",
    "__stack-auto-translation-149": "Registar-se com {provider}",
    "__stack-auto-translation-15": "Criar uma nova conta",
    "__stack-auto-translation-150": "Autentica\xE7\xE3o bem-sucedida!",
    "__stack-auto-translation-151": "Algo correu mal durante o processamento do callback OAuth:",
    "__stack-auto-translation-152": "Parar de utilizar para in\xEDcio de sess\xE3o",
    "__stack-auto-translation-153": "A cria\xE7\xE3o de equipas n\xE3o est\xE1 ativada",
    "__stack-auto-translation-154": "Nome de exibi\xE7\xE3o da equipa",
    "__stack-auto-translation-155": "Convite para equipa",
    "__stack-auto-translation-156": "Imagem de perfil da equipa",
    "__stack-auto-translation-157": "Nome de utilizador da equipa",
    "__stack-auto-translation-158": "Equipas",
    "__stack-auto-translation-159": "O link m\xE1gico j\xE1 foi utilizado. O link s\xF3 pode ser usado uma vez. Por favor, solicite um novo link m\xE1gico se precisar de iniciar sess\xE3o novamente.",
    "__stack-auto-translation-16": "Criar uma equipa",
    "__stack-auto-translation-160": "A opera\xE7\xE3o de in\xEDcio de sess\xE3o foi cancelada. Por favor, tente novamente. [access_denied]",
    "__stack-auto-translation-161": "O utilizador j\xE1 est\xE1 conectado a outra conta OAuth. Ter\xE1 selecionado a conta errada na p\xE1gina do provedor OAuth?",
    "__stack-auto-translation-162": "Em seguida, introduza o seu c\xF3digo MFA de seis d\xEDgitos:",
    "__stack-auto-translation-163": "Esta conta j\xE1 est\xE1 associada a outro utilizador. Por favor, associe uma conta diferente.",
    "__stack-auto-translation-164": "Este email j\xE1 \xE9 utilizado para iniciar sess\xE3o por outro utilizador.",
    "__stack-auto-translation-165": "Este \xE9 um nome de exibi\xE7\xE3o e n\xE3o \xE9 utilizado para autentica\xE7\xE3o",
    "__stack-auto-translation-166": "Isto \xE9 provavelmente um erro no Stack. Por favor, reporte-o.",
    "__stack-auto-translation-167": "Este link de redefini\xE7\xE3o de senha j\xE1 foi utilizado. Se precisar redefinir a sua senha novamente, por favor solicite um novo link de redefini\xE7\xE3o de senha na p\xE1gina de login.",
    "__stack-auto-translation-168": "Este link de convite para a equipa j\xE1 foi utilizado.",
    "__stack-auto-translation-169": "Para ativar a autentica\xE7\xE3o OTP, adicione um email de acesso verificado.",
    "__stack-auto-translation-17": "Criar uma Equipa",
    "__stack-auto-translation-170": "Para ativar o in\xEDcio de sess\xE3o com chave de acesso, adicione um email de in\xEDcio de sess\xE3o verificado.",
    "__stack-auto-translation-171": "Para definir uma palavra-passe, adicione um email de acesso.",
    "__stack-auto-translation-172": "Alternar tema",
    "__stack-auto-translation-173": "C\xF3digo QR de autentica\xE7\xE3o multifator TOTP",
    "__stack-auto-translation-174": "N\xE3o verificado",
    "__stack-auto-translation-175": "Atualizar palavra-passe",
    "__stack-auto-translation-176": "Atualizar Palavra-passe",
    "__stack-auto-translation-177": "Atualize a sua palavra-passe",
    "__stack-auto-translation-178": "Carregar uma imagem para a sua equipa",
    "__stack-auto-translation-179": "Carregue a sua pr\xF3pria imagem como avatar",
    "__stack-auto-translation-18": "Equipa atual",
    "__stack-auto-translation-180": "Usar para iniciar sess\xE3o",
    "__stack-auto-translation-181": "Utilizado para iniciar sess\xE3o",
    "__stack-auto-translation-182": "Link de Redefini\xE7\xE3o de Senha Utilizado",
    "__stack-auto-translation-183": "Link de Convite para Equipa Utilizado",
    "__stack-auto-translation-184": "Utilizador",
    "__stack-auto-translation-185": "Nome de utilizador",
    "__stack-auto-translation-186": "Verificar",
    "__stack-auto-translation-187": "J\xE1 est\xE1 autenticado",
    "__stack-auto-translation-188": "N\xE3o tem sess\xE3o iniciada de momento.",
    "__stack-auto-translation-189": "N\xE3o \xE9 poss\xEDvel remover o seu \xFAltimo email de in\xEDcio de sess\xE3o",
    "__stack-auto-translation-19": "Zona de perigo",
    "__stack-auto-translation-190": "O seu email foi verificado!",
    "__stack-auto-translation-191": "O seu email",
    "__stack-auto-translation-192": "O seu link de verifica\xE7\xE3o de e-mail expirou. Por favor, solicite um novo link de verifica\xE7\xE3o nas configura\xE7\xF5es da sua conta.",
    "__stack-auto-translation-193": "O seu link m\xE1gico expirou. Por favor, solicite um novo link m\xE1gico se precisar de iniciar sess\xE3o.",
    "__stack-auto-translation-194": "A sua palavra-passe foi redefinida. Agora pode iniciar sess\xE3o com a sua nova palavra-passe.",
    "__stack-auto-translation-195": "O seu link de redefini\xE7\xE3o de palavra-passe expirou. Por favor, solicite um novo link de redefini\xE7\xE3o de palavra-passe na p\xE1gina de in\xEDcio de sess\xE3o.",
    "__stack-auto-translation-196": "O seu link de convite para a equipa expirou. Por favor, solicite um novo link de convite para a equipa ",
    "__stack-auto-translation-2": "Adicionar",
    "__stack-auto-translation-20": "Eliminar conta",
    "__stack-auto-translation-21": "Eliminar Conta",
    "__stack-auto-translation-22": "Eliminar Chave de Acesso",
    "__stack-auto-translation-23": "Desativar",
    "__stack-auto-translation-24": "Desativar MFA",
    "__stack-auto-translation-25": "Desativar OTP",
    "__stack-auto-translation-26": "Nome de exibi\xE7\xE3o",
    "__stack-auto-translation-27": "Quer iniciar sess\xE3o?",
    "__stack-auto-translation-28": "Pretende verificar o seu email?",
    "__stack-auto-translation-29": "N\xE3o tem uma conta?",
    "__stack-auto-translation-3": "Adicionar um email",
    "__stack-auto-translation-30": "N\xE3o precisa redefinir?",
    "__stack-auto-translation-31": "Email",
    "__stack-auto-translation-32": "Email e Palavra-passe",
    "__stack-auto-translation-33": "O email j\xE1 existe",
    "__stack-auto-translation-34": "O email \xE9 obrigat\xF3rio",
    "__stack-auto-translation-35": "Email enviado!",
    "__stack-auto-translation-36": "E-mails",
    "__stack-auto-translation-37": "E-mails e autentica\xE7\xE3o",
    "__stack-auto-translation-38": "Ativar MFA",
    "__stack-auto-translation-39": "Ativar OTP",
    "__stack-auto-translation-4": "Adicionar nova chave de acesso",
    "__stack-auto-translation-40": "Ativar autentica\xE7\xE3o via link m\xE1gico ou OTP enviado para os seus e-mails de in\xEDcio de sess\xE3o.",
    "__stack-auto-translation-41": "Terminar a sua sess\xE3o atual",
    "__stack-auto-translation-42": "Insira um nome de exibi\xE7\xE3o para a sua nova equipa",
    "__stack-auto-translation-43": "Introduza o e-mail",
    "__stack-auto-translation-44": "Insira o c\xF3digo do seu e-mail",
    "__stack-auto-translation-45": "Link M\xE1gica Expirada",
    "__stack-auto-translation-46": "Link de Redefini\xE7\xE3o de Senha Expirado",
    "__stack-auto-translation-47": "Link de Convite para Equipa Expirado",
    "__stack-auto-translation-48": "Link de Verifica\xE7\xE3o Expirado",
    "__stack-auto-translation-49": "Expira",
    "__stack-auto-translation-5": "J\xE1 tem uma conta?",
    "__stack-auto-translation-50": "Falha ao conectar conta",
    "__stack-auto-translation-51": "Falha ao redefinir a palavra-passe",
    "__stack-auto-translation-52": "Falha ao redefinir a senha. Por favor, solicite um novo link de redefini\xE7\xE3o de senha",
    "__stack-auto-translation-53": "Esqueceu-se da palavra-passe?",
    "__stack-auto-translation-54": "Ir para in\xEDcio",
    "__stack-auto-translation-55": "Ir para in\xEDcio",
    "__stack-auto-translation-56": "Se o utilizador com este endere\xE7o de e-mail existir, foi enviado um e-mail para a sua caixa de entrada. Certifique-se de verificar a sua pasta de spam.",
    "__stack-auto-translation-57": "Se n\xE3o for redirecionado automaticamente, ",
    "__stack-auto-translation-58": "Ignorar",
    "__stack-auto-translation-59": "C\xF3digo incorreto. Por favor, tente novamente.",
    "__stack-auto-translation-6": "Ocorreu um erro desconhecido",
    "__stack-auto-translation-60": "Palavra-passe incorreta",
    "__stack-auto-translation-61": "C\xF3digo inv\xE1lido",
    "__stack-auto-translation-62": "Imagem inv\xE1lida",
    "__stack-auto-translation-63": "Link M\xE1gica Inv\xE1lida",
    "__stack-auto-translation-64": "Link Inv\xE1lido de Redefini\xE7\xE3o de Senha",
    "__stack-auto-translation-65": "Link de Convite de Equipa Inv\xE1lido",
    "__stack-auto-translation-66": "C\xF3digo TOTP inv\xE1lido",
    "__stack-auto-translation-67": "Link de Verifica\xE7\xE3o Inv\xE1lido",
    "__stack-auto-translation-68": "Convidar um utilizador para a sua equipa atrav\xE9s de e-mail",
    "__stack-auto-translation-69": "Convidar membro",
    "__stack-auto-translation-7": "Tem certeza de que deseja eliminar a sua conta? Esta a\xE7\xE3o \xE9 IRREVERS\xCDVEL e ir\xE1 eliminar TODOS os dados associados.",
    "__stack-auto-translation-70": "Convidar Utilizador",
    "__stack-auto-translation-71": "Juntar",
    "__stack-auto-translation-72": "Sair",
    "__stack-auto-translation-73": "Abandonar equipa",
    "__stack-auto-translation-74": "Sair da Equipa",
    "__stack-auto-translation-75": "abandonar esta equipa e remover o seu perfil de equipa",
    "__stack-auto-translation-76": "Link M\xE1gico J\xE1 Utilizado",
    "__stack-auto-translation-77": "Membros",
    "__stack-auto-translation-78": "Autentica\xE7\xE3o de M\xFAltiplos Fatores",
    "__stack-auto-translation-79": "A autentica\xE7\xE3o multifator est\xE1 atualmente desativada.",
    "__stack-auto-translation-8": "Tem certeza de que deseja desativar a autentica\xE7\xE3o OTP? J\xE1 n\xE3o poder\xE1 iniciar sess\xE3o apenas com e-mails.",
    "__stack-auto-translation-80": "A autentica\xE7\xE3o multifator est\xE1 atualmente ativada.",
    "__stack-auto-translation-81": "O Meu Perfil",
    "__stack-auto-translation-82": "Nome",
    "__stack-auto-translation-83": "N\xE3o \xE9 permitido registar novas contas",
    "__stack-auto-translation-84": "Nova palavra-passe",
    "__stack-auto-translation-85": "Nova Palavra-passe",
    "__stack-auto-translation-86": "Nenhum m\xE9todo de autentica\xE7\xE3o ativado.",
    "__stack-auto-translation-87": "Ainda sem equipas",
    "__stack-auto-translation-88": "N\xE3o tem sess\xE3o iniciada",
    "__stack-auto-translation-89": "Acesso ao provedor OAuth negado",
    "__stack-auto-translation-9": "Tem a certeza de que pretende desativar o in\xEDcio de sess\xE3o por chave de acesso? N\xE3o poder\xE1 mais iniciar sess\xE3o com a sua chave de acesso.",
    "__stack-auto-translation-90": "Palavra-passe antiga",
    "__stack-auto-translation-91": "Ou continuar com",
    "__stack-auto-translation-92": "Outras equipas",
    "__stack-auto-translation-93": "Autentica\xE7\xE3o OTP",
    "__stack-auto-translation-94": "A autentica\xE7\xE3o OTP est\xE1 ativada e n\xE3o pode ser desativada, pois \xE9 atualmente o \xFAnico m\xE9todo de autentica\xE7\xE3o",
    "__stack-auto-translation-95": "O in\xEDcio de sess\xE3o por OTP/link m\xE1gico est\xE1 atualmente ativado.",
    "__stack-auto-translation-96": "Convites pendentes",
    "__stack-auto-translation-97": "Substituir o seu nome de utilizador nesta equipa",
    "__stack-auto-translation-98": "Chave de acesso",
    "__stack-auto-translation-99": "Chave de acesso registada"
  })),
  "zh-CN": new Map(typedEntries({
    "__stack-auto-translation-0": "\u8D26\u6237\u8BBE\u7F6E",
    "__stack-auto-translation-1": "\u8D26\u6237\u8BBE\u7F6E",
    "__stack-auto-translation-10": "\u60A8\u786E\u5B9A\u8981\u79BB\u5F00\u56E2\u961F\u5417\uFF1F",
    "__stack-auto-translation-100": "\u5BC6\u94A5\u767B\u5F55\u5DF2\u542F\u7528\uFF0C\u4E14\u65E0\u6CD5\u7981\u7528\uFF0C\u56E0\u4E3A\u5B83\u76EE\u524D\u662F\u552F\u4E00\u7684\u767B\u5F55\u65B9\u5F0F",
    "__stack-auto-translation-101": "\u5BC6\u7801",
    "__stack-auto-translation-102": "\u5BC6\u7801\u91CD\u7F6E\u6210\u529F\uFF01",
    "__stack-auto-translation-103": "\u5BC6\u7801\u4E0D\u5339\u914D",
    "__stack-auto-translation-104": "\u6C38\u4E45\u5220\u9664\u60A8\u7684\u5E10\u6237\u548C\u6240\u6709\u76F8\u5173\u6570\u636E",
    "__stack-auto-translation-105": "\u8BF7\u68C0\u67E5\u60A8\u662F\u5426\u6709\u6B63\u786E\u7684\u94FE\u63A5\u3002\u5982\u679C\u60A8\u7EE7\u7EED\u9047\u5230\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u652F\u6301\u4EBA\u5458\u3002",
    "__stack-auto-translation-106": "\u8BF7\u518D\u6B21\u786E\u8BA4\u60A8\u662F\u5426\u6709\u6B63\u786E\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u3002",
    "__stack-auto-translation-107": "\u8BF7\u518D\u6B21\u786E\u8BA4\u60A8\u662F\u5426\u62E5\u6709\u6B63\u786E\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5\u3002",
    "__stack-auto-translation-108": "\u8BF7\u8F93\u5165\u56E2\u961F\u540D\u79F0",
    "__stack-auto-translation-109": "\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u7BB1\u5730\u5740",
    "__stack-auto-translation-11": "\u53D6\u6D88",
    "__stack-auto-translation-110": "\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    "__stack-auto-translation-111": "\u8BF7\u8F93\u5165\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    "__stack-auto-translation-112": "\u8BF7\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u7BB1",
    "__stack-auto-translation-113": "\u8BF7\u8F93\u5165\u60A8\u7684\u65E7\u5BC6\u7801",
    "__stack-auto-translation-114": "\u8BF7\u8F93\u5165\u60A8\u7684\u5BC6\u7801",
    "__stack-auto-translation-115": "\u8BF7\u91CD\u590D\u8F93\u5165\u60A8\u7684\u5BC6\u7801",
    "__stack-auto-translation-116": "\u8BF7\u91CD\u8BD5\uFF0C\u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002",
    "__stack-auto-translation-117": "\u8BF7\u5148\u9A8C\u8BC1\u60A8\u7684\u7535\u5B50\u90AE\u7BB1",
    "__stack-auto-translation-118": "\u4E3B\u8981",
    "__stack-auto-translation-119": "\u5934\u50CF",
    "__stack-auto-translation-12": "\u66F4\u6539\u56E2\u961F\u663E\u793A\u540D\u79F0",
    "__stack-auto-translation-120": "\u6CE8\u518C\u5BC6\u94A5",
    "__stack-auto-translation-121": "\u5220\u9664",
    "__stack-auto-translation-122": "\u91CD\u590D\u65B0\u5BC6\u7801",
    "__stack-auto-translation-123": "\u91CD\u590D\u65B0\u5BC6\u7801",
    "__stack-auto-translation-124": "\u91CD\u590D\u5BC6\u7801",
    "__stack-auto-translation-125": "\u91CD\u7F6E\u5BC6\u7801",
    "__stack-auto-translation-126": "\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801",
    "__stack-auto-translation-127": "\u4FDD\u5B58",
    "__stack-auto-translation-128": "\u4F7F\u7528\u60A8\u7684\u8EAB\u4EFD\u9A8C\u8BC1\u5668\u5E94\u7528\u626B\u63CF\u6B64\u4E8C\u7EF4\u7801\uFF1A",
    "__stack-auto-translation-129": "\u53D1\u9001\u7535\u5B50\u90AE\u4EF6",
    "__stack-auto-translation-13": "\u70B9\u51FB\u6B64\u5904",
    "__stack-auto-translation-130": "\u53D1\u9001\u90AE\u4EF6",
    "__stack-auto-translation-131": "\u53D1\u9001\u9A8C\u8BC1\u90AE\u4EF6",
    "__stack-auto-translation-132": "\u4E3A\u60A8\u7684\u8D26\u6237\u8BBE\u7F6E\u5BC6\u7801",
    "__stack-auto-translation-133": "\u8BBE\u7F6E\u4E3A\u4E3B\u8981",
    "__stack-auto-translation-134": "\u8BBE\u7F6E\u5BC6\u7801",
    "__stack-auto-translation-135": "\u8BBE\u7F6E\u5BC6\u7801",
    "__stack-auto-translation-136": "\u8BBE\u7F6E",
    "__stack-auto-translation-137": "\u767B\u5F55",
    "__stack-auto-translation-138": "\u767B\u5F55",
    "__stack-auto-translation-139": "\u518D\u6B21\u767B\u5F55",
    "__stack-auto-translation-14": "\u521B\u5EFA",
    "__stack-auto-translation-140": "\u767B\u5F55\u6216\u521B\u5EFA\u8D26\u6237\u4EE5\u52A0\u5165\u56E2\u961F\u3002",
    "__stack-auto-translation-141": "\u767B\u5F55\u60A8\u7684\u5E10\u6237",
    "__stack-auto-translation-142": "\u4F7F\u7528\u5BC6\u94A5\u767B\u5F55",
    "__stack-auto-translation-143": "\u4F7F\u7528{provider}\u767B\u5F55",
    "__stack-auto-translation-144": "\u9000\u51FA\u767B\u5F55",
    "__stack-auto-translation-145": "\u6CE8\u518C",
    "__stack-auto-translation-146": "\u6CE8\u518C",
    "__stack-auto-translation-147": "\u76EE\u524D\u4E0D\u5141\u8BB8\u65B0\u7528\u6237\u6CE8\u518C\u3002",
    "__stack-auto-translation-148": "\u4F7F\u7528\u901A\u884C\u5BC6\u94A5\u6CE8\u518C",
    "__stack-auto-translation-149": "\u7528 {provider} \u6CE8\u518C",
    "__stack-auto-translation-15": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "__stack-auto-translation-150": "\u767B\u5F55\u6210\u529F\uFF01",
    "__stack-auto-translation-151": "\u5904\u7406 OAuth \u56DE\u8C03\u65F6\u51FA\u73B0\u9519\u8BEF\uFF1A",
    "__stack-auto-translation-152": "\u505C\u6B62\u4F7F\u7528\u767B\u5F55",
    "__stack-auto-translation-153": "\u56E2\u961F\u521B\u5EFA\u672A\u542F\u7528",
    "__stack-auto-translation-154": "\u56E2\u961F\u663E\u793A\u540D\u79F0",
    "__stack-auto-translation-155": "\u56E2\u961F\u9080\u8BF7",
    "__stack-auto-translation-156": "\u56E2\u961F\u5934\u50CF",
    "__stack-auto-translation-157": "\u56E2\u961F\u7528\u6237\u540D",
    "__stack-auto-translation-158": "\u56E2\u961F",
    "__stack-auto-translation-159": "\u9B54\u6CD5\u94FE\u63A5\u5DF2\u88AB\u4F7F\u7528\u3002\u8BE5\u94FE\u63A5\u53EA\u80FD\u4F7F\u7528\u4E00\u6B21\u3002\u5982\u679C\u9700\u8981\u518D\u6B21\u767B\u5F55\uFF0C\u8BF7\u91CD\u65B0\u7533\u8BF7\u4E00\u4E2A\u65B0\u7684\u9B54\u6CD5\u94FE\u63A5\u3002",
    "__stack-auto-translation-16": "\u521B\u5EFA\u56E2\u961F",
    "__stack-auto-translation-160": "\u767B\u5F55\u64CD\u4F5C\u5DF2\u53D6\u6D88\u3002\u8BF7\u91CD\u8BD5\u3002[access_denied]",
    "__stack-auto-translation-161": "\u7528\u6237\u5DF2\u8FDE\u63A5\u5230\u53E6\u4E00\u4E2A OAuth \u8D26\u6237\u3002\u60A8\u662F\u5426\u5728 OAuth \u63D0\u4F9B\u5546\u9875\u9762\u4E0A\u9009\u62E9\u4E86\u9519\u8BEF\u7684\u8D26\u6237\uFF1F",
    "__stack-auto-translation-162": "\u7136\u540E\uFF0C\u8F93\u5165\u60A8\u7684\u516D\u4F4D\u6570 MFA \u7801\uFF1A",
    "__stack-auto-translation-163": "\u6B64\u5E10\u6237\u5DF2\u4E0E\u53E6\u4E00\u7528\u6237\u5173\u8054\u3002\u8BF7\u8FDE\u63A5\u5176\u4ED6\u5E10\u6237\u3002",
    "__stack-auto-translation-164": "\u6B64\u7535\u5B50\u90AE\u7BB1\u5DF2\u88AB\u53E6\u4E00\u7528\u6237\u7528\u4E8E\u767B\u5F55\u3002",
    "__stack-auto-translation-165": "\u8FD9\u662F\u4E00\u4E2A\u663E\u793A\u540D\u79F0\uFF0C\u4E0D\u7528\u4E8E\u8EAB\u4EFD\u9A8C\u8BC1",
    "__stack-auto-translation-166": "\u8FD9\u5F88\u53EF\u80FD\u662F Stack \u4E2D\u7684\u9519\u8BEF\u3002\u8BF7\u62A5\u544A\u6B64\u95EE\u9898\u3002",
    "__stack-auto-translation-167": "\u6B64\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u5DF2\u88AB\u4F7F\u7528\u3002\u5982\u679C\u60A8\u9700\u8981\u518D\u6B21\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4ECE\u767B\u5F55\u9875\u9762\u8BF7\u6C42\u65B0\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u3002",
    "__stack-auto-translation-168": "\u6B64\u56E2\u961F\u9080\u8BF7\u94FE\u63A5\u5DF2\u88AB\u4F7F\u7528\u3002",
    "__stack-auto-translation-169": "\u8981\u542F\u7528 OTP \u767B\u5F55\uFF0C\u8BF7\u6DFB\u52A0\u5DF2\u9A8C\u8BC1\u7684\u767B\u5F55\u90AE\u7BB1\u3002",
    "__stack-auto-translation-17": "\u521B\u5EFA\u56E2\u961F",
    "__stack-auto-translation-170": "\u8981\u542F\u7528\u901A\u884C\u5BC6\u94A5\u767B\u5F55\uFF0C\u8BF7\u6DFB\u52A0\u5DF2\u9A8C\u8BC1\u7684\u767B\u5F55\u90AE\u7BB1\u3002",
    "__stack-auto-translation-171": "\u8981\u8BBE\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u5148\u6DFB\u52A0\u767B\u5F55\u90AE\u7BB1\u3002",
    "__stack-auto-translation-172": "\u5207\u6362\u4E3B\u9898",
    "__stack-auto-translation-173": "TOTP \u591A\u56E0\u7D20\u8BA4\u8BC1\u4E8C\u7EF4\u7801",
    "__stack-auto-translation-174": "\u672A\u9A8C\u8BC1",
    "__stack-auto-translation-175": "\u66F4\u65B0\u5BC6\u7801",
    "__stack-auto-translation-176": "\u66F4\u65B0\u5BC6\u7801",
    "__stack-auto-translation-177": "\u66F4\u65B0\u60A8\u7684\u5BC6\u7801",
    "__stack-auto-translation-178": "\u4E3A\u56E2\u961F\u4E0A\u4F20\u56FE\u7247",
    "__stack-auto-translation-179": "\u4E0A\u4F20\u60A8\u81EA\u5DF1\u7684\u56FE\u50CF\u4F5C\u4E3A\u5934\u50CF",
    "__stack-auto-translation-18": "\u5F53\u524D\u56E2\u961F",
    "__stack-auto-translation-180": "\u7528\u4E8E\u767B\u5F55",
    "__stack-auto-translation-181": "\u7528\u4E8E\u767B\u5F55",
    "__stack-auto-translation-182": "\u5DF2\u4F7F\u7528\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5",
    "__stack-auto-translation-183": "\u5DF2\u4F7F\u7528\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5",
    "__stack-auto-translation-184": "\u7528\u6237",
    "__stack-auto-translation-185": "\u7528\u6237\u540D",
    "__stack-auto-translation-186": "\u9A8C\u8BC1",
    "__stack-auto-translation-187": "\u60A8\u5DF2\u7ECF\u767B\u5F55",
    "__stack-auto-translation-188": "\u60A8\u5F53\u524D\u672A\u767B\u5F55\u3002",
    "__stack-auto-translation-189": "\u4F60\u4E0D\u80FD\u5220\u9664\u6700\u540E\u4E00\u4E2A\u7528\u4E8E\u767B\u5F55\u7684\u7535\u5B50\u90AE\u7BB1",
    "__stack-auto-translation-19": "\u5371\u9669\u533A\u57DF",
    "__stack-auto-translation-190": "\u60A8\u7684\u90AE\u7BB1\u5DF2\u9A8C\u8BC1\uFF01",
    "__stack-auto-translation-191": "\u60A8\u7684\u90AE\u7BB1",
    "__stack-auto-translation-192": "\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u9A8C\u8BC1\u94FE\u63A5\u5DF2\u8FC7\u671F\u3002\u8BF7\u4ECE\u60A8\u7684\u8D26\u6237\u8BBE\u7F6E\u4E2D\u91CD\u65B0\u8BF7\u6C42\u4E00\u4E2A\u65B0\u7684\u9A8C\u8BC1\u94FE\u63A5\u3002",
    "__stack-auto-translation-193": "\u60A8\u7684\u9B54\u6CD5\u94FE\u63A5\u5DF2\u8FC7\u671F\u3002\u5982\u679C\u60A8\u9700\u8981\u767B\u5F55\uFF0C\u8BF7\u91CD\u65B0\u7533\u8BF7\u4E00\u4E2A\u65B0\u7684\u9B54\u6CD5\u94FE\u63A5\u3002",
    "__stack-auto-translation-194": "\u60A8\u7684\u5BC6\u7801\u5DF2\u91CD\u7F6E\u3002\u60A8\u73B0\u5728\u53EF\u4EE5\u4F7F\u7528\u65B0\u5BC6\u7801\u767B\u5F55\u3002",
    "__stack-auto-translation-195": "\u60A8\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u5DF2\u8FC7\u671F\u3002\u8BF7\u4ECE\u767B\u5F55\u9875\u9762\u7533\u8BF7\u65B0\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u3002",
    "__stack-auto-translation-196": "\u60A8\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5\u5DF2\u8FC7\u671F\u3002\u8BF7\u7533\u8BF7\u65B0\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5 ",
    "__stack-auto-translation-2": "\u6DFB\u52A0",
    "__stack-auto-translation-20": "\u5220\u9664\u8D26\u6237",
    "__stack-auto-translation-21": "\u5220\u9664\u8D26\u6237",
    "__stack-auto-translation-22": "\u5220\u9664\u5BC6\u94A5",
    "__stack-auto-translation-23": "\u7981\u7528",
    "__stack-auto-translation-24": "\u7981\u7528 MFA",
    "__stack-auto-translation-25": "\u7981\u7528 OTP",
    "__stack-auto-translation-26": "\u663E\u793A\u540D\u79F0",
    "__stack-auto-translation-27": "\u60A8\u8981\u767B\u5F55\u5417\uFF1F",
    "__stack-auto-translation-28": "\u60A8\u60F3\u9A8C\u8BC1\u60A8\u7684\u90AE\u7BB1\u5417\uFF1F",
    "__stack-auto-translation-29": "\u8FD8\u6CA1\u6709\u8D26\u53F7\uFF1F",
    "__stack-auto-translation-3": "\u6DFB\u52A0\u7535\u5B50\u90AE\u4EF6",
    "__stack-auto-translation-30": "\u4E0D\u9700\u8981\u91CD\u7F6E\uFF1F",
    "__stack-auto-translation-31": "\u90AE\u7BB1",
    "__stack-auto-translation-32": "\u7535\u5B50\u90AE\u4EF6\u548C\u5BC6\u7801",
    "__stack-auto-translation-33": "\u7535\u5B50\u90AE\u7BB1\u5DF2\u5B58\u5728",
    "__stack-auto-translation-34": "\u9700\u8981\u586B\u5199\u7535\u5B50\u90AE\u7BB1",
    "__stack-auto-translation-35": "\u90AE\u4EF6\u5DF2\u53D1\u9001\uFF01",
    "__stack-auto-translation-36": "\u7535\u5B50\u90AE\u4EF6",
    "__stack-auto-translation-37": "\u7535\u5B50\u90AE\u4EF6\u548C\u8EAB\u4EFD\u9A8C\u8BC1",
    "__stack-auto-translation-38": "\u542F\u7528 MFA",
    "__stack-auto-translation-39": "\u542F\u7528 OTP",
    "__stack-auto-translation-4": "\u6DFB\u52A0\u65B0\u5BC6\u94A5",
    "__stack-auto-translation-40": "\u542F\u7528\u901A\u8FC7\u9B54\u6CD5\u94FE\u63A5\u6216\u53D1\u9001\u5230\u60A8\u7684\u767B\u5F55\u90AE\u7BB1\u7684\u4E00\u6B21\u6027\u5BC6\u7801\u8FDB\u884C\u767B\u5F55\u3002",
    "__stack-auto-translation-41": "\u7ED3\u675F\u60A8\u7684\u5F53\u524D\u4F1A\u8BDD",
    "__stack-auto-translation-42": "\u4E3A\u60A8\u7684\u65B0\u56E2\u961F\u8F93\u5165\u4E00\u4E2A\u663E\u793A\u540D\u79F0",
    "__stack-auto-translation-43": "\u8F93\u5165\u90AE\u7BB1",
    "__stack-auto-translation-44": "\u8F93\u5165\u60A8\u90AE\u7BB1\u4E2D\u6536\u5230\u7684\u9A8C\u8BC1\u7801",
    "__stack-auto-translation-45": "\u8FC7\u671F\u7684\u9B54\u6CD5\u94FE\u63A5",
    "__stack-auto-translation-46": "\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5\u5DF2\u8FC7\u671F",
    "__stack-auto-translation-47": "\u8FC7\u671F\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5",
    "__stack-auto-translation-48": "\u9A8C\u8BC1\u94FE\u63A5\u5DF2\u8FC7\u671F",
    "__stack-auto-translation-49": "\u5230\u671F",
    "__stack-auto-translation-5": "\u5DF2\u6709\u8D26\u6237\uFF1F",
    "__stack-auto-translation-50": "\u65E0\u6CD5\u8FDE\u63A5\u5E10\u6237",
    "__stack-auto-translation-51": "\u91CD\u7F6E\u5BC6\u7801\u5931\u8D25",
    "__stack-auto-translation-52": "\u5BC6\u7801\u91CD\u7F6E\u5931\u8D25\u3002\u8BF7\u91CD\u65B0\u7533\u8BF7\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5",
    "__stack-auto-translation-53": "\u5FD8\u8BB0\u5BC6\u7801\uFF1F",
    "__stack-auto-translation-54": "\u8FD4\u56DE\u4E3B\u9875",
    "__stack-auto-translation-55": "\u8FD4\u56DE\u4E3B\u9875",
    "__stack-auto-translation-56": "\u5982\u679C\u5B58\u5728\u4F7F\u7528\u6B64\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u7684\u7528\u6237\uFF0C\u4E00\u5C01\u7535\u5B50\u90AE\u4EF6\u5DF2\u53D1\u9001\u5230\u60A8\u7684\u6536\u4EF6\u7BB1\u3002\u8BF7\u52A1\u5FC5\u68C0\u67E5\u60A8\u7684\u5783\u573E\u90AE\u4EF6\u6587\u4EF6\u5939\u3002",
    "__stack-auto-translation-57": "\u5982\u679C\u60A8\u6CA1\u6709\u88AB\u81EA\u52A8\u91CD\u5B9A\u5411\uFF0C",
    "__stack-auto-translation-58": "\u5FFD\u7565",
    "__stack-auto-translation-59": "\u4EE3\u7801\u4E0D\u6B63\u786E\u3002\u8BF7\u91CD\u8BD5\u3002",
    "__stack-auto-translation-6": "\u53D1\u751F\u672A\u77E5\u9519\u8BEF",
    "__stack-auto-translation-60": "\u5BC6\u7801\u4E0D\u6B63\u786E",
    "__stack-auto-translation-61": "\u65E0\u6548\u4EE3\u7801",
    "__stack-auto-translation-62": "\u65E0\u6548\u7684\u56FE\u7247",
    "__stack-auto-translation-63": "\u65E0\u6548\u7684\u9B54\u6CD5\u94FE\u63A5",
    "__stack-auto-translation-64": "\u65E0\u6548\u7684\u5BC6\u7801\u91CD\u7F6E\u94FE\u63A5",
    "__stack-auto-translation-65": "\u65E0\u6548\u7684\u56E2\u961F\u9080\u8BF7\u94FE\u63A5",
    "__stack-auto-translation-66": "\u65E0\u6548\u7684 TOTP \u4EE3\u7801",
    "__stack-auto-translation-67": "\u65E0\u6548\u7684\u9A8C\u8BC1\u94FE\u63A5",
    "__stack-auto-translation-68": "\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u9080\u8BF7\u7528\u6237\u52A0\u5165\u60A8\u7684\u56E2\u961F",
    "__stack-auto-translation-69": "\u9080\u8BF7\u6210\u5458",
    "__stack-auto-translation-7": "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u60A8\u7684\u8D26\u6237\u5417\uFF1F\u6B64\u64CD\u4F5C\u662F\u4E0D\u53EF\u9006\u7684\uFF0C\u5C06\u5220\u9664\u6240\u6709\u76F8\u5173\u6570\u636E\u3002",
    "__stack-auto-translation-70": "\u9080\u8BF7\u7528\u6237",
    "__stack-auto-translation-71": "\u52A0\u5165",
    "__stack-auto-translation-72": "\u79BB\u5F00",
    "__stack-auto-translation-73": "\u9000\u51FA\u56E2\u961F",
    "__stack-auto-translation-74": "\u79BB\u5F00\u56E2\u961F",
    "__stack-auto-translation-75": "\u79BB\u5F00\u6B64\u56E2\u961F\u5E76\u5220\u9664\u60A8\u7684\u56E2\u961F\u8D44\u6599",
    "__stack-auto-translation-76": "\u9B54\u6CD5\u94FE\u63A5\u5DF2\u4F7F\u7528",
    "__stack-auto-translation-77": "\u6210\u5458",
    "__stack-auto-translation-78": "\u591A\u91CD\u8EAB\u4EFD\u8BA4\u8BC1",
    "__stack-auto-translation-79": "\u591A\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u76EE\u524D\u5DF2\u7981\u7528\u3002",
    "__stack-auto-translation-8": "\u60A8\u786E\u5B9A\u8981\u7981\u7528 OTP \u767B\u5F55\u5417\uFF1F\u7981\u7528\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EC5\u4F7F\u7528\u7535\u5B50\u90AE\u7BB1\u767B\u5F55\u3002",
    "__stack-auto-translation-80": "\u591A\u91CD\u8EAB\u4EFD\u9A8C\u8BC1\u76EE\u524D\u5DF2\u542F\u7528\u3002",
    "__stack-auto-translation-81": "\u6211\u7684\u4E2A\u4EBA\u8D44\u6599",
    "__stack-auto-translation-82": "\u59D3\u540D",
    "__stack-auto-translation-83": "\u4E0D\u5141\u8BB8\u6CE8\u518C\u65B0\u8D26\u6237",
    "__stack-auto-translation-84": "\u65B0\u5BC6\u7801",
    "__stack-auto-translation-85": "\u65B0\u5BC6\u7801",
    "__stack-auto-translation-86": "\u672A\u542F\u7528\u4EFB\u4F55\u8EAB\u4EFD\u9A8C\u8BC1\u65B9\u6CD5\u3002",
    "__stack-auto-translation-87": "\u5C1A\u65E0\u56E2\u961F",
    "__stack-auto-translation-88": "\u672A\u767B\u5F55",
    "__stack-auto-translation-89": "OAuth \u63D0\u4F9B\u5546\u8BBF\u95EE\u88AB\u62D2\u7EDD",
    "__stack-auto-translation-9": "\u60A8\u786E\u5B9A\u8981\u7981\u7528\u5BC6\u94A5\u767B\u5F55\u5417\uFF1F\u7981\u7528\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u518D\u4F7F\u7528\u5BC6\u94A5\u767B\u5F55\u3002",
    "__stack-auto-translation-90": "\u65E7\u5BC6\u7801",
    "__stack-auto-translation-91": "\u6216\u7EE7\u7EED\u4F7F\u7528",
    "__stack-auto-translation-92": "\u5176\u4ED6\u56E2\u961F",
    "__stack-auto-translation-93": "OTP \u767B\u5F55",
    "__stack-auto-translation-94": "\u5DF2\u542F\u7528 OTP \u767B\u5F55\uFF0C\u4E14\u65E0\u6CD5\u7981\u7528\uFF0C\u56E0\u4E3A\u5B83\u76EE\u524D\u662F\u552F\u4E00\u7684\u767B\u5F55\u65B9\u5F0F",
    "__stack-auto-translation-95": "OTP/\u9B54\u6CD5\u94FE\u63A5\u767B\u5F55\u76EE\u524D\u5DF2\u542F\u7528\u3002",
    "__stack-auto-translation-96": "\u5F85\u5904\u7406\u9080\u8BF7",
    "__stack-auto-translation-97": "\u5728\u8FD9\u4E2A\u56E2\u961F\u4E2D\u8986\u76D6\u4F60\u7684\u7528\u6237\u663E\u793A\u540D\u79F0",
    "__stack-auto-translation-98": "\u5BC6\u94A5",
    "__stack-auto-translation-99": "\u5BC6\u94A5\u5DF2\u6CE8\u518C"
  })),
  "zh-TW": new Map(typedEntries({
    "__stack-auto-translation-0": "\u5E33\u6236\u8A2D\u5B9A",
    "__stack-auto-translation-1": "\u5E33\u6236\u8A2D\u5B9A",
    "__stack-auto-translation-10": "\u60A8\u78BA\u5B9A\u8981\u96E2\u958B\u5718\u968A\u55CE\uFF1F",
    "__stack-auto-translation-100": "\u901A\u884C\u91D1\u9470\u767B\u5165\u5DF2\u555F\u7528\uFF0C\u76EE\u524D\u7121\u6CD5\u505C\u7528\uFF0C\u56E0\u70BA\u9019\u662F\u552F\u4E00\u7684\u767B\u5165\u65B9\u5F0F",
    "__stack-auto-translation-101": "\u5BC6\u78BC",
    "__stack-auto-translation-102": "\u5BC6\u78BC\u91CD\u8A2D\u6210\u529F\uFF01",
    "__stack-auto-translation-103": "\u5BC6\u78BC\u4E0D\u7B26\u5408",
    "__stack-auto-translation-104": "\u6C38\u4E45\u522A\u9664\u60A8\u7684\u5E33\u6236\u548C\u6240\u6709\u76F8\u95DC\u8CC7\u6599",
    "__stack-auto-translation-105": "\u8ACB\u6AA2\u67E5\u60A8\u7684\u9023\u7D50\u662F\u5426\u6B63\u78BA\u3002\u5982\u679C\u60A8\u7E7C\u7E8C\u9047\u5230\u554F\u984C\uFF0C\u8ACB\u806F\u7D61\u5BA2\u6236\u652F\u63F4\u3002",
    "__stack-auto-translation-106": "\u8ACB\u518D\u6B21\u78BA\u8A8D\u60A8\u662F\u5426\u64C1\u6709\u6B63\u78BA\u7684\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50\u3002",
    "__stack-auto-translation-107": "\u8ACB\u518D\u6B21\u78BA\u8A8D\u60A8\u662F\u5426\u6709\u6B63\u78BA\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50\u3002",
    "__stack-auto-translation-108": "\u8ACB\u8F38\u5165\u5718\u968A\u540D\u7A31",
    "__stack-auto-translation-109": "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
    "__stack-auto-translation-11": "\u53D6\u6D88",
    "__stack-auto-translation-110": "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
    "__stack-auto-translation-111": "\u8ACB\u8F38\u5165\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
    "__stack-auto-translation-112": "\u8ACB\u8F38\u5165\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-113": "\u8ACB\u8F38\u5165\u60A8\u7684\u820A\u5BC6\u78BC",
    "__stack-auto-translation-114": "\u8ACB\u8F38\u5165\u60A8\u7684\u5BC6\u78BC",
    "__stack-auto-translation-115": "\u8ACB\u91CD\u8907\u8F38\u5165\u60A8\u7684\u5BC6\u78BC",
    "__stack-auto-translation-116": "\u8ACB\u518D\u8A66\u4E00\u6B21\uFF0C\u5982\u679C\u554F\u984C\u4ECD\u7136\u5B58\u5728\uFF0C\u8ACB\u806F\u7D61\u5BA2\u6236\u652F\u63F4\u3002",
    "__stack-auto-translation-117": "\u8ACB\u5148\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-118": "\u4E3B\u8981",
    "__stack-auto-translation-119": "\u500B\u4EBA\u982D\u50CF",
    "__stack-auto-translation-12": "\u66F4\u6539\u5718\u968A\u7684\u986F\u793A\u540D\u7A31",
    "__stack-auto-translation-120": "\u8A3B\u518A\u901A\u884C\u91D1\u9470",
    "__stack-auto-translation-121": "\u79FB\u9664",
    "__stack-auto-translation-122": "\u91CD\u8907\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-123": "\u91CD\u8907\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-124": "\u91CD\u8907\u5BC6\u78BC",
    "__stack-auto-translation-125": "\u91CD\u8A2D\u5BC6\u78BC",
    "__stack-auto-translation-126": "\u91CD\u8A2D\u60A8\u7684\u5BC6\u78BC",
    "__stack-auto-translation-127": "\u5132\u5B58",
    "__stack-auto-translation-128": "\u8ACB\u4F7F\u7528\u60A8\u7684\u8EAB\u4EFD\u9A57\u8B49\u5668\u61C9\u7528\u7A0B\u5F0F\u6383\u63CF\u6B64 QR \u78BC\uFF1A",
    "__stack-auto-translation-129": "\u767C\u9001\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-13": "\u9EDE\u64CA\u9019\u88E1",
    "__stack-auto-translation-130": "\u767C\u9001\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-131": "\u767C\u9001\u9A57\u8B49\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-132": "\u70BA\u60A8\u7684\u5E33\u6236\u8A2D\u5B9A\u5BC6\u78BC",
    "__stack-auto-translation-133": "\u8A2D\u70BA\u4E3B\u8981",
    "__stack-auto-translation-134": "\u8A2D\u5B9A\u5BC6\u78BC",
    "__stack-auto-translation-135": "\u8A2D\u5B9A\u5BC6\u78BC",
    "__stack-auto-translation-136": "\u8A2D\u5B9A",
    "__stack-auto-translation-137": "\u767B\u5165",
    "__stack-auto-translation-138": "\u767B\u5165",
    "__stack-auto-translation-139": "\u518D\u6B21\u767B\u5165",
    "__stack-auto-translation-14": "\u5EFA\u7ACB",
    "__stack-auto-translation-140": "\u767B\u5165\u6216\u5EFA\u7ACB\u5E33\u6236\u4EE5\u52A0\u5165\u5718\u968A\u3002",
    "__stack-auto-translation-141": "\u767B\u5165\u60A8\u7684\u5E33\u6236",
    "__stack-auto-translation-142": "\u4F7F\u7528\u5BC6\u9470\u767B\u5165",
    "__stack-auto-translation-143": "\u4EE5 {provider} \u767B\u5165",
    "__stack-auto-translation-144": "\u767B\u51FA",
    "__stack-auto-translation-145": "\u8A3B\u518A",
    "__stack-auto-translation-146": "\u8A3B\u518A",
    "__stack-auto-translation-147": "\u76EE\u524D\u4E0D\u958B\u653E\u65B0\u4F7F\u7528\u8005\u8A3B\u518A\u3002",
    "__stack-auto-translation-148": "\u4F7F\u7528\u901A\u884C\u91D1\u9470\u8A3B\u518A",
    "__stack-auto-translation-149": "\u4F7F\u7528 {provider} \u8A3B\u518A",
    "__stack-auto-translation-15": "\u5EFA\u7ACB\u65B0\u5E33\u6236",
    "__stack-auto-translation-150": "\u767B\u5165\u6210\u529F\uFF01",
    "__stack-auto-translation-151": "\u8655\u7406 OAuth \u56DE\u8ABF\u6642\u51FA\u73FE\u932F\u8AA4\uFF1A",
    "__stack-auto-translation-152": "\u505C\u6B62\u4F7F\u7528\u65BC\u767B\u5165",
    "__stack-auto-translation-153": "\u5718\u968A\u5275\u5EFA\u529F\u80FD\u672A\u555F\u7528",
    "__stack-auto-translation-154": "\u5718\u968A\u986F\u793A\u540D\u7A31",
    "__stack-auto-translation-155": "\u5718\u968A\u9080\u8ACB",
    "__stack-auto-translation-156": "\u5718\u968A\u982D\u50CF",
    "__stack-auto-translation-157": "\u5718\u968A\u7528\u6236\u540D\u7A31",
    "__stack-auto-translation-158": "\u5718\u968A",
    "__stack-auto-translation-159": "\u8A72\u9B54\u6CD5\u9023\u7D50\u5DF2\u88AB\u4F7F\u7528\u904E\u3002\u6B64\u9023\u7D50\u50C5\u80FD\u4F7F\u7528\u4E00\u6B21\u3002\u5982\u679C\u60A8\u9700\u8981\u518D\u6B21\u767B\u5165\uFF0C\u8ACB\u91CD\u65B0\u7533\u8ACB\u4E00\u500B\u65B0\u7684\u9B54\u6CD5\u9023\u7D50\u3002",
    "__stack-auto-translation-16": "\u5EFA\u7ACB\u4E00\u500B\u5718\u968A",
    "__stack-auto-translation-160": "\u767B\u5165\u64CD\u4F5C\u5DF2\u53D6\u6D88\u3002\u8ACB\u518D\u8A66\u4E00\u6B21\u3002[access_denied]",
    "__stack-auto-translation-161": "\u4F7F\u7528\u8005\u5DF2\u7D93\u9023\u63A5\u5230\u53E6\u4E00\u500B OAuth \u5E33\u6236\u3002\u60A8\u662F\u5426\u5728 OAuth \u63D0\u4F9B\u8005\u9801\u9762\u4E0A\u9078\u64C7\u4E86\u932F\u8AA4\u7684\u5E33\u6236\uFF1F",
    "__stack-auto-translation-162": "\u7136\u5F8C\uFF0C\u8F38\u5165\u60A8\u7684\u516D\u4F4D\u6578MFA\u9A57\u8B49\u78BC\uFF1A",
    "__stack-auto-translation-163": "\u6B64\u5E33\u865F\u5DF2\u8207\u5176\u4ED6\u7528\u6236\u9023\u7D50\u3002\u8ACB\u9023\u7D50\u4E0D\u540C\u7684\u5E33\u865F\u3002",
    "__stack-auto-translation-164": "\u6B64\u96FB\u5B50\u90F5\u4EF6\u5DF2\u88AB\u53E6\u4E00\u4F4D\u4F7F\u7528\u8005\u7528\u65BC\u767B\u5165\u3002",
    "__stack-auto-translation-165": "\u9019\u662F\u4E00\u500B\u986F\u793A\u540D\u7A31\uFF0C\u4E0D\u7528\u65BC\u8EAB\u4EFD\u9A57\u8B49",
    "__stack-auto-translation-166": "\u9019\u5F88\u53EF\u80FD\u662F Stack \u7684\u932F\u8AA4\u3002\u8ACB\u56DE\u5831\u6B64\u554F\u984C\u3002",
    "__stack-auto-translation-167": "\u6B64\u5BC6\u78BC\u91CD\u7F6E\u9023\u7D50\u5DF2\u88AB\u4F7F\u7528\u3002\u5982\u679C\u60A8\u9700\u8981\u518D\u6B21\u91CD\u7F6E\u5BC6\u78BC\uFF0C\u8ACB\u5F9E\u767B\u5165\u9801\u9762\u91CD\u65B0\u7533\u8ACB\u65B0\u7684\u5BC6\u78BC\u91CD\u7F6E\u9023\u7D50\u3002",
    "__stack-auto-translation-168": "\u6B64\u5718\u968A\u9080\u8ACB\u9023\u7D50\u5DF2\u88AB\u4F7F\u7528\u3002",
    "__stack-auto-translation-169": "\u8ACB\u65B0\u589E\u5DF2\u9A57\u8B49\u7684\u767B\u5165\u96FB\u5B50\u90F5\u4EF6\u4EE5\u555F\u7528 OTP \u767B\u5165\u3002",
    "__stack-auto-translation-17": "\u5EFA\u7ACB\u5718\u968A",
    "__stack-auto-translation-170": "\u82E5\u8981\u555F\u7528\u901A\u884C\u91D1\u9470\u767B\u5165\uFF0C\u8ACB\u65B0\u589E\u5DF2\u9A57\u8B49\u7684\u767B\u5165\u96FB\u5B50\u90F5\u4EF6\u3002",
    "__stack-auto-translation-171": "\u8ACB\u65B0\u589E\u767B\u5165\u96FB\u5B50\u90F5\u4EF6\u4EE5\u8A2D\u5B9A\u5BC6\u78BC\u3002",
    "__stack-auto-translation-172": "\u5207\u63DB\u4E3B\u984C",
    "__stack-auto-translation-173": "TOTP \u591A\u56E0\u7D20\u9A57\u8B49 QR \u78BC",
    "__stack-auto-translation-174": "\u672A\u9A57\u8B49",
    "__stack-auto-translation-175": "\u66F4\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-176": "\u66F4\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-177": "\u66F4\u65B0\u60A8\u7684\u5BC6\u78BC",
    "__stack-auto-translation-178": "\u4E0A\u50B3\u60A8\u5718\u968A\u7684\u5716\u50CF",
    "__stack-auto-translation-179": "\u4E0A\u50B3\u60A8\u81EA\u5DF1\u7684\u5716\u50CF\u4F5C\u70BA\u982D\u50CF",
    "__stack-auto-translation-18": "\u76EE\u524D\u5718\u968A",
    "__stack-auto-translation-180": "\u7528\u65BC\u767B\u5165",
    "__stack-auto-translation-181": "\u7528\u65BC\u767B\u5165",
    "__stack-auto-translation-182": "\u5DF2\u4F7F\u7528\u7684\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50",
    "__stack-auto-translation-183": "\u5DF2\u4F7F\u7528\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50",
    "__stack-auto-translation-184": "\u4F7F\u7528\u8005",
    "__stack-auto-translation-185": "\u4F7F\u7528\u8005\u540D\u7A31",
    "__stack-auto-translation-186": "\u9A57\u8B49",
    "__stack-auto-translation-187": "\u60A8\u5DF2\u7D93\u767B\u5165",
    "__stack-auto-translation-188": "\u60A8\u76EE\u524D\u5C1A\u672A\u767B\u5165\u3002",
    "__stack-auto-translation-189": "\u60A8\u7121\u6CD5\u79FB\u9664\u6700\u5F8C\u4E00\u500B\u7528\u65BC\u767B\u5165\u7684\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-19": "\u5371\u96AA\u5340\u57DF",
    "__stack-auto-translation-190": "\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5DF2\u9A57\u8B49\uFF01",
    "__stack-auto-translation-191": "\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-192": "\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u9A57\u8B49\u9023\u7D50\u5DF2\u904E\u671F\u3002\u8ACB\u5F9E\u60A8\u7684\u5E33\u6236\u8A2D\u7F6E\u4E2D\u91CD\u65B0\u8ACB\u6C42\u65B0\u7684\u9A57\u8B49\u9023\u7D50\u3002",
    "__stack-auto-translation-193": "\u60A8\u7684\u9B54\u6CD5\u9023\u7D50\u5DF2\u904E\u671F\u3002\u5982\u679C\u60A8\u9700\u8981\u767B\u5165\uFF0C\u8ACB\u91CD\u65B0\u7533\u8ACB\u65B0\u7684\u9B54\u6CD5\u9023\u7D50\u3002",
    "__stack-auto-translation-194": "\u60A8\u7684\u5BC6\u78BC\u5DF2\u91CD\u8A2D\u3002\u60A8\u73FE\u5728\u53EF\u4EE5\u4F7F\u7528\u65B0\u5BC6\u78BC\u767B\u5165\u3002",
    "__stack-auto-translation-195": "\u60A8\u7684\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50\u5DF2\u904E\u671F\u3002\u8ACB\u5F9E\u767B\u5165\u9801\u9762\u91CD\u65B0\u7533\u8ACB\u65B0\u7684\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50\u3002",
    "__stack-auto-translation-196": "\u60A8\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50\u5DF2\u904E\u671F\u3002\u8ACB\u91CD\u65B0\u7533\u8ACB\u65B0\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50 ",
    "__stack-auto-translation-2": "\u65B0\u589E",
    "__stack-auto-translation-20": "\u522A\u9664\u5E33\u865F",
    "__stack-auto-translation-21": "\u522A\u9664\u5E33\u6236",
    "__stack-auto-translation-22": "\u522A\u9664\u901A\u884C\u91D1\u9470",
    "__stack-auto-translation-23": "\u505C\u7528",
    "__stack-auto-translation-24": "\u505C\u7528 MFA",
    "__stack-auto-translation-25": "\u505C\u7528 OTP",
    "__stack-auto-translation-26": "\u986F\u793A\u540D\u7A31",
    "__stack-auto-translation-27": "\u60A8\u8981\u767B\u5165\u55CE\uFF1F",
    "__stack-auto-translation-28": "\u60A8\u8981\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u55CE\uFF1F",
    "__stack-auto-translation-29": "\u9084\u6C92\u6709\u5E33\u6236\u55CE\uFF1F",
    "__stack-auto-translation-3": "\u65B0\u589E\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-30": "\u4E0D\u9700\u8981\u91CD\u8A2D\u5BC6\u78BC\u55CE\uFF1F",
    "__stack-auto-translation-31": "\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-32": "\u96FB\u90F5\u8207\u5BC6\u78BC",
    "__stack-auto-translation-33": "\u96FB\u5B50\u90F5\u4EF6\u5DF2\u5B58\u5728",
    "__stack-auto-translation-34": "\u96FB\u5B50\u90F5\u4EF6\u70BA\u5FC5\u586B",
    "__stack-auto-translation-35": "\u96FB\u5B50\u90F5\u4EF6\u5DF2\u767C\u9001\uFF01",
    "__stack-auto-translation-36": "\u96FB\u5B50\u90F5\u4EF6",
    "__stack-auto-translation-37": "\u96FB\u5B50\u90F5\u4EF6\u8207\u9A57\u8B49",
    "__stack-auto-translation-38": "\u555F\u7528\u591A\u91CD\u8981\u7D20\u8EAB\u4EFD\u9A57\u8B49",
    "__stack-auto-translation-39": "\u555F\u7528 OTP",
    "__stack-auto-translation-4": "\u65B0\u589E\u901A\u884C\u91D1\u9470",
    "__stack-auto-translation-40": "\u555F\u7528\u900F\u904E\u9B54\u6CD5\u9023\u7D50\u6216\u767C\u9001\u5230\u60A8\u7684\u767B\u5165\u96FB\u5B50\u90F5\u4EF6\u7684\u4E00\u6B21\u6027\u5BC6\u78BC\u9032\u884C\u767B\u5165\u3002",
    "__stack-auto-translation-41": "\u7D50\u675F\u60A8\u7684\u7576\u524D\u6703\u8A71",
    "__stack-auto-translation-42": "\u8F38\u5165\u60A8\u65B0\u5718\u968A\u7684\u986F\u793A\u540D\u7A31",
    "__stack-auto-translation-43": "\u8F38\u5165\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
    "__stack-auto-translation-44": "\u8F38\u5165\u60A8\u96FB\u5B50\u90F5\u4EF6\u4E2D\u7684\u9A57\u8B49\u78BC",
    "__stack-auto-translation-45": "\u5DF2\u904E\u671F\u7684\u9B54\u6CD5\u9023\u7D50",
    "__stack-auto-translation-46": "\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50\u5DF2\u904E\u671F",
    "__stack-auto-translation-47": "\u5DF2\u904E\u671F\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50",
    "__stack-auto-translation-48": "\u9A57\u8B49\u9023\u7D50\u5DF2\u904E\u671F",
    "__stack-auto-translation-49": "\u5230\u671F",
    "__stack-auto-translation-5": "\u5DF2\u7D93\u6709\u5E33\u865F\u4E86\u55CE\uFF1F",
    "__stack-auto-translation-50": "\u5E33\u6236\u9023\u63A5\u5931\u6557",
    "__stack-auto-translation-51": "\u91CD\u8A2D\u5BC6\u78BC\u5931\u6557",
    "__stack-auto-translation-52": "\u7121\u6CD5\u91CD\u8A2D\u5BC6\u78BC\u3002\u8ACB\u91CD\u65B0\u7533\u8ACB\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50",
    "__stack-auto-translation-53": "\u5FD8\u8A18\u5BC6\u78BC\uFF1F",
    "__stack-auto-translation-54": "\u56DE\u9996\u9801",
    "__stack-auto-translation-55": "\u56DE\u9996\u9801",
    "__stack-auto-translation-56": "\u5982\u679C\u6B64\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7684\u7528\u6236\u5B58\u5728\uFF0C\u4E00\u5C01\u96FB\u5B50\u90F5\u4EF6\u5DF2\u767C\u9001\u5230\u60A8\u7684\u6536\u4EF6\u7BB1\u3002\u8ACB\u52D9\u5FC5\u6AA2\u67E5\u60A8\u7684\u5783\u573E\u90F5\u4EF6\u8CC7\u6599\u593E\u3002",
    "__stack-auto-translation-57": "\u5982\u679C\u60A8\u6C92\u6709\u81EA\u52D5\u91CD\u65B0\u5C0E\u5411\uFF0C",
    "__stack-auto-translation-58": "\u5FFD\u7565",
    "__stack-auto-translation-59": "\u4EE3\u78BC\u4E0D\u6B63\u78BA\u3002\u8ACB\u518D\u8A66\u4E00\u6B21\u3002",
    "__stack-auto-translation-6": "\u767C\u751F\u672A\u77E5\u932F\u8AA4",
    "__stack-auto-translation-60": "\u5BC6\u78BC\u4E0D\u6B63\u78BA",
    "__stack-auto-translation-61": "\u9A57\u8B49\u78BC\u7121\u6548",
    "__stack-auto-translation-62": "\u7121\u6548\u7684\u5716\u7247",
    "__stack-auto-translation-63": "\u7121\u6548\u7684\u9B54\u8853\u9023\u7D50",
    "__stack-auto-translation-64": "\u7121\u6548\u7684\u5BC6\u78BC\u91CD\u8A2D\u9023\u7D50",
    "__stack-auto-translation-65": "\u7121\u6548\u7684\u5718\u968A\u9080\u8ACB\u9023\u7D50",
    "__stack-auto-translation-66": "\u7121\u6548\u7684 TOTP \u4EE3\u78BC",
    "__stack-auto-translation-67": "\u7121\u6548\u7684\u9A57\u8B49\u9023\u7D50",
    "__stack-auto-translation-68": "\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u9080\u8ACB\u7528\u6236\u52A0\u5165\u60A8\u7684\u5718\u968A",
    "__stack-auto-translation-69": "\u9080\u8ACB\u6210\u54E1",
    "__stack-auto-translation-7": "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u60A8\u7684\u5E33\u6236\u55CE\uFF1F\u6B64\u64CD\u4F5C\u662F\u4E0D\u53EF\u9006\u7684\uFF0C\u4E26\u5C07\u522A\u9664\u6240\u6709\u76F8\u95DC\u6578\u64DA\u3002",
    "__stack-auto-translation-70": "\u9080\u8ACB\u7528\u6236",
    "__stack-auto-translation-71": "\u52A0\u5165",
    "__stack-auto-translation-72": "\u96E2\u958B",
    "__stack-auto-translation-73": "\u96E2\u958B\u5718\u968A",
    "__stack-auto-translation-74": "\u96E2\u958B\u5718\u968A",
    "__stack-auto-translation-75": "\u96E2\u958B\u6B64\u5718\u968A\u4E26\u79FB\u9664\u60A8\u7684\u5718\u968A\u6A94\u6848",
    "__stack-auto-translation-76": "\u9B54\u6CD5\u9023\u7D50\u5DF2\u88AB\u4F7F\u7528",
    "__stack-auto-translation-77": "\u6210\u54E1",
    "__stack-auto-translation-78": "\u591A\u91CD\u8981\u7D20\u9A57\u8B49",
    "__stack-auto-translation-79": "\u76EE\u524D\u5DF2\u505C\u7528\u591A\u91CD\u8EAB\u4EFD\u9A57\u8B49\u3002",
    "__stack-auto-translation-8": "\u60A8\u78BA\u5B9A\u8981\u505C\u7528 OTP \u767B\u5165\u55CE\uFF1F\u60A8\u5C07\u7121\u6CD5\u518D\u50C5\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u9032\u884C\u767B\u5165\u3002",
    "__stack-auto-translation-80": "\u76EE\u524D\u5DF2\u555F\u7528\u591A\u91CD\u8EAB\u5206\u9A57\u8B49\u3002",
    "__stack-auto-translation-81": "\u6211\u7684\u500B\u4EBA\u8CC7\u6599",
    "__stack-auto-translation-82": "\u540D\u7A31",
    "__stack-auto-translation-83": "\u4E0D\u5141\u8A31\u8A3B\u518A\u65B0\u5E33\u6236",
    "__stack-auto-translation-84": "\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-85": "\u65B0\u5BC6\u78BC",
    "__stack-auto-translation-86": "\u672A\u555F\u7528\u4EFB\u4F55\u8EAB\u4EFD\u9A57\u8B49\u65B9\u6CD5\u3002",
    "__stack-auto-translation-87": "\u5C1A\u7121\u5718\u968A",
    "__stack-auto-translation-88": "\u672A\u767B\u5165",
    "__stack-auto-translation-89": "OAuth \u63D0\u4F9B\u8005\u5B58\u53D6\u906D\u62D2",
    "__stack-auto-translation-9": "\u60A8\u78BA\u5B9A\u8981\u505C\u7528\u901A\u884C\u91D1\u9470\u767B\u5165\u55CE\uFF1F\u505C\u7528\u5F8C\u60A8\u5C07\u7121\u6CD5\u518D\u4F7F\u7528\u901A\u884C\u91D1\u9470\u767B\u5165\u3002",
    "__stack-auto-translation-90": "\u820A\u5BC6\u78BC",
    "__stack-auto-translation-91": "\u6216\u7E7C\u7E8C\u4F7F\u7528",
    "__stack-auto-translation-92": "\u5176\u4ED6\u5718\u968A",
    "__stack-auto-translation-93": "OTP \u767B\u5165",
    "__stack-auto-translation-94": "\u5DF2\u555F\u7528 OTP \u767B\u5165\uFF0C\u76EE\u524D\u7121\u6CD5\u505C\u7528\uFF0C\u56E0\u70BA\u9019\u662F\u552F\u4E00\u7684\u767B\u5165\u65B9\u5F0F",
    "__stack-auto-translation-95": "\u76EE\u524D\u5DF2\u555F\u7528 OTP/\u9B54\u6CD5\u9023\u7D50\u767B\u5165\u3002",
    "__stack-auto-translation-96": "\u5F85\u8655\u7406\u9080\u8ACB",
    "__stack-auto-translation-97": "\u8986\u5BEB\u60A8\u5728\u6B64\u5718\u968A\u4E2D\u7684\u4F7F\u7528\u8005\u986F\u793A\u540D\u7A31",
    "__stack-auto-translation-98": "\u901A\u884C\u91D1\u9470",
    "__stack-auto-translation-99": "\u901A\u884C\u91D1\u9470\u5DF2\u8A3B\u518A"
  }))
}));
export {
  quetzalKeys,
  quetzalLocales
};
//# sourceMappingURL=quetzal-translations.js.map